(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio
   * @description
   *
   */
  angular
    .module('itecAdministracio', [
      'ui.router',
      'itecApi',
      'itecAdministracio.api',
      'itecAdministracio.shared',
      'itecLocale',
      'itecGuicomponents.layout',
      'itecGuicomponents.commonControls',
      'itecGuicomponents.calendar',
      'ngDraggable',
      'ngCookies',
      'ngFileSaver',
      'itecAdministracio.usuaris',
      'itecAdministracio.entitats',
      'itecAdministracio.rols',
      'itecAdministracio.productes'
    ])
    .config(["$translatePartialLoaderProvider", "$urlRouterProvider", "$httpProvider", function($translatePartialLoaderProvider, $urlRouterProvider, $httpProvider) {
       $httpProvider.defaults.useXDomain = true;

      $translatePartialLoaderProvider.addPart('resources');
      $translatePartialLoaderProvider.addPart('vendor/itec-guicomponents/dist/resources/common-controls/resources');
   }])
   .config(["$httpProvider", function($httpProvider) {
      $httpProvider.interceptors.push('LocaleInterceptorFactory');
   }])
	 .run(["$rootScope", "LocalStorage", "DataFactory", "ApiLayoutConstant", "SessionStorage", "PermisosFactory", "LocaleService", "AdmConstant", function($rootScope, LocalStorage, DataFactory, ApiLayoutConstant, SessionStorage, PermisosFactory, LocaleService, AdmConstant) {

      //Configuració per itec-guicomponents
      LocalStorage.setBasePath('itecAdministracio');
      SessionStorage.setBasePath('itecAdministracio');
      $rootScope.prefixItecGuicomponents = 'vendor/itec-guicomponents/dist/';

      DataFactory.setApiParameters('security', ApiLayoutConstant.SERVER_VERSION_ADMINISTRACIO, 'authsecurity','');
      PermisosFactory.setApiParameters(AdmConstant.SERVER_PATH_ADMINISTRACIO + 'permisos', 'pagenotfound');

      //Pedimos permisos (y creamos sesion y desbloqueamos la api)
      PermisosFactory.load().then(function(response){
        $rootScope.permisos = response.data.permisos;
        $rootScope.usuari = response.data.usuari;
        $rootScope.issuperadmin = response.data.issuperadmin;
      }).catch(function(error){
        console.log(error);
        $state.go(errorState);
      }).finally(function(){
        DataFactory.unblockApi();
        AppFactory.setExistsSession(true);
      });

      DataFactory.blockApi();
    }]);
}());

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/main/llicencies/formulari/formulari.tpl.html',
    '<div   ng-cloak>\n' +
    '      <itec-form\n' +
    '        name="ctrl.formulari.nom"\n' +
    '        fields="ctrl.formulari.camps"\n' +
    '        ng-model="ctrl.llicencia"\n' +
    '        ng-submit-function="ctrl.formulari.func()"\n' +
    '        errors="ctrl.errors"\n' +
    '        backbutton="true"\n' +
    '        backbuttonfunction="ctrl.back()">\n' +
    '          <div transclude-to="additional-form">\n' +
    '            <div ng-if="ctrl.aplicacions.length>0"\n' +
    '              id="aplicacions"\n' +
    '              class="tcqi--margin-top-20 tcqi--margin-bottom-30">\n' +
    '                <table class="itec-table">\n' +
    '                    <thead>\n' +
    '                      <tr>\n' +
    '                        <th>{{\'DEFAULT_NOM\' | translate}}</th>\n' +
    '                        <th>{{\'DEFAULT_TYK\' | translate}}</th>\n' +
    '                      </tr>\n' +
    '                    </thead>\n' +
    '                    <tbody>\n' +
    '                      <tr ng-repeat="aplicacio in ctrl.aplicacions">\n' +
    '                        <td>\n' +
    '                          <div ng-repeat="nom in aplicacio.noms">{{nom}}</div>\n' +
    '                        </td>\n' +
    '                        <td ng-if="aplicacio.esitec">\n' +
    '                          <form>\n' +
    '                            <itec-select\n' +
    '                               class="mdl-cell mdl-cell--12-col"\n' +
    '                               property-id="id"\n' +
    '                               property-label="urltyk"\n' +
    '                               list="ctrl.listtyksitec"\n' +
    '                               name="tyk"\n' +
    '                               ng-model="aplicacio.tyk"\n' +
    '                               ng-disabled="true">\n' +
    '                             </itec-simple-list>\n' +
    '                           </form>\n' +
    '                        </td>\n' +
    '                        <td ng-if="!aplicacio.esitec">\n' +
    '                          <form>\n' +
    '                          <itec-select\n' +
    '                             class="mdl-cell mdl-cell--12-col"\n' +
    '                             property-id="id"\n' +
    '                             property-label="urltyk"\n' +
    '                             list="ctrl.listtyks"\n' +
    '                             name="tyk"\n' +
    '                             ng-model="aplicacio.tyk"\n' +
    '                             ng-disabled="true">\n' +
    '                           </itec-simple-list>\n' +
    '                         </form>\n' +
    '                        </td>\n' +
    '                      </tr>\n' +
    '\n' +
    '                    </tbody>\n' +
    '                  </table>\n' +
    '              <div>\n' +
    '          </div>\n' +
    '      </itec-form>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('usuaris/main/llista/llista.tpl.html',
    '\n' +
    '  <div class="mnt-content mdl-grid mdl-grid--no-spacing">\n' +
    '    <div class="mdl-cell mdl-cell--12-col ">\n' +
    '       <itec-form\n' +
    '            name="ctrl.formulari.nom"\n' +
    '            fields="ctrl.formulari.camps"\n' +
    '            ng-model="ctrl.cercaObj"\n' +
    '            ng-submit-function="ctrl.formulari.func()"\n' +
    '            errors="ctrl.errors"\n' +
    '            submit-button-text="DEFAULT_CERCAR"\n' +
    '            backbutton="false"\n' +
    '            submit-button-dynamic="false">\n' +
    '          </itec-form>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '    <div class="tcqi--padding-right-5 tcqi--padding-left-5 tcqi--padding-top-10 tcqi--padding-bottom-5">\n' +
    '      <div class="circle-ok"></div> {{::\'USUARI_CONFIRMAT_TITOL\' | translate}}\n' +
    '      <div class="circle-vermell"></div>&nbsp;{{\'USUARI_NO_REGISTRAT_HEADER\' | translate}}\n' +
    '      <div class="circle-groc"></div>&nbsp;{{\'USUARI_NO_CONFIRMAT_HEADER\' | translate}}  </div>\n' +
    '    <itec-simple-list\n' +
    '      class="mdl-cell mdl-cell--12-col"\n' +
    '      items="ctrl.llista"\n' +
    '      fields="ctrl.fields"\n' +
    '      show-edit-button="$root.permisos.ACTUALITZARUSUARI.edit"\n' +
    '      show-delete-button="$root.permisos.ESBORRARUSUARI.delete"\n' +
    '      show-add-button="false"\n' +
    '      itec-dialog-confirm-title="DEFAULT_TITOL_CONFIRMACIO_ESBORRAR"\n' +
    '      itec-dialog-confirm-text-content="USUARI_DELETE_CONTENT"\n' +
    '      itec-infinite-scroll-function="ctrl.load"\n' +
    '      threshold="100"\n' +
    '      can-load="ctrl.canLoad"\n' +
    '      delete-function="ctrl.deleteUsuari"\n' +
    '      click-function="ctrl.view"\n' +
    '      all-row-clickable="true"\n' +
    '      edit-function="ctrl.edit"\n' +
    '      id-selected="$stateParams.idUsuari"\n' +
    '      formatter-function="ctrl.formatter">\n' +
    '    </itec-simple-list>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('usuaris/main/dades/dades.tpl.html',
    '<div  class="usuaris-content">\n' +
    '  <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '    <h5 class="mdl-layout-title mdl-cell--8-col">\n' +
    '      {{\'DEFAULT_USUARI\' | translate}}\n' +
    '      	<span ng-if ="ctrl.usuari.confirmat && !ctrl.usuari.deleted" >{{\'USUARI_CONFIRMAT_HEADER\' | translate}}	</span>\n' +
    '		<span ng-if ="(ctrl.usuari.deleted || ctrl.usuari.fictici)" class="color-vermell">{{\'USUARI_NO_REGISTRAT_HEADER\' | translate}}</span>\n' +
    '        <span ng-if ="(!ctrl.usuari.deleted && !ctrl.usuari.fictici && !ctrl.usuari.confirmat)" class="color-groc">\n' +
    '        {{\'USUARI_NO_CONFIRMAT_HEADER\' | translate}}</span>\n' +
    '</h5>\n' +
    '    <div class="mdl-cell mdl-cell--4-col">\n' +
    '      <div class="itec-float-right">\n' +
    '	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"\n' +
    '						ng-if="$root.permisos.ESBORRARUSUARI.delete"\n' +
    '	          itec-dialog-confirm\n' +
    '	          itec-dialog-confirm-title="{{\'DEFAULT_TITOL_CONFIRMACIO_ESBORRAR\' | translate}}"\n' +
    '	          itec-dialog-confirm-text-content="{{\'USUARI_DELETE_CONTENT\' | translate}}"\n' +
    '	          itec-dialog-confirm-text-ok="DIALOG_CONFIRM"\n' +
    '	          itec-dialog-confirm-text-cancel="DIALOG_CANCEL"\n' +
    '	          itec-dialog-confirm-function-ok="ctrl.deleteElem()">\n' +
    '	        <i class="material-icons">delete</i>\n' +
    '	      </button>\n' +
    '	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"\n' +
    '								ng-if="$root.permisos.ACTUALITZARUSUARI.edit"\n' +
    '								ng-click="ctrl.changeToForm()">\n' +
    '	        <i class="material-icons">edit</i>\n' +
    '	      </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '   <div class="mdl-cell--12-col">\n' +
    '      <md-card>\n' +
    '        <md-card-content>\n' +
    '          <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '				<div class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'DEFAULT_USERNAME\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div class="mdl-cell mdl-cell--10-col">\n' +
    ' 					<span class="bold {{(ctrl.usuari.deleted || ctrl.usuari.fictici) ? \'color-vermell\' : \'\'}}\n' +
    '                     {{(!ctrl.usuari.deleted && !ctrl.usuari.fictici && !ctrl.usuari.confirmat) ? \'color-groc\' : \'\'}} ">\n' +
    '                    {{ctrl.usuari.username}}\n' +
    '                \n' +
    '                	</span>\n' +
    '	            </div>\n' +
    '	            <div class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'DEFAULT_NOM\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div class="mdl-cell mdl-cell--10-col">\n' +
    '	              <span class="bold">{{ctrl.usuari.nom}}</span>\n' +
    '	            </div>\n' +
    '\n' +
    '	            <div class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'DEFAULT_COGNOM\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div class="mdl-cell mdl-cell--10-col">\n' +
    '	              <span class="bold">{{ctrl.usuari.cognom}}</span>\n' +
    '	            </div>\n' +
    '				<div class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'DEFAULT_IDIOMA\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="ctrl.usuari.idioma==0"  class="mdl-cell mdl-cell--10-col">\n' +
    '	              <span class="bold">{{\'DEFAULT_CATALA\' | translate}}</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="ctrl.usuari.idioma==1"  class="mdl-cell mdl-cell--10-col">\n' +
    '	              <span class="bold">{{\'DEFAULT_ESPANYOL\' | translate}}</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="ctrl.usuari.idioma==2"  class="mdl-cell mdl-cell--10-col">\n' +
    '	              <span class="bold">{{\'DEFAULT_ANGLES\' | translate}}</span>\n' +
    '	            </div>\n' +
    '	            <div class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'USUARI_INFOITEC\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div  class="mdl-cell mdl-cell--10-col">\n' +
    '	              <span  ng-if="ctrl.usuari.infoitec" class="bold">{{\'DEFAULT_SI\' | translate}}</span>\n' +
    '	              <span  ng-if="ctrl.usuari.infoitec==false" class="bold">{{\'DEFAULT_NO\' | translate}}</span>\n' +
    '	            </div>\n' +
    '				<div class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'DEFAULT_DATA_ACCES\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div class="mdl-cell mdl-cell--10-col">\n' +
    '	              <span class="bold">{{ctrl.usuari.accesdata}}</span>\n' +
    '	            </div>\n' +
    '\n' +
    '	            <div class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'DEFAULT_IP_ACCES\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '\n' +
    '	            <div class="mdl-cell mdl-cell--10-col">\n' +
    '	              <span class="bold">{{ctrl.usuari.accesip}}</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'DEFAULT_BLOQUEJAT\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div class="mdl-cell mdl-cell--10-col" ng-if="$root.issuperadmin">\n' +
    '	              <span  ng-if="ctrl.usuari.bloquejat" class="bold">{{\'DEFAULT_SI\' | translate}}\n' +
    '  					<button\n' +
    '			            <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"\n' +
    '			            ng-if="$root.issuperadmin"\n' +
    '			            ng-click="ctrl.unlock()"\n' +
    '			            ng-disabled= "!ctrl.usuari.bloquejat">\n' +
    '  	                    <i class="icon-check"></i>\n' +
    '			        </button>\n' +
    '	              </span>\n' +
    '	              <span  ng-if="ctrl.usuari.bloquejat==false" class="bold">{{\'DEFAULT_NO\' | translate}}</span>\n' +
    '	            </div>\n' +
    ' 				<div ng-if="ctrl.usuari.deleted==true"  class="mdl-cell mdl-cell--12-col">\n' +
    '              		<span class="bold">{{\'USUARI_BAIXA\' | translate}}</span>\n' +
    '            	</div>\n' +
    '\n' +
    '	            <div ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'USUARI_REGISTRE\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="ctrl.usuari.fictici==false && ctrl.usuari.deleted==false"  class="mdl-cell mdl-cell--10-col">\n' +
    '              		<span class="bold">{{\'USUARI_REGISTRAT\' | translate}}</span>\n' +
    '            	</div>\n' +
    '            	<div ng-if="ctrl.usuari.fictici==true  && ctrl.usuari.deleted==false"  class="mdl-cell mdl-cell--10-col">\n' +
    '              		<span class="bold">{{\'USUARI_NO_REGISTRAT\' | translate}}</span>\n' +
    '            	</div>\n' +
    '\n' +
    '\n' +
    '	            <div ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'USUARI_CONFIRMACIO\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="ctrl.usuari.confirmat==true && ctrl.usuari.deleted==false"   class="mdl-cell mdl-cell--10-col">\n' +
    '              		<span class="bold">{{\'USUARI_CONFIRMAT\' | translate}}</span>\n' +
    '            	</div>\n' +
    '            	<div ng-if="ctrl.usuari.confirmat==false && ctrl.usuari.deleted==false"  class="mdl-cell mdl-cell--10-col">\n' +
    '              		<span class="bold">{{\'USUARI_NO_CONFIRMAT\' | translate}}</span>\n' +
    '            	</div>\n' +
    '				<div  ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'DEFAULT_ENTITATS\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '\n' +
    ' 				<div ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--10-col">\n' +
    '	              <span ng-repeat="entitat in ctrl.usuari.entitats" class="bold">\n' +
    '    				<a class="itec-link bold" ng-single-click="ctrl.viewProductesEntitat({{entitat.id}});">\n' +
    '	              	{{entitat.nom}} </a>&nbsp;\n' +
    '	              	<!-- <br/>   -->\n' +
    '	              </span>\n' +
    '	            </div>\n' +
    '\n' +
    '  				<div  ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{\'USUARI_PRODUCTES\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '\n' +
    '   				<div ng-if="ctrl.usuari.deleted==false" class="mdl-cell mdl-cell--10-col">\n' +
    '   					<span ng-repeat="entitatrol in ctrl.usuari.entitatrols" class="bold">\n' +
    '					  <span ng-if="$root.issuperadmin" class="bold"> {{entitatrol.nomentitat}}<br></span>\n' +
    '  	              	  <span ng-if="!$root.issuperadmin" ng-repeat="rol in entitatrol.rols">\n' +
    '  	              	  	<span ng-if ="!rol.liccaducada">{{rol.nom}}<br/></span>\n' +
    '  	              	  </span>\n' +
    '  	              	  <span ng-if="$root.issuperadmin" ng-repeat="rol in entitatrol.rols" class="tcqi--margin-left-20">   		\n' +
    '  	              	  	<span class ="{{(rol.liccaducada) ? \'color-vermell\' : \'\' }}">{{rol.nom}}</span>\n' +
    '	                      <span ng-if="$root.issuperadmin && rol.caducitat!=null" >- {{\'DEFAULT_DATA_CADUCITAT\' | translate}}: {{rol.caducitat | date:\'dd/MM/yyyy\'}}</span>\n' +
    '	                      <br>\n' +
    '	                      <span ng-if="$root.issuperadmin && rol.tokenDemoModel!=null" > \n' +
    '\n' +
    '	                      	<span ng-repeat="token in rol.tokenDemoModel">\n' +
    '		                      	{{\'tipusclient_\' + token.tipusclient | translate}}:   	{{\'DEFAULT_DATA_RENOVACIO\' | translate}}: \n' +
    '		                      	<span ng-if="token.datarenovacio!=null">{{token.datarenovacio | date:\'dd/MM/yyyy\'}}</span>\n' +
    '														<span ng-if="token.datarenovacio==null">No utilitzat</span>\n' +
    '		                      			 - Consultes gratuites {{token.numdemos}} - consumides {{token.numdemos-token.numdemosrestants}} - disponibles {{token.numdemosrestants}} \n' +
    '\n' +
    '												        <button ng-if="$root.permisos.ACTUALITZARUSUARI.edit"\n' +
    '\n' +
    '												            <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"\n' +
    '												            ng-if="$root.issuperadmin"\n' +
    '												            ng-click="ctrl.renew(token.idproducte,token.tipusclient,token.versio)"\n' +
    '												            ng-disabled= "token.datarenovacio==null">\n' +
    '												          <i class="icon-repeat-redo"></i>\n' +
    '												        </button>\n' +
    '												        <br>\n' +
    '												  </span>\n' +
    '									      </span>\n' +
    '                  </span>\n' +
    '              	</span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="horizontal_separator"></div>\n' +
    '        </md-card-content>\n' +
    '      </md-card>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('usuaris/main/edit/edit.tpl.html',
    '<div id="usuari-form" ng-cloak>\n' +
    '  <span class="{{ctrl.colorestat}}">{{ctrl.estatusuari}}</span>\n' +
    '      <itec-form\n' +
    '      	name="ctrl.formulari.nom"\n' +
    '      	fields="ctrl.formulari.camps"\n' +
    '      	ng-model="ctrl.usuari"\n' +
    '      	ng-submit-function="ctrl.formulari.func()"\n' +
    '      	errors="ctrl.errors"\n' +
    '        submit-button-text="DEFAULT_GUARDAR"\n' +
    '        backbutton="true"\n' +
    '        backbuttonfunction="ctrl.back()"\n' +
    '        >\n' +
    '\n' +
    '\n' +
    '\n' +
    '         <itec-transclude transclude-to="notificar-registre-button" >\n' +
    '          <div ng-if="ctrl.usuari.deleted==false" >\n' +
    '            <div>\n' +
    '                  <span>{{\'USUARI_REGISTRE\' | translate}}:</span>\n' +
    '            </div>\n' +
    '            <div ng-if="ctrl.usuari.fictici==false" >\n' +
    '                  <span class="bold">{{\'USUARI_REGISTRAT\' | translate}}</span>\n' +
    '            </div>\n' +
    '            <div ng-if="ctrl.usuari.fictici==true"  >\n' +
    '                  <span class="bold">{{\'USUARI_NO_REGISTRAT\' | translate}}</span>\n' +
    '                  <itec-button  label="{{\'USUARI_NOTIFICAR_REGISTRE\' | translate}}"\n' +
    '                                ng-click-function="ctrl.notificarregistre()">\n' +
    '                  </itec-button >\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </itec-transclude>\n' +
    '\n' +
    '\n' +
    '         <itec-transclude transclude-to="notificar-confirmar-button">\n' +
    '         <div ng-if="ctrl.usuari.deleted==false" >\n' +
    '              <div >\n' +
    '                <span>{{\'USUARI_CONFIRMACIO\' | translate}}:</span>\n' +
    '              </div>\n' +
    '              <div ng-if="ctrl.usuari.confirmat==true"  >\n' +
    '                  <span class="bold">{{\'USUARI_CONFIRMAT\' | translate}}</span>\n' +
    '              </div>\n' +
    '               <div ng-if="ctrl.usuari.confirmat==false && ctrl.usuari.fictici==true" >\n' +
    '                  <span class="bold">{{\'USUARI_NO_CONFIRMAT\' | translate}}</span>\n' +
    '              </div>\n' +
    '              <div ng-if="ctrl.usuari.confirmat==false && ctrl.usuari.fictici==false" >\n' +
    '                  <span class="bold">{{\'USUARI_NO_CONFIRMAT\' | translate}}</span>\n' +
    '                  <itec-button  label="{{\'USUARI_NOTIFICAR_CONFIRMAR\' | translate}}"\n' +
    '                                ng-click-function="ctrl.notificarconfirmar()">\n' +
    '                  </itec-button >\n' +
    '              </div>\n' +
    '          </div>\n' +
    '        </itec-transclude>\n' +
    '\n' +
    '        <itec-transclude  transclude-to="notificar-deleted-button">\n' +
    '           <div ng-if="ctrl.usuari.deleted==true">\n' +
    '                  <span class="bold">{{\'USUARI_BAIXA\' | translate}}</span>\n' +
    '                  <itec-button  label="{{\'USUARI_NOTIFICAR_REGISTRE\' | translate}}"\n' +
    '                                ng-click-function="ctrl.notificarregistre()">\n' +
    '                  </itec-button >\n' +
    '           </div>\n' +
    '        </itec-transclude>\n' +
    '\n' +
    '\n' +
    '      </itec-form>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('rols/main/permisos/permisos.tpl.html',
    '\n' +
    '<div id="rol-form" ng-cloak  class="mdl-cell mdl-cell--12-col">\n' +
    '          <itec-button ng-show="::!ctrl.rol.inicial && $root.permisos.ACTUALITZARROL.edit" label="{{::\'DEFAULT_GUARDAR\' | translate}}"\n' +
    '                        ng-click-function="ctrl.func()">\n' +
    '          </itec-button>\n' +
    '          <itec-button  label="{{::\'DEFAULT_TORNAR\' | translate}}"\n' +
    '                        ng-click-function="ctrl.back()">\n' +
    '          </itec-button>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<itec-tree      items="ctrl.rootTreeNodeCollection"\n' +
    '                expanded-collection="ctrl.expandedCollection"\n' +
    '                children="ctrl.loadChildren(object)"\n' +
    '                tree-tracking="ctrl.treeTracking"\n' +
    '                show-node="ctrl.filterNode"\n' +
    '                selected="ctrl.selected"\n' +
    '                order-by="order"\n' +
    '                expand-in-all-row="false"\n' +
    '                item-name="object">\n' +
    '\n' +
    '    <div  class="mdl-grid mdl-grid--no-spacing">\n' +
    '        <div class="mdl-cell mdl-cell--12-col">\n' +
    '            <span ng-if="::object.type === \'tema\'">\n' +
    '                <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '                    <div class="mdl-cell mdl-cell--4-col">\n' +
    '                    <span>{{::object.messageKey | translate}}</span>\n' +
    '                    </div>\n' +
    '                    <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="read"\n' +
    '                            ng-model="object.read"\n' +
    '                            ng-change-function="ctrl.onChangeReadTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_VEURE\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '                     <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="add"\n' +
    '                            ng-model="object.add"\n' +
    '                            ng-change-function="ctrl.onChangeAddTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_AFEGIR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '                     <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="edit"\n' +
    '                            ng-model="object.edit"\n' +
    '                            ng-change-function="ctrl.onChangeEditTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_EDITAR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '                     <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="delete"\n' +
    '                            ng-model="object.delete"\n' +
    '                            ng-change-function="ctrl.onChangeDeleteTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_ESBORRAR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </span>\n' +
    '            <span ng-if="::object.type === \'vista\'">\n' +
    '                <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '                    <div  class="mdl-cell mdl-cell--4-col">\n' +
    '                        <span>{{::"administracio.producte.vistes." + object.nom | translate}}</span>\n' +
    '                    </div>\n' +
    '                    <div  class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox  ng-if="::object.permetread"\n' +
    '                            name="read"\n' +
    '                            ng-model="object.read"\n' +
    '                            label="{{::\'DEFAULT_VEURE\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '                     <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox ng-if="::object.permetadd"\n' +
    '                            name="add"\n' +
    '                            ng-model="object.add"\n' +
    '                            label="{{::\'DEFAULT_AFEGIR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '                     <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox  ng-if="::object.permetedit"\n' +
    '                            name="edit"\n' +
    '                            ng-model="object.edit"\n' +
    '                            label="{{::\'DEFAULT_EDITAR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '                     <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox  ng-if="::object.permetdelete"\n' +
    '                            name="delete"\n' +
    '                            ng-model="object.delete"\n' +
    '                            label="{{::\'DEFAULT_ESBORRAR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </span>\n' +
    '\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</itec-tree>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('rols/main/edit/edit.tpl.html',
    '<div id="rol-form" ng-cloak>\n' +
    '\n' +
    '      <itec-form \n' +
    '      	name="ctrl.formulari.nom"\n' +
    '      	fields="ctrl.formulari.camps"\n' +
    '      	ng-model="ctrl.rol"\n' +
    '      	ng-submit-function="ctrl.formulari.func()"\n' +
    '      	errors="ctrl.errors"\n' +
    '        submit-button-text="DEFAULT_GUARDAR"\n' +
    '        backbutton="true"\n' +
    '        backbuttonfunction="ctrl.back()"\n' +
    '        >\n' +
    '\n' +
    '        \n' +
    '      </itec-form>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('rols/main/llista/llista.tpl.html',
    '<div class="mnt-content mdl-grid mdl-grid--no-spacing">\n' +
    '  <div class="mdl-cell mdl-cell--12-col">\n' +
    '\n' +
    '        <itec-form\n' +
    '            name="ctrl.formulari.nom"\n' +
    '            fields="ctrl.formulari.camps"\n' +
    '            ng-model="ctrl.cercaObj"\n' +
    '            ng-submit-function="ctrl.formulari.func()"\n' +
    '            errors="ctrl.errors"\n' +
    '            submit-button-text="DEFAULT_CERCAR"\n' +
    '            backbutton="false"\n' +
    '            submit-button-dynamic="false">\n' +
    '          </itec-form>\n' +
    '  </div>\n' +
    '  <div class="mdl-cell mdl-cell--12-col">\n' +
    '    <md-card>\n' +
    '      <md-card-content>\n' +
    '        <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '\n' +
    '          <itec-simple-list\n' +
    '            class="mdl-cell mdl-cell--12-col"\n' +
    '            items="ctrl.llista"\n' +
    '            fields="ctrl.fields"\n' +
    '            show-edit-button="::$root.permisos.ACTUALITZARROL.edit"\n' +
    '            show-delete-button="::$root.permisos.ESBORRARROL.delete"\n' +
    '            show-edit-button="true"\n' +
    '            show-delete-button="true"\n' +
    '            show-add-button="false"\n' +
    '            show-clone-button="::$root.permisos.AFEGIRROL.add"\n' +
    '            itec-dialog-confirm-title="DEFAULT_TITOL_CONFIRMACIO_ESBORRAR"\n' +
    '            itec-dialog-confirm-text-content="ROL_DELETE_CONTENT"\n' +
    '            itec-infinite-scroll-function="ctrl.load"\n' +
    '            threshold="100"\n' +
    '            can-load="ctrl.canLoad"\n' +
    '            delete-function="ctrl.deleteRols"\n' +
    '            click-function="ctrl.view"\n' +
    '            all-row-clickable="true"\n' +
    '            clone-function="ctrl.duplicate"\n' +
    '            edit-function="ctrl.edit"\n' +
    '            id-selected="$stateParams.idRol"\n' +
    '            formatter-function="ctrl.formatter">\n' +
    '          </itec-simple-list>\n' +
    '        </div>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('rols/main/dades/dades.tpl.html',
    '<div  class="usuaris-content">\n' +
    '  <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '    <h5 class="mdl-layout-title mdl-cell--8-col">\n' +
    '      {{::\'DEFAULT_ROL\' | translate}}\n' +
    '    </h5>\n' +
    '    <div class="mdl-cell mdl-cell--4-col">\n' +
    '      <div class="itec-float-right">\n' +
    '	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"\n' +
    '					 	ng-if="::$root.permisos.ESBORRARROL.delete"\n' +
    '	          itec-dialog-confirm\n' +
    '	          itec-dialog-confirm-title="{{::\'DEFAULT_TITOL_CONFIRMACIO_ESBORRAR\' | translate}}"\n' +
    '	          itec-dialog-confirm-text-content="{{::\'ROL_DELETE_CONTENT\' | translate}}"\n' +
    '	          itec-dialog-confirm-text-ok="DIALOG_CONFIRM"\n' +
    '	          itec-dialog-confirm-text-cancel="DIALOG_CANCEL"\n' +
    '	          itec-dialog-confirm-function-ok="ctrl.deleteElem()">\n' +
    '	        <i class="material-icons">delete</i>\n' +
    '	      </button>\n' +
    '	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"\n' +
    '								ng-if="::$root.permisos.ACTUALITZARROL.edit"\n' +
    '								ng-click="ctrl.changeToForm()">\n' +
    '	        <i class="material-icons">edit</i>\n' +
    '	      </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '   <div class="mdl-cell--12-col">\n' +
    '      <md-card>\n' +
    '        <md-card-content>\n' +
    '          <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '	            <div class="mdl-cell mdl-cell--3-col">\n' +
    '	              <span>{{::\'DEFAULT_NOM\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div class="mdl-cell mdl-cell--9-col">\n' +
    '	              <span class="bold">{{::ctrl.rol.nom}}</span>\n' +
    '	            </div>\n' +
    '\n' +
    '	            <div class="mdl-cell mdl-cell--3-col">\n' +
    '	              <span>{{::\'DEFAULT_ENTITAT\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div class="mdl-cell mdl-cell--9-col">\n' +
    '	              <span class="bold">{{::ctrl.rol.entitat[0].nom}}</span>\n' +
    '	            </div>\n' +
    '	            <div class="mdl-cell mdl-cell--3-col">\n' +
    '	              <span>{{::\'DEFAULT_PRODUCTE\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div class="mdl-cell mdl-cell--9-col">\n' +
    '	              <span class="bold">{{::ctrl.rol.producte[0].nom}}</span>\n' +
    '	            </div>\n' +
    '\n' +
    '				<div class="mdl-cell mdl-cell--3-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span>{{::\'DEFAULT_ADMINISTRADOR\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="::ctrl.rol.administrador===true"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span class="bold">{{::\'DEFAULT_SI\' | translate}}</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="::ctrl.rol.administrador===false"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span class="bold">{{::\'DEFAULT_NO\' | translate}}</span>\n' +
    '	            </div>\n' +
    '\n' +
    '				<div class="mdl-cell mdl-cell--3-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span>{{::\'ROL_ES_POT_ELIMINAR\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="::ctrl.rol.eliminar===true"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span class="bold">{{::\'DEFAULT_SI\' | translate}}</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="::ctrl.rol.eliminar===false"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span class="bold">{{::\'DEFAULT_NO\' | translate}}</span>\n' +
    '	            </div>\n' +
    '\n' +
    '\n' +
    '				<div class="mdl-cell mdl-cell--3-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span>{{::\'ROL_INICIAL\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="::ctrl.rol.inicial===true"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span class="bold">{{::\'DEFAULT_SI\' | translate}}</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="::ctrl.rol.inicial===false"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span class="bold">{{::\'DEFAULT_NO\' | translate}}</span>\n' +
    '	            </div>\n' +
    '\n' +
    '\n' +
    '	            <div class="mdl-cell mdl-cell--3-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span>{{::\'ROL_VISIBLEALL\' | translate}}:</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="::ctrl.rol.visibleall===true"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span class="bold">{{::\'DEFAULT_SI\' | translate}}</span>\n' +
    '	            </div>\n' +
    '	            <div ng-if="::ctrl.rol.visibleall===false"  class="mdl-cell mdl-cell--9-col" ng-show="::ctrl.issuperadmin">\n' +
    '	              <span class="bold">{{::\'DEFAULT_NO\' | translate}}</span>\n' +
    '	            </div>\n' +
    '\n' +
    '            </div>\n' +
    '          <div class="horizontal_separator"></div>\n' +
    '        </md-card-content>\n' +
    '      </md-card>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('productes/main/permisos/permisos.tpl.html',
    '\n' +
    '<div id="producte-form" ng-cloak  class="mdl-cell mdl-cell--12-col">\n' +
    '          <itec-button  label="{{::\'DEFAULT_ACTUALITZAR_ROLS\' | translate}}"\n' +
    '                        ng-click-function="ctrl.actualitzarrols()">\n' +
    '          </itec-button>\n' +
    '\n' +
    '          <itec-button  label="{{::\'DEFAULT_GUARDAR\' | translate}}"\n' +
    '                        ng-click-function="ctrl.func()">\n' +
    '          </itec-button>\n' +
    '          <itec-button  label="{{::\'DEFAULT_TORNAR\' | translate}}"\n' +
    '                        ng-click-function="ctrl.back()">\n' +
    '          </itec-button>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<itec-tree      items="ctrl.rootTreeNodeCollection"\n' +
    '                expanded-collection="ctrl.expandedCollection"\n' +
    '                children="ctrl.loadChildren(object)"\n' +
    '                tree-tracking="ctrl.treeTracking"\n' +
    '                show-node="ctrl.filterNode"\n' +
    '                selected="ctrl.selected"\n' +
    '                order-by="order"\n' +
    '                expand-in-all-row="false"\n' +
    '                item-name="object">\n' +
    '\n' +
    '    <div  class="mdl-grid mdl-grid--no-spacing">\n' +
    '        <div class="mdl-cell mdl-cell--12-col">\n' +
    '            <span ng-if="::object.type === \'tema\'">\n' +
    '                <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '                    <div class="mdl-cell mdl-cell--4-col">\n' +
    '                    <span>{{::object.messageKey | translate}}</span>\n' +
    '                    </div>\n' +
    '                     <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="read"\n' +
    '                            ng-model="object.read"\n' +
    '                            ng-change-function="ctrl.onChangeReadTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_VEURE\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '                     <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="add"\n' +
    '                            ng-model="object.add"\n' +
    '                            ng-change-function="ctrl.onChangeAddTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_AFEGIR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '                     <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="edit"\n' +
    '                            ng-model="object.edit"\n' +
    '                            ng-change-function="ctrl.onChangeEditTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_EDITAR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '                     <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="delete"\n' +
    '                            ng-model="object.delete"\n' +
    '                            ng-change-function="ctrl.onChangeDeleteTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_ESBORRAR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </span>\n' +
    '            <span ng-if="::object.type === \'vista\'">\n' +
    '                <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '                    <div class="mdl-cell mdl-cell--4-col">\n' +
    '                        <span>{{::"administracio.producte.vistes." + object.nom | translate}}</span>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="read"\n' +
    '                            ng-model="object.read"\n' +
    '                            ng-change-function="ctrl.onChangeReadTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_VEURE\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '\n' +
    '                      <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="add"\n' +
    '                            ng-model="object.add"\n' +
    '                            ng-change-function="ctrl.onChangeAddTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_AFEGIR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="edit"\n' +
    '                            ng-model="object.edit"\n' +
    '                            ng-change-function="ctrl.onChangeEditTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_EDITAR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '\n' +
    '\n' +
    '                    <div class="mdl-cell mdl-cell--2-col">\n' +
    '                        <itec-checkbox\n' +
    '                            name="delete"\n' +
    '                            ng-model="object.delete"\n' +
    '                            ng-change-function="ctrl.onChangeDeleteTheme(object)"\n' +
    '                            label="{{::\'DEFAULT_ESBORRAR\' | translate}}">\n' +
    '                        </itec-checkbox>\n' +
    '                    </div>\n' +
    '\n' +
    '                </div>\n' +
    '            </span>\n' +
    '\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</itec-tree>\n' +
    '<div class="tcqi--margin-bottom-30"></div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('productes/main/llista/llista.tpl.html',
    '<div class="mnt-content mdl-grid mdl-grid--no-spacing">\n' +
    '  <div class="mdl-cell mdl-cell--12-col">\n' +
    '\n' +
    '        <itec-form\n' +
    '            name="ctrl.formulari.nom"\n' +
    '            fields="ctrl.formulari.camps"\n' +
    '            ng-model="ctrl.cercaObj"\n' +
    '            ng-submit-function="ctrl.formulari.func()"\n' +
    '            errors="ctrl.errors"\n' +
    '            submit-button-text="DEFAULT_CERCAR"\n' +
    '            backbutton="false"\n' +
    '            submit-button-dynamic="false">\n' +
    '          </itec-form>\n' +
    '  </div>\n' +
    '  <div class="mdl-cell mdl-cell--12-col">\n' +
    '    <md-card>\n' +
    '      <md-card-content>\n' +
    '        <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '\n' +
    '          <itec-simple-list\n' +
    '            class="mdl-cell mdl-cell--12-col"\n' +
    '            items="ctrl.llista"\n' +
    '            fields="ctrl.fields"\n' +
    '            show-edit-button="::$root.permisos.ACTUALITZARPRODUCTE.edit"\n' +
    '            show-delete-button="::$root.permisos.ESBORRARPRODUCTE.delete"\n' +
    '            show-add-button="false"\n' +
    '            show-clone-button="::$root.permisos.AFEGIRPRODUCTE.add"\n' +
    '            itec-dialog-confirm-title="DEFAULT_TITOL_CONFIRMACIO_ESBORRAR"\n' +
    '            itec-dialog-confirm-text-content="PRODUCTE_DELETE_CONTENT"\n' +
    '            itec-infinite-scroll-function="ctrl.load"\n' +
    '            threshold="100"\n' +
    '            can-load="ctrl.canLoad"\n' +
    '            delete-function="ctrl.deleteProductes"\n' +
    '            click-function="ctrl.view"\n' +
    '            all-row-clickable="true"\n' +
    '            clone-function="ctrl.duplicate"\n' +
    '            edit-function="ctrl.edit"\n' +
    '            id-selected="$stateParams.idProducte">\n' +
    '          </itec-simple-list>\n' +
    '        </div>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('productes/main/entitats/dades.tpl.html',
    '<div class="mnt-content mdl-grid mdl-grid--no-spacing">\n' +
    '   <div class="mdl-cell mdl-cell--12-col">\n' +
    '\n' +
    '          <itec-form ng-show="$root.issuperadmin"\n' +
    '            name="ctrl.formulari.nom"\n' +
    '            fields="ctrl.formulari.camps"\n' +
    '            ng-model="ctrl.cercaObj"\n' +
    '            ng-submit-function="ctrl.formulari.func()"\n' +
    '            errors="ctrl.errors"\n' +
    '            submit-button-text="DEFAULT_CERCAR"\n' +
    '            backbutton="false"\n' +
    '            submit-button-dynamic="false">\n' +
    '          </itec-form>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="mdl-cell mdl-cell--12-col mdl-grid mdl-grid--no-spacing">\n' +
    '     <itec-simple-list\n' +
    '        class="mdl-cell mdl-cell--12-col"\n' +
    '        items="ctrl.llista"\n' +
    '        fields="ctrl.fields"\n' +
    '        show-edit-button="false"\n' +
    '        show-delete-button="false"\n' +
    '        show-add-button="false"\n' +
    '        itec-infinite-scroll-function="ctrl.load"\n' +
    '        threshold="100"\n' +
    '        can-load="ctrl.canLoad"\n' +
    '        click-function="ctrl.view"\n' +
    '        all-row-clickable="true"\n' +
    '        id-selected="$stateParams.idEntitat">\n' +
    '      </itec-simple-list>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('productes/main/edit/edit.tpl.html',
    '<div id="producte-form" ng-cloak>\n' +
    '\n' +
    '      <itec-form \n' +
    '      	name="ctrl.formulari.nom"\n' +
    '      	fields="ctrl.formulari.camps"\n' +
    '      	ng-model="ctrl.producte"\n' +
    '      	ng-submit-function="ctrl.formulari.func()"\n' +
    '      	errors="ctrl.errors"\n' +
    '        submit-button-text="DEFAULT_GUARDAR"\n' +
    '        backbutton="true"\n' +
    '        backbuttonfunction="ctrl.back()"\n' +
    '        >\n' +
    '\n' +
    '        \n' +
    '      </itec-form>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('productes/main/dades/dades.tpl.html',
    '<div  class="productes-content">\n' +
    '  <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '    <h5 class="mdl-layout-title mdl-cell--8-col">\n' +
    '      {{::\'DEFAULT_PRODUCTE\' | translate}}\n' +
    '    </h5>\n' +
    '    <div class="mdl-cell mdl-cell--4-col">\n' +
    '      <div class="itec-float-right">\n' +
    '	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"\n' +
    '					 	ng-if="::$root.permisos.ESBORRARPRODUCTE.delete"\n' +
    '	          itec-dialog-confirm\n' +
    '	          itec-dialog-confirm-title="{{::\'DEFAULT_TITOL_CONFIRMACIO_ESBORRAR\' | translate}}"\n' +
    '	          itec-dialog-confirm-text-content="{{::\'PRODUCTE_DELETE_CONTENT\' | translate}}"\n' +
    '	          itec-dialog-confirm-text-ok="DIALOG_CONFIRM"\n' +
    '	          itec-dialog-confirm-text-cancel="DIALOG_CANCEL"\n' +
    '	          itec-dialog-confirm-function-ok="ctrl.deleteElem()">\n' +
    '	        <i class="material-icons">delete</i>\n' +
    '	      </button>\n' +
    '	      <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"\n' +
    '								ng-if="::$root.permisos.ACTUALITZARPRODUCTE.edit"\n' +
    '								ng-click="ctrl.changeToForm()">\n' +
    '	        <i class="material-icons">edit</i>\n' +
    '	      </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '   <div class="mdl-cell--12-col">\n' +
    '      <md-card>\n' +
    '        <md-card-content>\n' +
    '   <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '         <div class="mdl-cell mdl-cell--2-col">\n' +
    '               <span>{{::\'DEFAULT_ID\' | translate}}:</span>\n' +
    '          </div>\n' +
    '          <div class="mdl-cell mdl-cell--10-col">\n' +
    '               <span class="bold">{{::ctrl.producte.id}}</span>\n' +
    '          </div>\n' +
    '	        <div class="mdl-cell mdl-cell--2-col">\n' +
    '	              <span>{{::\'DEFAULT_NOM\' | translate}}:</span>\n' +
    '	         </div>\n' +
    '	         <div class="mdl-cell mdl-cell--4-col">\n' +
    '	              <span class="bold">{{::ctrl.producte.nom}}</span>\n' +
    '	         </div>\n' +
    '            <div class="mdl-cell mdl-cell--2-col">\n' +
    '                <span>{{::\'DEFAULT_APLICACIO\' | translate}}:</span>\n' +
    '            </div>\n' +
    '            <div class="mdl-cell mdl-cell--4-col">\n' +
    '                <span class="bold">{{::ctrl.producte.aplicacio.nom}}</span>\n' +
    '            </div>\n' +
    '            <div class="mdl-cell mdl-cell--2-col">\n' +
    '              <span>{{::\'DEFAULT_CODI_client\' | translate}}:</span>\n' +
    '            </div>\n' +
    '            <div class="mdl-cell mdl-cell--4-col">\n' +
    '              <span class="bold">{{::ctrl.producte.codiclient}}</span>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="mdl-cell mdl-cell--2-col">\n' +
    '              <span>{{::\'DEFAULT_TEDEMO\' | translate}}:</span>\n' +
    '            </div>\n' +
    '	          <div  class="mdl-cell mdl-cell--4-col">\n' +
    '	              <span class="bold">{{::ctrl.producte.tedemo}}</span>\n' +
    '	          </div>\n' +
    '        </div>\n' +
    '        </md-card-content>\n' +
    '      </md-card>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/main/sessions/usuarisensessio.tpl.html',
    '<md-dialog  aria-label="{{\'DEFAULT_EXPORTAR_FIE\' | translate}}">\n' +
    '  <form>\n' +
    '\n' +
    '    <md-dialog-content>\n' +
    '      <div class="md-dialog-content ">\n' +
    '        <div class="mdl-grid tcqi-table">\n' +
    '          <div class="mdl-cell mdl-cell--12-col tcqi--table-header">\n' +
    '  		        {{\'USUARIS_SESSIO\' | translate}}\n' +
    '          </div>\n' +
    '          <div class="mdl-cell mdl-cell--12-col">\n' +
    '              {{ctrl.usuarisensessio}}\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </md-dialog-content>\n' +
    '    <md-dialog-actions layout="row">\n' +
    '      <md-button class="md-primary md-button md-default-theme md-ink-ripple" ng-click="hide()">\n' +
    '       {{\'DEFAULT_SORTIR\' | translate}}\n' +
    '      </md-button>\n' +
    '    </md-dialog-actions>\n' +
    '  </form>\n' +
    '</md-dialog>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/main/sessions/sessions.tpl.html',
    '<div  class="mdl-grid mdl-grid--no-spacing"\n' +
    '      ng-if="$root.permisos.USUARISSESSIO.read">\n' +
    '  <h5 class="mdl-layout-title mdl-cell--12-col">\n' +
    '    {{\'USUARIS_SESSIO\' | translate}} </h5>\n' +
    '  <div class="mdl-cell--12-col">\n' +
    '    <md-card>\n' +
    '      <md-card-content>\n' +
    '        <form class="mdl-grid mdl-grid--no-spacing">\n' +
    '        <table class="itec-table mdl-grid mdl-cell mdl-cell--12-col mdl-grid--no-spacing">\n' +
    '            <thead class="mdl-grid mdl-cell mdl-cell--12-col mdl-grid--no-spacing">\n' +
    '              <tr class="mdl-grid mdl-cell mdl-cell--12-col mdl-grid--no-spacing">\n' +
    '                <th class="mdl-cell mdl-cell--2-col" >{{\'SUBSCRIPCIO\' | translate}}</th>\n' +
    '                <th class="mdl-cell mdl-cell--2-col">{{\'DEFAULT_NUMERO\' | translate}}</th>\n' +
    '                <th class="mdl-cell mdl-cell--2-col">{{\'USUARIS_SESSIO\' | translate}}</th>\n' +
    '                <th class="mdl-cell mdl-cell--6-col">{{\'USUARIS_PRODUCTE\' | translate}}&nbsp;\n' +
    '                    <div class="circle-ok " ></div>&nbsp;{{\'USUARI_CONFIRMAT_HEADER\' | translate}}\n' +
    '                    <div class="circle-vermell"></div>&nbsp;{{\'USUARI_NO_REGISTRAT_HEADER\' | translate}}\n' +
    '                    <div class="circle-groc"></div>&nbsp;{{\'USUARI_NO_CONFIRMAT_HEADER\' | translate}}\n' +
    '                </th>\n' +
    '              </tr>\n' +
    '            </thead>\n' +
    '            <tbody  class="mdl-grid mdl-cell mdl-cell--12-col mdl-grid--no-spacing">\n' +
    '                <tr class="mdl-grid mdl-cell mdl-cell--12-col mdl-grid--no-spacing" ng-repeat="usuarisessio in ctrl.productes">\n' +
    '                <td class="mdl-cell mdl-cell--2-col">{{usuarisessio.nomproducte}} </td>\n' +
    '                <td class="tcqi--text-align-right mdl-cell mdl-cell--2-col">{{\'DEFAULT_TOTAL\' | translate}} =  {{usuarisessio.numllicencies}} <br>\n' +
    '                  <div ng-repeat="cad in usuarisessio.caducitat">\n' +
    '                  {{cad.caducitat}}<br>\n' +
    '                  <span ng-if="cad.demo"> {{\'demo\' | translate}}</span>\n' +
    '                  <span ng-if="cad.renovacio"> {{\'renovacio\' | translate}}<br></span>\n' +
    '                  </div>\n' +
    '                </td>\n' +
    '                <td  class="tcqi--text-align-right mdl-cell mdl-cell--2-col">\n' +
    '                  <div ng-repeat="usc in usuarisessio.userssessioclient">\n' +
    '                    {{\'tipusclient_\' + usc.tipusclient | translate}}: {{usc.numusersensessio}}\n' +
    '                      <button ng-if="usc.numusersensessio>0"\n' +
    '                        class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"\n' +
    '                        title="{{::\'USUARIS_SESSIO\' | translate}}"\n' +
    '                        ng-click="ctrl.usuarisensessio(usc.usersensessio)">\n' +
    '                         <i class="icon-usuari"></i>\n' +
    '                       </button>\n' +
    '                  </div>\n' +
    '                </td>\n' +
    '                <td class="mdl-cell mdl-cell--6-col"> \n' +
    '                  <span ng-repeat="user in usuarisessio.users">\n' +
    '                      <a class="itec-link\n' +
    '                      {{(user.deleted || user.fictici) ? \'color-vermell\' : \'\'}}\n' +
    '                      {{(!user.deleted && !user.fictici && !user.confirmat) ? \'color-groc\' : \'\'}} \n' +
    '                      " ng-single-click="ctrl.viewuser({{user.id}});">\n' +
    '                       {{user.username}}</a>&nbsp; \n' +
    '                  </span>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </form>\n' +
    '\n' +
    '        <div class="visualClear">&nbsp;</div>\n' +
    '\n' +
    '\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/main/logos/logos.tpl.html',
    '<div class="mdl-grid mdl-grid--no-spacing">\n' +
    '  <h5 class="mdl-layout-title mdl-cell--12-col">\n' +
    '    {{\'DEFAULT_LOGOS\' | translate}}\n' +
    '  </h5>\n' +
    '  <div class="mdl-cell--12-col">\n' +
    '    <md-card>\n' +
    '      <md-card-content>\n' +
    '\n' +
    '        <adm-document-view\n' +
    '          base-url-upload="ctrl.baseUrlUpload"\n' +
    '          controller-url-upload="ctrl.controllerUrlUpload"\n' +
    '          id-entitat="ctrl.idEntitat"\n' +
    '          list-documents="ctrl.logos"\n' +
    '          show-edit="$root.permisos.LOGO.edit"\n' +
    '          edit-function="ctrl.makeLogoPred"\n' +
    '          upload-end-function="ctrl.uploadEndFunction">\n' +
    '        </adm-document-view>\n' +
    '\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/main/llista/llista.tpl.html',
    '<div class="mnt-content mdl-grid mdl-grid--no-spacing">\n' +
    '  <div class="mdl-cell mdl-cell--12-col">\n' +
    '\n' +
    '          <itec-form ng-show="$root.issuperadmin"\n' +
    '            name="ctrl.formulari.nom"\n' +
    '            fields="ctrl.formulari.camps"\n' +
    '            ng-model="ctrl.cercaObj"\n' +
    '            ng-submit-function="ctrl.formulari.func()"\n' +
    '            errors="ctrl.errors"\n' +
    '            submit-button-text="DEFAULT_CERCAR"\n' +
    '            backbutton="false"\n' +
    '            submit-button-dynamic="false">\n' +
    '          </itec-form>\n' +
    '\n' +
    '  </div>\n' +
    '  <div class="mdl-cell mdl-cell--12-col mdl-grid mdl-grid--no-spacing">\n' +
    '     <itec-simple-list\n' +
    '        class="mdl-cell mdl-cell--12-col"\n' +
    '        items="ctrl.llista"\n' +
    '        fields="ctrl.fields"\n' +
    '        show-edit-button="$root.permisos.ACTUALITZARENT.edit"\n' +
    '        show-delete-button="$root.permisos.ESBORRARENT.delete"\n' +
    '        show-add-button="false"\n' +
    '        itec-dialog-confirm-title="DEFAULT_TITOL_CONFIRMACIO_ESBORRAR"\n' +
    '        itec-dialog-confirm-text-content="ENTITAT_DELETE_CONTENT"\n' +
    '        itec-infinite-scroll-function="ctrl.load"\n' +
    '        threshold="100"\n' +
    '        can-load="ctrl.canLoad"\n' +
    '        delete-function="ctrl.deleteEntitat"\n' +
    '        click-function="ctrl.view"\n' +
    '        all-row-clickable="true"\n' +
    '        edit-function="ctrl.edit"\n' +
    '        id-selected="$stateParams.idEntitat">\n' +
    '      </itec-simple-list>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/main/llicencies/usuarisensessio.tpl.html',
    '<md-dialog  aria-label="{{\'DEFAULT_EXPORTAR_FIE\' | translate}}">\n' +
    '  <form>\n' +
    '\n' +
    '    <md-dialog-content>\n' +
    '      <div class="md-dialog-content ">\n' +
    '        <div class="mdl-grid tcqi-table">\n' +
    '          <div class="mdl-cell mdl-cell--12-col tcqi--table-header">\n' +
    '  		        {{\'USUARIS_SESSIO\' | translate}}\n' +
    '          </div>\n' +
    '          <div class="mdl-cell mdl-cell--12-col">\n' +
    '              {{ctrl.usuarisensessio}}\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </md-dialog-content>\n' +
    '    <md-dialog-actions layout="row">\n' +
    '      <md-button class="md-primary md-button md-default-theme md-ink-ripple" ng-click="hide()">\n' +
    '       {{\'DEFAULT_SORTIR\' | translate}}\n' +
    '      </md-button>\n' +
    '    </md-dialog-actions>\n' +
    '  </form>\n' +
    '</md-dialog>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/main/llicencies/llicencies.tpl.html',
    '<div  class="mdl-grid mdl-grid--no-spacing"\n' +
    '      ng-if="$root.permisos.LLICENCIA.read">\n' +
    '  <h5 class="mdl-layout-title mdl-cell--12-col">\n' +
    '    {{\'DEFAULT_PRODUCTES\' | translate}}\n' +
    '  </h5>\n' +
    '  <div class="mdl-cell--12-col">\n' +
    '    <md-card>\n' +
    '      <md-card-content>\n' +
    '       \n' +
    '\n' +
    '        <form>\n' +
    '        <div>\n' +
    '          <itec-error-block errors="ctrl.errors"></itec-error-block>\n' +
    '        </div>\n' +
    '        <table class="itec-table">\n' +
    '            <thead>\n' +
    '              <tr>\n' +
    '                <th>{{\'SUBSCRIPCIO\' | translate}}</th>\n' +
    '                <th>{{\'DEFAULT_DATA_CADUCITAT\' | translate}}</th>\n' +
    '                <th>{{\'DEFAULT_NUMERO\' | translate}}</th>\n' +
    '                <th ng-if="!ctrl.isAgrupat">{{\'DEFAULT_TIPUS\' | translate}}</th>\n' +
    '                <th>{{\'PRODUCTES_INCLOSOS\' | translate}}</th>\n' +
    '                <th ng-if="!ctrl.isAgrupat" ng-show="$root.permisos.ACTUALITZARLLICENCIA.edit">{{\'DEFAULT_ACCIONS\' | translate}}</th>\n' +
    '              </tr>\n' +
    '            </thead>\n' +
    '            <tbody>\n' +
    '              <tr ng-repeat="llicencia in ctrl.llicencies.items">\n' +
    '                <td>{{llicencia.productenom}} </td>\n' +
    '                <td >\n' +
    '                  <itec-datepicker\n' +
    '\n' +
    '                                    ng-model="llicencia.caducitat"\n' +
    '                                    ng-disabled="!angular.isUndefined(llicencia.editant) && !llicencia.editant "\n' +
    '                                    ng-showparam="field.show">\n' +
    '                  </itec-datepicker>\n' +
    '                </td>\n' +
    '                <td>\n' +
    '                     {{llicencia.numero}}\n' +
    '                </td>\n' +
    '                <td ng-if="!ctrl.isAgrupat">\n' +
    '                  <span ng-if="llicencia.botiga">{{\'botiga\' | translate}}</span> \n' +
    '                  <span ng-if="llicencia.botiga && llicencia.demo"> - </span> \n' +
    '                  <span ng-if="llicencia.demo">{{\'demo\' | translate}} </span>\n' +
    '                  <span ng-if="(llicencia.demo && llicencia.renovacio) || (llicencia.botiga && !llicencia.demo && llicencia.renovacio)"> - </span> \n' +
    '                  <span ng-if="llicencia.renovacio">{{\'renovacio\' | translate}} </span>\n' +
    '                </td>\n' +
    '                <td >\n' +
    '                      <div ng-repeat="produac in llicencia.listllicproductes">\n' +
    '                          {{produac.productenom}}\n' +
    '                      </div>\n' +
    '                </td>\n' +
    '                <td ng-if="!ctrl.isAgrupat">\n' +
    '                 <button ng-if="!ctrl.isAgrupat"\n' +
    '                    ng-show="llicencia.editant "\n' +
    '                    title="{{\'DEFAULT_ACCIONS_EDITAR\' | translate}}"\n' +
    '                    aria-label="{{\'DEFAULT_ACCIONS_EDITAR\' | translate}}"\n' +
    '                    class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"\n' +
    '                    ng-click="ctrl.saveNewDate(llicencia)">\n' +
    '                      <i class="material-icons">save</i>\n' +
    '                  </button>\n' +
    '\n' +
    '                  <button \n' +
    '                    ng-if="!ctrl.isAgrupat && !angular.isUndefined(llicencia.editant) && !llicencia.editant && $root.permisos.LLICENCIA.edit"\n' +
    '                    title="{{\'DEFAULT_ACCIONS_EDITAR\' | translate}}"\n' +
    '                    aria-label="{{\'DEFAULT_ACCIONS_EDITAR\' | translate}}"\n' +
    '                    class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"\n' +
    '                    ng-click="llicencia.editant = true">\n' +
    '                      <i class="material-icons">edit</i>\n' +
    '                  </button>\n' +
    '\n' +
    '                  <button \n' +
    '                    ng-if="!ctrl.isAgrupat && $root.permisos.ESBORRARLLICENCIA.delete"\n' +
    '                    class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"\n' +
    '                    itec-dialog-confirm\n' +
    '                    title="{{\'DEFAULT_ACCIONS_ESBORRAR\' | translate}}"\n' +
    '                    aria-label="{{\'DEFAULT_ACCIONS_ESBORRAR\' | translate}}"\n' +
    '                    itec-dialog-confirm-title="{{\'DEFAULT_TITOL_CONFIRMACIO_ESBORRAR\' | translate}}"\n' +
    '                    itec-dialog-confirm-text-content="{{\'PRODUCTE_DELETE_CONTENT\' | translate}}"\n' +
    '                    itec-dialog-confirm-text-ok="DIALOG_CONFIRM"\n' +
    '                    itec-dialog-confirm-text-cancel="DIALOG_CANCEL"\n' +
    '                    itec-dialog-confirm-function-ok="ctrl.deleteFunction(llicencia)">\n' +
    '                      <i class="material-icons">delete</i>\n' +
    '                  </button>\n' +
    '                </td>\n' +
    '              </tr>\n' +
    '            </tbody>\n' +
    '          </table>\n' +
    '        </form>\n' +
    '\n' +
    '        <div class="visualClear">&nbsp;</div>\n' +
    '\n' +
    '        <itec-button ng-click="ctrl.add()"\n' +
    '          label="AFEGIR_PRODUCTE"\n' +
    '           ng-if="$root.permisos.AFEGIRLLICENCIA.add">\n' +
    '        </itec-button>\n' +
    '\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/main/formulari/formulari.tpl.html',
    '<div ng-cloak>\n' +
    '  \n' +
    '      <itec-form \n' +
    '        name="ctrl.formulari.nom"\n' +
    '        fields="ctrl.formulari.camps"\n' +
    '        ng-model="ctrl.entitat"\n' +
    '        ng-submit-function="ctrl.formulari.func()"\n' +
    '        errors="ctrl.errors"\n' +
    '        backbutton="true"\n' +
    '        backbuttonfunction="ctrl.back()">\n' +
    '      </itec-form>\n' +
    '   \n' +
    '</div>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/main/dades/dades.tpl.html',
    '\n' +
    '<div  class="contractes-content">\n' +
    '  <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '    <h5 class="mdl-layout-title mdl-cell--8-col">\n' +
    '      {{::ctrl.entitat.nom | translate}}\n' +
    '    </h5>\n' +
    '    <div class="mdl-cell mdl-cell--4-col">\n' +
    '      <div class="itec-float-right">\n' +
    '        <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"\n' +
    '            ng-if="$root.permisos.ESBORRARENT.delete"\n' +
    '            itec-dialog-confirm\n' +
    '            itec-dialog-confirm-title="DEFAULT_TITOL_CONFIRMACIO_ESBORRAR"\n' +
    '            itec-dialog-confirm-text-content="ENTITAT_DELETE_CONTENT"\n' +
    '            itec-dialog-confirm-text-ok="DIALOG_CONFIRM"\n' +
    '            itec-dialog-confirm-text-cancel="DIALOG_CANCEL"\n' +
    '            itec-dialog-confirm-function-ok="ctrl.deleteElem()">\n' +
    '          <i class="material-icons">delete</i>\n' +
    '        </button>\n' +
    '        <button\n' +
    '            class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored itec-float-right"\n' +
    '            ng-if="$root.permisos.ACTUALITZARENT.edit"\n' +
    '            ng-click="ctrl.edit()">\n' +
    '          <i class="material-icons">edit</i>\n' +
    '        </button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="mdl-cell--12-col">\n' +
    '      <md-card>\n' +
    '        <md-card-content>\n' +
    '          <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '            <div class="mdl-cell mdl-cell--2-col">\n' +
    '              <span>{{::\'DEFAULT_NOM\' | translate}}:</span>\n' +
    '            </div>\n' +
    '            <div class="mdl-cell mdl-cell--4-col">\n' +
    '              <span class="bold">{{::ctrl.entitat.nom}}</span>\n' +
    '            </div>\n' +
    '            <div class="mdl-cell mdl-cell--2-col">\n' +
    '              <span>{{::\'DEFAULT_NIF\' | translate}}:</span>\n' +
    '            </div>\n' +
    '            <div class="mdl-cell mdl-cell--4-col">\n' +
    '              <span class="bold">{{::ctrl.entitat.nif}}</span>\n' +
    '            </div>\n' +
    '            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">\n' +
    '              <span>{{::\'DEFAULT_CODI\' | translate}}:</span>\n' +
    '            </div>\n' +
    '            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--4-col">\n' +
    '              <span class="bold">{{::ctrl.entitat.codi}}</span>\n' +
    '            </div>\n' +
    '            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">\n' +
    '              <span>{{::\'DEFAULT_CODI_client\' | translate}}:</span>\n' +
    '            </div>\n' +
    '            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--4-col">\n' +
    '              <span class="bold">{{::ctrl.entitat.codiclient}}</span>\n' +
    '            </div>\n' +
    '            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">\n' +
    '              <span>{{::\'DEFAULT_TYK_PROPI\' | translate}}:</span>\n' +
    '            </div>\n' +
    '            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--4-col">\n' +
    '              <span  ng-if="ctrl.entitat.tetykpropi==true" class="bold">{{\'DEFAULT_SI\' | translate}}</span>\n' +
    '              <span  ng-if="ctrl.entitat.tetykpropi==false" class="bold">{{\'DEFAULT_NO\' | translate}}</span>\n' +
    '            </div>\n' +
    '             <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">\n' +
    '              <span>{{::\'DEFAULT_BLOQUEJADA\' | translate}}:</span>\n' +
    '            </div>\n' +
    '            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--4-col">\n' +
    '              <span  ng-if="ctrl.entitat.bloquejada==true" class="bold">{{\'DEFAULT_SI\' | translate}}</span>\n' +
    '              <span  ng-if="ctrl.entitat.bloquejada==false" class="bold">{{\'DEFAULT_NO\' | translate}}</span>\n' +
    '            </div>\n' +
    '            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--2-col">\n' +
    '              <span>{{::\'DEFAULT_TIPUS\' | translate}}:</span>\n' +
    '            </div>\n' +
    '            <div  ng-if="$root.issuperadmin" class="mdl-cell mdl-cell--4-col">\n' +
    '              <span  class="bold">{{ ctrl.entitat.tipus_client | translate}}</span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </md-card-content>\n' +
    '      </md-card>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="tcqi--margin-bottom-20" ng-if="$root.issuperadmin">\n' +
    '  <form name="form" class="mdl-grid mdl-grid--no-spacing">\n' +
    '    <div class="mdl-cell mdl-cell--6-col" ng-if="$root.permisos.LOGIN.add">\n' +
    '      <itec-form-file-upload\n' +
    '      name="form"\n' +
    '      class="mdl-cell mdl-cell--12-col"\n' +
    '      files="ctrl.files"\n' +
    '      err-files="ctrl.errFiles"\n' +
    '      funcio-seleccionar="ctrl.uploadFile()"\n' +
    '      select-files-text="{{\'IMPORTAR_USUARIS_EXCEL\' | translate}}"\n' +
    '      max-size="{{vm.maxSize}}"\n' +
    '      pattern="[\'.xlsx\', \'.xls\' ,\'.ods\']"\n' +
    '      show-only-icon="false"\n' +
    '      icon-left="ctrl.iconLeft"\n' +
    '      parent-ctrl="ctrl"\n' +
    '      multiple-files="false"\n' +
    '      show-header="ctrl.showHeader"\n' +
    '      close-after-doc-selection="true"\n' +
    '      title="{{ctrl.title}}">\n' +
    '\n' +
    '    </itec-form-file-upload>\n' +
    '    </div>\n' +
    '    <div class="mdl-cell mdl-cell--9-col" ng-show="ctrl.fitxercarrega.fields.selected || ctrl.fitxercarrega.status == \'done\'">\n' +
    '      {{vm.fitxercarrega.file.name}}\n' +
    '      <md-button ng-show="ctrl.fixercarrega.file.progress==100" class="md-icon-button">\n' +
    '        <md-icon>done</md-icon>\n' +
    '      </md-button>\n' +
    '      <span flex></span>\n' +
    '      <md-progress-linear md-mode="determinate" value="{{ctrl.fitxercarrega.file.progress}}">\n' +
    '      </md-progress-linear>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '\n' +
    '  <itec-form-file-upload-errors\n' +
    '    err-files="ctrl.errFiles"\n' +
    '    max-size="{{ctrl.maxSize}}"\n' +
    '    max-size-exceeded-text={{maxSizeExceededText}}>\n' +
    '  </itec-form-file-upload-errors>\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/main/administradors/administradors.tpl.html',
    '<div  class="contractes-content">\n' +
    '  <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '    <h5 class="mdl-layout-title mdl-cell--12-col">\n' +
    '      {{::\'DEFAULT_ADMINISTRADORS\' | translate}}\n' +
    '    </h5>\n' +
    '\n' +
    '    <div class="mdl-cell--12-col">\n' +
    '      <md-card>\n' +
    '        <md-card-content>\n' +
    '          <div class="mdl-grid ">\n' +
    '          <div class="mdl-cell--2-col "><div class="circle-ok"></div> {{::\'USUARI_CONFIRMAT_TITOL\' | translate}}</div>\n' +
    '          <div class="mdl-cell--2-col"><div class="circle-vermell"></div>  {{::\'USUARI_NO_REGISTRAT_TITOL\' | translate}}</div>\n' +
    '          <div class="mdl-cell--3-col "><div class="circle-groc"></div>  {{::\'USUARI_NO_CONFIRMAT_TITOL\' | translate}}</div>\n' +
    '        </div>\n' +
    '         <span ng-repeat="user in ctrl.entitat.administradors">\n' +
    '                     <a class="itec-link \n' +
    '                     {{(user.deleted || user.fictici) ? \'color-vermell\' : \'\'}}\n' +
    '                     {{(!user.deleted && !user.fictici && !user.confirmat) ? \'color-groc\' : \'\'}} " ng-single-click="ctrl.viewuser({{user.id}});">\n' +
    '                       {{user.username}}</a>&nbsp; \n' +
    '          </span>\n' +
    '        </md-card-content>\n' +
    '      </md-card>\n' +
    '\n' +
    '        <h5 class="mdl-layout-title mdl-cell--12-col">\n' +
    '          <span>{{::\'titol_enviar_admins\' | translate}}</span>\n' +
    '        </h5>\n' +
    '        <md-card>\n' +
    '        <md-card-content>\n' +
    '          <div class="mdl-grid ">\n' +
    '          <div class="mdl-cell mdl-cell--12-col">\n' +
    '             <form>\n' +
    '              <itec-select\n' +
    '                 class="mdl-cell mdl-cell--12-col"\n' +
    '                 property-id="id"\n' +
    '                 property-label="name"\n' +
    '                 list="ctrl.listnotificar"\n' +
    '                 name="tipusnotificacions"\n' +
    '                 ng-model="ctrl.entitat.tipusnotificacions"\n' +
    '                 ng-disabled="false"\n' +
    '                 ng-change-function="ctrl.onEnviarAdminsChange()">\n' +
    '              </itec-select>\n' +
    '            </form>\n' +
    '          </div>\n' +
    '          </div>\n' +
    '        </md-card-content>\n' +
    '        </md-card>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('usuaris/main/main.tpl.html',
    '<h2>main</h2>\n' +
    '<p>{{main.ctrlName}}</p>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('shared/submain/submain.tpl.html',
    '<div ui-view="content"></div>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('shared/header-submenu/headerSubmenu.tpl.html',
    '<tcqi-header-submenu ng-if="vm.attr.header.submenu.show" attr="vm.attr"></tcqi-header-submenu>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('shared/document/document-overwrite-dialog.tpl.html',
    '<md-dialog  aria-label="{{\'SHARED_DOCUMENT_PASTE_OVERWRITE_TITLE\' | translate}}">\n' +
    '  <form>\n' +
    '    <md-toolbar>\n' +
    '      <div class="md-toolbar-tools">\n' +
    '        <h2>{{\'SHARED_DOCUMENT_PASTE_OVERWRITE_TITLE\' | translate}}</h2>\n' +
    '        <span flex></span>\n' +
    '        <md-button class="md-icon-button" ng-click="hide()" ng-disabled="!$root.permisos.ACTUALITZARENT.edit">\n' +
    '          <md-icon aria-label="{{\'DEFAULT_TANCAR\' | translate}}">close</md-icon>\n' +
    '        </md-button>\n' +
    '      </div>\n' +
    '    </md-toolbar>\n' +
    '    <md-dialog-content>\n' +
    '      <div class="md-dialog-content">\n' +
    '        <p>{{\'SHARED_DOCUMENT_PASTE_OVERWRITE_CONTENT\' | translate}}</p>\n' +
    '      </div>\n' +
    '    </md-dialog-content>\n' +
    '    <md-dialog-actions layout="row">\n' +
    '      <md-button class="md-primary md-button md-default-theme md-ink-ripple" ng-click="hide()">\n' +
    '       {{\'DEFAULT_CANCELAR\' | translate}}\n' +
    '      </md-button>\n' +
    '      <md-button class="md-primary md-button md-default-theme md-ink-ripple" ng-click="accept()" ng-if="$root.permisos.DOCUMENT.edit">\n' +
    '        {{\'DEFAULT_SOBREESCRIURE\' | translate}}\n' +
    '      </md-button>\n' +
    '    </md-dialog-actions>\n' +
    '  </form>\n' +
    '</md-dialog>\n' +
    '');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('shared/document/adm-form-file-upload-manteniment-directive.tpl.html',
    '<itec-form-file-upload\n' +
    '	files="vm.files"\n' +
    '	err-files="vm.errFiles"\n' +
    '	funcio-seleccionar="vm.selectFiles()"\n' +
    '	select-files-text="{{selectFilesText}}"\n' +
    '	pattern="[\'images\']"\n' +
    '	multiple-files="true"\n' +
    '	max-size="{{vm.maxSize}}">\n' +
    '</itec-form-file-upload>\n' +
    '\n' +
    '<div ng-repeat="f in vm.files" class="itec-file-upload tcqi--margin-top-20">\n' +
    '	<div ng-show="f.status!=\'working\'">\n' +
    '		<div class="mdl-grid" ng-show="f.fields.selected || f.status == \'done\'">\n' +
    '			<div class="mdl-cell mdl-cell--1-col mdl-cell--middle">\n' +
    '			</div>\n' +
    '\n' +
    '			<div class="mdl-cell mdl-cell--11-col">\n' +
    '				{{::f.file.name}}\n' +
    '				<span flex></span>\n' +
    '				<md-button ng-show="f.progress==100" class="md-icon-button">\n' +
    '		          	<md-icon>done</md-icon>\n' +
    '		        </md-button>\n' +
    '				<md-progress-linear md-mode="determinate" value="{{f.progress}}">\n' +
    '				</md-progress-linear>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '	</div>\n' +
    '\n' +
    '	<form name="f.form" novalidate ng-cloak ng-show="f.status==\'working\'">\n' +
    '		<div class="mdl-grid">\n' +
    '\n' +
    '			<div class="mdl-cell mdl-cell--1-col mdl-cell--middle">\n' +
    '				<md-checkbox class="md-primary" aria-label="mark file" ng-model="f.fields.selected"></md-checkbox>\n' +
    '			</div>\n' +
    '\n' +
    '			<div class="mdl-cell mdl-cell--11-col">\n' +
    '				<itec-input-text 	name="title"\n' +
    '									container-class=""\n' +
    '									with-label="false"\n' +
    '			    					ng-model="f.fields.title"\n' +
    '							        ng-required="true"\n' +
    '							        ng-minlength="0"\n' +
    '							        ng-maxlength="255"\n' +
    '							        label="DEFAULT_NOM"\n' +
    '							        validation-message-required="DEFAULT_VALIDATION_MESSAGE_REQUIRED"\n' +
    '							        validation-message-minlength="DEFAULT_VALIDATION_MESSAGE_MINLENGTH"\n' +
    '							        validation-message-maxlength="DEFAULT_VALIDATION_MESSAGE_MAXLENGTH">\n' +
    '				</itec-input-text>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '	</form>\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '<itec-form-file-upload-errors\n' +
    '  err-files="vm.errFiles"\n' +
    '  max-size="{{vm.maxSize}}"\n' +
    '  max-size-exceeded-text={{maxSizeExceededText}}>\n' +
    '</itec-form-file-upload-errors>\n' +
    '\n' +
    '<br/><br/>\n' +
    '\n' +
    '<itec-button\n' +
    '			ng-click-function="vm.uploadFiles()" \n' +
    '			ng-disabled="vm.invalidForm()" \n' +
    '			ng-show="vm.files.length>0 && vm.pending(vm.files)"\n' +
    '			label="{{saveFilesText}}">\n' +
    '</itec-button>\n' +
    '<itec-button\n' +
    '			ng-click-function="vm.cleanForm()" \n' +
    '			ng-show="vm.files.length>0"\n' +
    '			label="DEFAULT_TORNAR">\n' +
    '</itec-button>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('shared/document/adm-document-view-directive.tpl.html',
    '<div class="mdl-grid" ng-if="ctrl.mode === 0">\n' +
    '  <h5 class="mdl-layout-title">{{::ctrl.labelUploadTitle | translate}}</h5>\n' +
    '  \n' +
    '  <div class="mdl-cell mdl-cell--12-col" ng-if="ctrl.showUpload">\n' +
    '    <md-card>\n' +
    '      <md-card-content ng-if="$root.permisos.DOCUMENT.edit" >\n' +
    '        <adm-form-file-upload-manteniment\n' +
    '          id-type-document="ctrl.idTypeDocument"\n' +
    '          select-files-text="SHARED_DOCUMENT_UPLOAD_SELECT_FILES"\n' +
    '          save-files-text="SHARED_DOCUMENT_UPLOAD_SAVE_FILES"\n' +
    '          max-size-exceeded-text="SHARED_DOCUMENT_UPLOAD_MAX_SIZE_EXCEEDED"\n' +
    '          id-entitat="idEntitat"\n' +
    '          on-finish-function="ctrl.uploadEndFunction()"\n' +
    '          url-base="baseUrlUpload"\n' +
    '          url-controller="controllerUrlUpload">\n' +
    '        </adm-form-file-upload-manteniment>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="mdl-cell mdl-cell--11-col">\n' +
    '    <h5 class="mdl-layout-title">{{::ctrl.labelListTitle | translate}}</h5>\n' +
    '  </div>\n' +
    '\n' +
    ' <!-- <div class="mdl-cell mdl-cell--1-col">\n' +
    '    <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="ctrl.changeListMode()">\n' +
    '      <i ng-if="ctrl.listMode" class="material-icons" title="{{\'DEFAULT_ACCIONS_VISUALITZAR_ICONES\' | translate}}" aria-label="{{\'DEFAULT_ACCIONS_VISUALITZAR_ICONES\' | translate}}">view_comfy </i>\n' +
    '      <i ng-if="!ctrl.listMode" class="material-icons" title="{{\'DEFAULT_ACCIONS_VISUALITZAR_LLISTA\' | translate}}" aria-label="{{\'DEFAULT_ACCIONS_VISUALITZAR_LLISTA\' | translate}}">format_list_bulleted</i>\n' +
    '    </button> \n' +
    '  </div> -->\n' +
    '\n' +
    '  <div class="mdl-cell mdl-cell--12-col">\n' +
    '    <md-card>\n' +
    '      <md-card-content>\n' +
    '        <table class="itec-table">\n' +
    '          <thead>\n' +
    '            <tr>\n' +
    '              <th class="maxwidthTableButton"></th>\n' +
    '              <th>\n' +
    '                <ng-pluralize count="listDocuments.length"\n' +
    '                  when="{\'0\': \'{{&quot;SHARED_DOCUMENT_UPLOADED_COUNT_0&quot; | translate}}\',\n' +
    '                      \'1\': \'{{&quot;SHARED_DOCUMENT_UPLOADED_COUNT_1&quot; | translate}}\',\n' +
    '                      \'other\': \'{{&quot;SHARED_DOCUMENT_UPLOADED_COUNT_N&quot; | translate:{count : listDocuments.length} }}\'}">\n' +
    '                </ng-pluralize>\n' +
    '              </th>\n' +
    '              <th class="maxwidthTableButton">\n' +
    '  	            <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="ctrl.downloadDocuments(ctrl.selectedDocuments)" title="{{\'DEFAULT_ACCIONS_DESCARREGAR\' | translate}}" aria-label="{{\'DEFAULT_ACCIONS_DESCARREGAR\' | translate}}">\n' +
    '  	              <i class="material-icons">file_download</i>\n' +
    '  	            </button>     \n' +
    '              </th>\n' +
    '              <th class="maxwidthTableButton">\n' +
    '  	            <button ng-if="$root.permisos.DOCUMENT.edit" class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"\n' +
    '  	                itec-dialog-confirm \n' +
    '                    itec-dialog-confirm-title="SHARED_DOCUMENT_CONFIRM_DELETE_TITLE"\n' +
    '                    itec-dialog-confirm-text-content="{{ctrl.labelConfirmDelete}}"\n' +
    '					title="{{\'DEFAULT_ACCIONS_ESBORRAR\' | translate}}" \n' +
    '                    aria-label="{{\'DEFAULT_ACCIONS_ESBORRAR\' | translate}}"\n' +
    '                    itec-dialog-confirm-text-ok="DEFAULT_ESBORRAR"\n' +
    '                    itec-dialog-confirm-text-cancel="DEFAULT_CANCELAR"\n' +
    '                    itec-dialog-confirm-function-ok="ctrl.deleteDocuments(ctrl.selectedDocuments)"\n' +
    '                    ng-if="ctrl.showDelete">\n' +
    '  	              <i class="material-icons">delete</i>\n' +
    '  	            </button>   \n' +
    '              </th>\n' +
    '            </tr>\n' +
    '          </thead>\n' +
    '          <tbody ng-if="!ctrl.listMode">\n' +
    '            <tr>\n' +
    '              <td colspan="9">\n' +
    '                <itec-gallery ng-if="!ctrl.listMode" list="listDocuments" selected="ctrl.selectedDocuments" property-label="titol" property-date="dataDocument"></itec-gallery>\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '          </tbody>\n' +
    '          <tbody ng-if="ctrl.listMode">\n' +
    '            <tr ng-repeat="doc in listDocuments">\n' +
    '              <td ng-if="doc.predeterminat">\n' +
    '                <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="" ng-if="ctrl.showEdit">\n' +
    '                  <i class="material-icons">star</i>\n' +
    '                </button>\n' +
    '                <button class="mdl-button mdl-js-button mdl-button--icon" ng-click="" ng-if="!ctrl.showEdit">\n' +
    '                  <i class="material-icons">star</i>\n' +
    '                </button>\n' +
    '              </td>\n' +
    '              <td ng-if="!doc.predeterminat">\n' +
    '                <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="ctrl.editDocument(doc.id)" ng-if="ctrl.showEdit">\n' +
    '                  <i class="material-icons">star_border</i>\n' +
    '                </button>\n' +
    '                <button class="mdl-button mdl-js-button mdl-button--icon" ng-click="" ng-if="!ctrl.showEdit">\n' +
    '                  <i class="material-icons">star_border</i>\n' +
    '                </button>\n' +
    '              </td>\n' +
    '              <td>\n' +
    '                {{doc.nom}}\n' +
    '              </td>\n' +
    '              <td> \n' +
    '                <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="ctrl.downloadDocument(doc.id)">\n' +
    '                  <i class="material-icons">file_download</i>\n' +
    '                </button>     \n' +
    '              </td>\n' +
    '              <td>\n' +
    '                <button ng-if="$root.permisos.DOCUMENT.edit" class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored"\n' +
    '                    itec-dialog-confirm \n' +
    '                    itec-dialog-confirm-title="SHARED_DOCUMENT_CONFIRM_DELETE_TITLE"\n' +
    '                    itec-dialog-confirm-text-content="{{ctrl.labelConfirmDelete}}"\n' +
    '		                itec-dialog-confirm-text-ok="DEFAULT_ESBORRAR"\n' +
    '                    itec-dialog-confirm-text-cancel="DEFAULT_CANCELAR"\n' +
    '                    itec-dialog-confirm-function-ok="ctrl.deleteDocument(doc.id)"\n' +
    '                    ng-if="ctrl.showDelete">\n' +
    '                  <i class="material-icons">delete</i>\n' +
    '                </button>   \n' +
    '              </td>\n' +
    '            </tr>\n' +
    '          </tbody>\n' +
    '        </table>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="mdl-grid" ng-if="ctrl.mode === 1">\n' +
    '  <h5 class="mdl-layout-title">{{::ctrl.labelEditTitle | translate}}</h5>\n' +
    '\n' +
    '  <div class="mdl-cell mdl-cell--12-col">\n' +
    '    <md-card>\n' +
    '      <md-card-content>\n' +
    '\n' +
    '        <form name="ctrl.editForm" novalidate ng-cloak>\n' +
    '          <div class="mdl-grid" ng-repeat="editDocument in ctrl.listEditDocuments">\n' +
    '            <div class="mdl-cell mdl-cell--6-col">\n' +
    '              <itec-input-text\n' +
    '                name="{{editDocument.id}}.nom"\n' +
    '                ng-model="editDocument.nom"\n' +
    '                ng-required="true"\n' +
    '                ng-minlength="0"\n' +
    '                ng-maxlength="100"\n' +
    '                label="DEFAULT_NOM"\n' +
    '                validation-message-required="DEFAULT_VALIDATION_MESSAGE_REQUIRED"\n' +
    '                validation-message-minlength="DEFAULT_VALIDATION_MESSAGE_MINLENGTH"\n' +
    '                validation-message-maxlength="DEFAULT_VALIDATION_MESSAGE_MAXLENGTH">\n' +
    '              </itec-input-text>\n' +
    '\n' +
    '              <itec-error-form errors="ctrl.errors[editDocument.id+\'.titol\']">\n' +
    '              </itec-error-form>\n' +
    '	          </div>\n' +
    '	          <div class="mdl-cell mdl-cell--6-col"></div>\n' +
    '\n' +
    '            <div class="mdl-cell mdl-cell--12-col">\n' +
    '              <itec-error-form errors="ctrl.errors[editDocument.id]">\n' +
    '              </itec-error-form>\n' +
    '            </div>\n' +
    '\n' +
    '\n' +
    '	          <div class="mdl-cell mdl-cell--12-col">\n' +
    '	            <itec-button label="DEFAULT_GUARDAR"\n' +
    '	              ng-click-function="ctrl.submitEditForm()"\n' +
    '	              ng-disabled="ctrl.editForm.$invalid">\n' +
    '	            </itec-button>\n' +
    '	\n' +
    '	            <itec-button label="DEFAULT_TORNAR" ng-click-function="ctrl.tornar(0)"></itec-button>\n' +
    '	          </div>\n' +
    '          </div>\n' +
    '        </form>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="mdl-grid" ng-if="ctrl.mode === 2">\n' +
    '  <h5 class="mdl-layout-title">{{::ctrl.labelVersionTitle | translate}}</h5>\n' +
    '  \n' +
    '  <div class="mdl-cell mdl-cell--12-col">\n' +
    '    <md-card>\n' +
    '      <md-card-content>\n' +
    '        <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '          <div ng-repeat="versionDocument in ctrl.listVersionDocuments" class="mdl-cell mdl-cell--12-col">\n' +
    '            <h6>{{versionDocument.titol}}</h6>\n' +
    '            <table class="itec-table">\n' +
    '              <thead>\n' +
    '              <tr>\n' +
    '                <th>{{::\'DEFAULT_DATA_PUBLICACIO\' | translate}}</th>\n' +
    '                <th>{{::\'DEFAULT_USUARI\' | translate}}</th>\n' +
    '                <th>{{::\'DEFAULT_VERSIO\' | translate}}</th>\n' +
    '                <th>{{::\'DEFAULT_ACCIONS\' | translate}}</th>\n' +
    '              </tr>\n' +
    '              </thead>\n' +
    '              <tbody>\n' +
    '                <tr ng-repeat="version in versionDocument.versions">\n' +
    '                  <td>{{::version.dataPublicacio | date}}</td>\n' +
    '                  <td>{{::version.usuariPublicacio}}</td>\n' +
    '                  <td>{{::version.versio}}</td>\n' +
    '                  <td>\n' +
    '                    <button class="mdl-button mdl-js-button mdl-button--icon mdl-button--colored" ng-click="ctrl.downloadDocument(version.id)">\n' +
    '                      <i class="material-icons">file_download</i>\n' +
    '                    </button>\n' +
    '                  </td>\n' +
    '                </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </div>\n' +
    '          \n' +
    '          <div class="mdl-cell mdl-cell--12-col">\n' +
    '            <div class="horizontal_separator"></div>\n' +
    '            <itec-button label="DEFAULT_TORNAR" ng-click-function="ctrl.tornar(0)"></itec-button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="mdl-grid" ng-if="ctrl.mode === 3">\n' +
    '\n' +
    '  <h5 class="mdl-layout-title">{{::ctrl.labelLogTitle | translate}}</h5>\n' +
    '  \n' +
    '  <div class="mdl-cell mdl-cell--12-col">\n' +
    '    <md-card>\n' +
    '      <md-card-content>\n' +
    '        <div class="mdl-grid mdl-grid--no-spacing">\n' +
    '          <div ng-repeat="logDocument in ctrl.listLogDocuments" class="mdl-cell mdl-cell--12-col">\n' +
    '            <h6>{{::logDocument.titol}}</h6>\n' +
    '            <table class="itec-table">\n' +
    '              <thead>\n' +
    '              <tr>\n' +
    '                <th>{{::\'DEFAULT_DATA\' | translate}}</th>\n' +
    '                <th>{{::\'DEFAULT_USUARI\' | translate}}</th>\n' +
    '                <th>{{::\'DEFAULT_VERSIO\' | translate}}</th>\n' +
    '                <th>{{::\'DEFAULT_DESCRIPCIO\' | translate}}</th>\n' +
    '              </tr>\n' +
    '              </thead>\n' +
    '              <tbody>\n' +
    '                <tr ng-repeat="log in logDocument.logs">\n' +
    '                  <td>{{::log.dataLog | date}}</td>\n' +
    '                  <td>{{::log.usuariLog}}</td>\n' +
    '                  <td>{{::log.versioDocument}}</td>\n' +
    '                  <td>{{::log.descripcioLog}}</td>\n' +
    '                </tr>\n' +
    '              </tbody>\n' +
    '            </table>\n' +
    '          </div>\n' +
    '          \n' +
    '          <div class="mdl-cell mdl-cell--12-col">\n' +
    '            <div class="horizontal_separator"></div>\n' +
    '            <itec-button label="DEFAULT_TORNAR" ng-click-function="ctrl.tornar(0)"></itec-button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </md-card-content>\n' +
    '    </md-card>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('rols/main/main.tpl.html',
    '<h2>main</h2>\n' +
    '<p>{{main.ctrlName}}</p>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('productes/main/main.tpl.html',
    '<h2>main</h2>\n' +
    '<p>{{main.ctrlName}}</p>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/main/main.tpl.html',
    '<h2>main</h2>\n' +
    '<p>{{main.ctrlName}}</p>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('usuaris/usuaris.tpl.html',
    ' <div ng-show="ctrl.attr.sides.left.show && ctrl.attr.sides.left.columns > 0" id="tcqi-leftSide" class="mdl-cell--{{ctrl.attr.sides.left.columns}}-col tcqi--with-scroll">\n' +
    '    <div ui-view="leftSide"></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div  id="tcqi-content" \n' +
    '        ng-show="ctrl.attr.content.columns > 0"\n' +
    '        class="mdl-cell--{{ctrl.attr.content.columns}}-col tcqi--with-scroll tcqi-expand-layout-to-bottom">\n' +
    '      <dynamic-submenu class="mdl-grid--no-spacing" permits-object="$root.permisos"></dynamic-submenu>\n' +
    '      <itec-breadcrumb></itec-breadcrumb>\n' +
    '      <div ui-view="content"></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-show="ctrl.attr.sides.right.show && ctrl.attr.sides.right.columns > 0" id="tcqi-rightSide" class="mdl-cell--{{ctrl.attr.sides.right.columns}}-col ">\n' +
    '      <div ui-view="rightSide"></div>\n' +
    '  </div>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('rols/rols.tpl.html',
    ' <div ng-show="ctrl.attr.sides.left.show && ctrl.attr.sides.left.columns > 0" id="tcqi-leftSide" class="mdl-cell--{{ctrl.attr.sides.left.columns}}-col tcqi--with-scroll">\n' +
    '    <div ui-view="leftSide"></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div  id="tcqi-content" \n' +
    '        ng-show="ctrl.attr.content.columns > 0"\n' +
    '        class="mdl-cell--{{ctrl.attr.content.columns}}-col tcqi--with-scroll tcqi-expand-layout-to-bottom">\n' +
    '      <dynamic-submenu class="mdl-grid--no-spacing" permits-object="$root.permisos"></dynamic-submenu>\n' +
    '      <itec-breadcrumb></itec-breadcrumb>\n' +
    '      <div ui-view="content"></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-show="ctrl.attr.sides.right.show && ctrl.attr.sides.right.columns > 0" id="tcqi-rightSide" class="mdl-cell--{{ctrl.attr.sides.right.columns}}-col ">\n' +
    '      <div ui-view="rightSide"></div>\n' +
    '  </div>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('productes/productes.tpl.html',
    ' <div ng-show="ctrl.attr.sides.left.show && ctrl.attr.sides.left.columns > 0" id="tcqi-leftSide" class="mdl-cell--{{ctrl.attr.sides.left.columns}}-col tcqi--with-scroll">\n' +
    '    <div ui-view="leftSide"></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div  id="tcqi-content" \n' +
    '        ng-show="ctrl.attr.content.columns > 0"\n' +
    '        class="mdl-cell--{{ctrl.attr.content.columns}}-col tcqi--with-scroll tcqi-expand-layout-to-bottom">\n' +
    '      <dynamic-submenu class="mdl-grid--no-spacing" permits-object="$root.permisos"></dynamic-submenu>\n' +
    '      <itec-breadcrumb></itec-breadcrumb>\n' +
    '      <div ui-view="content"></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-show="ctrl.attr.sides.right.show && ctrl.attr.sides.right.columns > 0" id="tcqi-rightSide" class="mdl-cell--{{ctrl.attr.sides.right.columns}}-col ">\n' +
    '      <div ui-view="rightSide"></div>\n' +
    '  </div>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('entitats/entitats.tpl.html',
    ' <div ng-show="ctrl.attr.sides.left.show && ctrl.attr.sides.left.columns > 0" \n' +
    '      id="tcqi-leftSide" \n' +
    '      class="mdl-cell--{{ctrl.attr.sides.left.columns}}-col tcqi--with-scroll">\n' +
    '    <div ui-view="leftSide"></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div  id="tcqi-content" \n' +
    '        ng-show="ctrl.attr.content.columns > 0"\n' +
    '        class="mdl-cell--{{ctrl.attr.content.columns}}-col tcqi--with-scroll">\n' +
    '      <dynamic-submenu class="mdl-grid--no-spacing" permits-object="$root.permisos"></dynamic-submenu>\n' +
    '      <itec-breadcrumb></itec-breadcrumb>\n' +
    '      <div ui-view="content"></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-show="ctrl.attr.sides.right.show && ctrl.attr.sides.right.columns > 0" id="tcqi-rightSide" class="mdl-cell--{{ctrl.attr.sides.right.columns}}-col">\n' +
    '      <div ui-view="rightSide"></div>\n' +
    '  </div>');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('ok.html',
    '0');
}]);

angular.module('itecAdministracio').run(['$templateCache', function($templateCache) {
  $templateCache.put('notfound.html',
    '<html>\n' +
    '<head><title>Not Found</title></head>\n' +
    '<body bgcolor="white">\n' +
    '<center><h1>Not Found</h1></center>\n' +
    '<hr><center>itec - tcqi</center>\n' +
    '\n' +
    '<form action="v1/tcqihome/">\n' +
    '	<center>\n' +
    '  	<input type="submit" value="Go to Homepage" />\n' +
    '  </center>\n' +
    '</form>\n' +
    '\n' +
    '</body>\n' +
    '</html>');
}]);

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.llicencies
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.llicencies', [
      'ui.router',
      'itecAdministracio.entitats.main.llicencies.formulari'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.entitats.main.llicencies')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.llicencies.formulari', {
        url: '/formulari',
        params: {
          isNew : false,
          idLlicencia: undefined,
          errorproces: undefined
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["entitatsHeaderSubmenuLinksValue", function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@entitats.main.submain': {
              templateUrl: 'entitats/main/llicencies/formulari/formulari.tpl.html',
              controller: 'EntitatsMainLlicenciesFormulariCtrl',
              controllerAs: 'ctrl'
          }
        },
        resolve: {
          llicenciaData: ["LlicenciaFactory", "$stateParams", "$locale", function(LlicenciaFactory, $stateParams, $locale) {
            if ($stateParams.isNew){
              return {};
            }
            else if (!angular.isUndefined($stateParams.idLlicencia)
                      && $stateParams.idLlicencia !== null
                      && $stateParams.idLlicencia) {
              var form = {
                idioma : $locale.localeID
              };
              return LlicenciaFactory.get($stateParams.idEntitat, $stateParams.idLlicencia, form).catch(function(){});
            }
            else {
              return {};
            }
          }],
          tyksentitatData:["TykFactory", "$stateParams", "$locale", function(TykFactory, $stateParams, $locale) {
            return TykFactory.getTyksEntitat($stateParams.idEntitat).catch(function(){});
          }],
          breadcrumbText: ["$stateParams", function($stateParams){
            if (angular.isUndefined($stateParams.idLlicencia) || $stateParams.idLlicencia === '') {
              return 'BREADCRUMB_FORMULARI_CREACIO';
            }
            else {
              return 'BREADCRUMB_LABEL';
            }
          }]
        },
        breadcrumb: {
          dynamicText: '{{breadcrumbText}}',
          stateName: 'entitats.main.submain.dades.llicenciaFormulari',
          textParam: {paramName: 'label', paramValue: '{{$stateParams.llicenciaData}}'}
        },
      });
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name dades.llicenciaFormulari
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.llicencies.formulari', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name dades.llicenciaFormulari.controller:LlicenciaFormulariCtrl
   *
   * @description
   *
   */
  EntitatsMainLlicenciesFormulariCtrl.$inject = ["LlicenciaFactory", "entitatData", "Notification", "llicenciaData", "$locale", "$rootScope", "$state", "$stateParams", "ProducteBotigaFactory", "tyksentitatData", "AplicacioFactory", "$scope"];
  angular
    .module('itecAdministracio.entitats.main.llicencies')
    .controller('EntitatsMainLlicenciesFormulariCtrl', EntitatsMainLlicenciesFormulariCtrl);

  function EntitatsMainLlicenciesFormulariCtrl(LlicenciaFactory, entitatData, Notification, llicenciaData, $locale, $rootScope, $state, $stateParams, ProducteBotigaFactory,tyksentitatData,AplicacioFactory,$scope) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainLlicenciesFormulariCtrl';

    vm.entitat    = entitatData.data;
    vm.llicencia  = llicenciaData.data;
    vm.onchangeproducte=onchangeproducte;
    vm.tyks=tyksentitatData.data;
    vm.listtyks=[];
    vm.listtyksitec=[];

    for (var i=0;i<vm.tyks.list.length;i++){
      vm.listtyks.push(vm.tyks.list[i]);
    }
    for (var i=0;i<vm.tyks.list.length;i++){
      if (vm.tyks.list[i].esitec){
        vm.listtyksitec.push(vm.tyks.list[i]);
      }
    }
    vm.aplicacions=[];
    if (angular.isUndefined(vm.llicencia)){
      vm.llicencia = {
        entitat : vm.entitat,
        demo:false,
        botiga:false,
        renovacio:false/*,
        numero:1*/
      }
    }


    vm.formulari = {
        nom: 'formulari',
        func: func,
        camps: [
          {
            type: 'select',
            name: 'producte',
            label: 'DEFAULT_PRODUCTE',
            propertyLabel: 'nom',
            required: true,
            columns: 6,
            onChange:onchangeproducte
          },
          {
            type: 'datepicker',
            name: 'caducitat',
            label: 'DEFAULT_DATA_CADUCITAT',
            required: true,
            columns: 6
          },
          {
            type: 'numeric',
            name: 'numero',
            label: 'DEFAULT_NUMERO',
            required: true,
            columns: 3,
            decimalPlaces:0
          },
          {
             type: 'checkbox',
             name: 'botiga',
             label: 'botiga',
             columns: 12
          },
          {
             type: 'checkbox',
             name: 'demo',
             label: 'demo',
             columns: 12
          },
          {
             type: 'checkbox',
             name: 'renovacio',
             label: 'renovacio',
             columns: 12
          }
          ]
      };

    ProducteBotigaFactory.getAll().then(function(response){
      vm.formulari.camps[0].list = [];
      for (var i=0;i<response.data.list.length;i++){
        if ($locale.localeID === response.data.list[i].idioma){
          vm.formulari.camps[0].list.push(response.data.list[i]);
        }
      }
    }).catch(function(error){
      Notification.processError(error);
    });

    vm.errors = [];
    vm.back = back;

    function onchangeproducte(){
      vm.showme = true;
      if (!angular.isUndefined(vm.llicencia.producte)){
        if (!angular.isUndefined(vm.llicencia.producte.id)){

            var promise=AplicacioFactory.getAplicacionsProducte(vm.llicencia.producte.id,$stateParams.idEntitat).then(function (response){
                $scope.$evalAsync(function(){
                vm.aplicacions=[];
                  angular.forEach(response.data.list, function(entrada) {
                    vm.aplicacions.push(entrada);
                  });
                });
              }).catch(function(error){
                vm.errors = Notification.processError(error);
              });
            return promise;
        }
      }
    }

    function func(){
      vm.llicencia.listaplicaciotyk=vm.aplicacions;
      if ($stateParams.isNew){
          var promise=LlicenciaFactory.add($stateParams.idEntitat,vm.llicencia).then(function (response){
            vm.llicencia.id = response.data.id;
            if (!angular.isUndefined(response.data.error)){
                $stateParams.errorproces=response.data.error;
            }
            $state.go('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
          return promise;
      }
      else {
          var promise=LlicenciaFactory.update($stateParams.idEntitat, vm.llicencia.id, vm.llicencia).then(function (response){
             $state.go('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
          return promise;
      }

    }

    function back() {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
      $state.go('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
    }

    if (!angular.isUndefined($stateParams.isNew) && $stateParams.isNew !== null && $stateParams.isNew) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    } else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name usuaris.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main.llista', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name usuaris.llista.controller:LlistaCtrl
   *
   * @description
   *
   */
  UsuarisMainLlistaCtrl.$inject = ["$rootScope", "$scope", "HelperFactory", "Notification", "UsuariFactory", "$window", "$state", "$stateParams", "LogoutFactory", "llistaentitats", "$translate"];
  angular
    .module('itecAdministracio.usuaris.main.llista')
    .controller('UsuarisMainLlistaCtrl', UsuarisMainLlistaCtrl);

  function UsuarisMainLlistaCtrl($rootScope,$scope, HelperFactory, Notification, UsuariFactory, $window, $state, $stateParams,LogoutFactory,llistaentitats,$translate) {
    var vm = this;
    vm.ctrlName = 'UsuarisMainLlistaCtrl';

    vm.calculateListFields = calculateListFields;
    vm.load = load;
    vm.view = view;
    vm.edit=edit;
    vm.deleteUsuari=deleteElem;

    vm.llista = [];
    vm.page = 1;
    vm.perPage = 25;
    vm.pages = 0;
    vm.canLoad = true;
    vm.auxentitatsel=[];
    vm.indexeliminat=-1;

    vm.cercaObj = {
      page : vm.page,
      perPage: vm.perPage,
      pages: vm.pages,
      entitatsel:[],
      username: '',
      identitat:''
    };

   if (!angular.isUndefined(llistaentitats)){
      vm.listallentitat=llistaentitats.data.list;
    }


 function onChangeFunction(){
      vm.cercaObj.identitat=null;
      if (vm.cercaObj.entitatsel!=null){
        if (vm.cercaObj.entitatsel.length>0){
          vm.cercaObj.identitat=vm.cercaObj.entitatsel[0].id;
          vm.searchText = null;
        }
      }
    }

    if ($rootScope.issuperadmin){
      vm.formulari = {
        nom: 'cercador',
        func: function(){
          return cercar();
        },
        camps: [
           {
              type: 'text',
              name: 'username',
              label: 'DEFAULT_USERNAME',
              columns: 4,
              required: false
            },
            {
              type: 'text',
              name: 'entitat',
              label: 'DEFAULT_CODI_client',
              columns: 4,
              required: false
            },
            {
                type: 'chips',
                name: 'entitatsel',
                list:vm.listallentitat,
                master: true,
                fieldProperty: 'nom',
                textPlaceholder: $translate.instant('USUARIENTITAT_CERCA'),
                columns: 4,
                label:"CERCA_ENTITATS",
                onChange :  onChangeFunction,
                mdMaxChips:2
            }            
        ]
      }
    }
    else
    {
       vm.formulari = {
        nom: 'cercador',
        func: function(){
          return cercar();
        },
        camps: [
            {
              type: 'text',
              name: 'username',
              label: 'DEFAULT_USERNAME',
              columns: 6,
              required: false
            }
        ]
      }
    }
    vm.formatter = formatter;
    function formatter(object, field) {
      var css = '';
      if (field === 'username' && (object.deleted || object.fictici) ) {
        css = 'color:#dd2c00;';
      }else if (field === 'username' && !object.confirmat){
        css = 'color:#ffa500;';
      }
      return css;
    };


    function loadUsuaris() {
      if (!angular.isUndefined($rootScope.permisos.LOGIN) && $rootScope.permisos.LOGIN.read){
        vm.auxentitatsel=vm.cercaObj.entitatsel;
        vm.cercaObj.entitatsel=[];
        var promise = UsuariFactory.getAll(vm.cercaObj).then(function(response){
          $scope.$evalAsync(function(){
            vm.cercaObj.pages = response.data.pages;
            vm.cercaObj.page = response.data.page + 1;
            angular.forEach(response.data.list, function(entrada) {
               vm.llista.push(entrada);
            });
          });
        }).catch(function(error){
          Notification.processError(error);
        });
        vm.cercaObj.entitatsel=vm.auxentitatsel;
        return promise;
      }
      else{
        return undefined;
      }
    }

    function cercar(){
      vm.cercaObj.page = 1;
      vm.cercaObj.pages = undefined;
      vm.llista = [];
      return loadUsuaris();
    }

    function load(){
      if (!angular.isUndefined(vm.cercaObj.pages) && (vm.cercaObj.page < (vm.cercaObj.pages + 1)) ) {
        vm.canLoad = false;
        loadUsuaris().then(function(){
          $scope.$evalAsync(function(){
            vm.canLoad = true;
          });
        });
      }
    }

    function calculateListFields(reductedList){
      if (reductedList){
        vm.fields = [
          {
            header: 'DEFAULT_USERNAME',
            type: 'text',
            name: 'username'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];
      } else{
        vm.fields = [
          {
            header: 'DEFAULT_USERNAME',
            type: 'text',
            name: 'username'
          },
          {
            header: 'DEFAULT_ENTITAT',
            type: 'text',
            name: 'nomEntitat'
          },
          {
            header: 'DEFAULT_PRODUCTES',
            type: 'text',
            name: 'rols'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];

      }
    }

    function deleteElem(id) {
      UsuariFactory.delete(id).then(function(response){
        $scope.$evalAsync(function(){
          vm.indexeliminat=-1;
          vm.llista.forEach(function(elem, index) {
            if (elem.id === id){
              if (!$rootScope.issuperadmin){
                vm.llista.splice(index,1);
                vm.indexeliminat=index;
              }
              else{
                vm.llista[index].nomEntitat="";
                vm.llista[index].rols="";
              }
            }
          });

            if ($rootScope.issuperadmin){
              HelperFactory.setParams($stateParams, {'idUsuari': id});
              $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
            }
            else
            {
              if (vm.llista.length==0 )
              {
                HelperFactory.setParams($stateParams, {'idUsuari': null});
                $state.go('usuaris.main', $stateParams, {'reload': 'usuaris.main.submain'});
              }
              else
              {
                if (vm.llista.length==1)
                {
                  view(vm.llista[0]);
                }
                else{
                  if (vm.indexeliminat<vm.llista.length)
                  {
                    view(vm.llista[vm.indexeliminat]);
                  }
                  else
                  {
                    view(vm.llista[vm.indexeliminat-1]);
                  }
                }
              }
            }


        });
      }).catch(function(error){
        console.log(error);
        Notification.processError(error);
      });
    }



    function edit(id) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'isNew': false, 'idUsuari': id});
      $state.go('usuaris.main.submain.edit', $stateParams, {'reload': 'usuaris.main.submain'});
    }

    function view(obj) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'idUsuari': obj.id});
      $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
    }

    $scope.$on('addItemToTree', function(event, data) {
      HelperFactory.setParams($stateParams, {'isNew': true, 'idUsuari': undefined});
      $state.go('usuaris.main.submain.edit', $stateParams);
    });

    cercar();

    /*--------------------------------EVENTS ------------------------------*/

    $scope.$on('changeSides', function(event, data) {
      vm.calculateListFields(!data.left.collapsed && !data.links.collapsed);
    });

    $scope.$on('usuaris.main.delete', function(event, data) {
      deleteElem(data.id);
    });

     $scope.$on('usuaris.main.edit', function(event, data) {
      edit(data.id);
    });


    $scope.$on('usuaris.main.llista.update', function(event, data) {
      vm.llista.forEach(function(obj, index){
        if (obj.id === data.id) {
          var rols="";
          data.rols.forEach(function(obj, index){
            if (rols==""){
              rols =  obj.nom ;
            }
            else
            {
              rols = rols + ", " + obj.nom ;
            }
          });
          var entitats="";
          data.entitats.forEach(function(obj, index){
            if (entitats==""){
              entitats =  obj.nom ;
            }
            else
            {
              entitats = entitats + ", " + obj.nom ;
            }
          });

          obj.username = data.username;
          obj.rols=rols;
          obj.entitats=entitats;

          if (obj.username.indexOf(vm.cercaObj.username) == -1) {
            vm.llista.splice(index, 1);
          }
          Notification.success('GENERIC_SUCCESS');

          return;
        }
      });
    });

    $scope.$on('usuaris.main.llista.add', function(event, data) {
      $stateParams.idUsuari = data.id;
      if (data.username.indexOf(vm.cercaObj.username) != -1) {
          var rols="";
          data.rols.forEach(function(obj, index){
            if (rols==""){
              rols =  obj.nom ;
            }
            else
            {
              rols = rols + ", " + obj.nom ;
            }
          });
          var entitats="";
          data.entitats.forEach(function(obj, index){
            if (entitats==""){
              entitats =  obj.nom ;
            }
            else
            {
              entitats = entitats + ", " + obj.nom ;
            }
          });

          var obj={
            email:data.email,
            id:data.id,
            nomEntitat:entitats,
            rols:rols,
            username:data.username,
            fictici:data.fictici
          };
          vm.llista.push(obj);
      }
      HelperFactory.setParams($stateParams, {'idUsuari': $stateParams.idUsuari});
      $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});

      Notification.success('GENERIC_SUCCESS');
    });

    if (angular.isUndefined($stateParams.idUsuari)){
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
    }


  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.edit
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main.submain.edit', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.usuaris.main.submain.edit')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('usuaris.main.submain.edit', {
        url: '/edit',
         params: {
          isNew : false
        },
      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosUsuarisHeaderSubmenuLinksValue", function(permisosUsuarisHeaderSubmenuLinksValue){
                return permisosUsuarisHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@usuaris.main.submain': {
            templateUrl: 'usuaris/main/edit/edit.tpl.html',
            controller: 'UsuarisMainEditCtrl',
            controllerAs: 'ctrl'  ,
            resolve: {
              llistaproductes:["ProducteBotigaFactory", function(ProducteBotigaFactory) {
                return ProducteBotigaFactory.getProductesBotigaEntitats().catch(function(){});
              }],
              llistarols: ["RolFactory", function(RolFactory) {
                return RolFactory.getAll().catch(function(){});
              }],
              llistaentitats:["EntitatFactory", function(EntitatFactory) {
                return EntitatFactory.getAll().catch(function(){});
              }],
              usuariData: ["UsuariFactory", "$stateParams", function(UsuariFactory, $stateParams) {
                if ($stateParams.isNew){
                  return {};
                }
                else if (!angular.isUndefined($stateParams.idUsuari)
                          && $stateParams.idUsuari !== null
                          && $stateParams.idUsuari) {
                  return UsuariFactory.get($stateParams.idUsuari).catch(function(){});
                }
                else {
                  return {};
                }
              }]
            }
          }
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name agents.edit.controller:EditCtrl
   *
   * @description
   *
   */
  UsuarisMainEditCtrl.$inject = ["$scope", "usuariData", "$translate", "$state", "$window", "llistarols", "$rootScope", "$stateParams", "UsuariFactory", "Notification", "llistaentitats", "llistaproductes", "HelperFactory"];
  angular
    .module('itecAdministracio.usuaris.main.submain.edit')
    .controller('UsuarisMainEditCtrl', UsuarisMainEditCtrl);

  function UsuarisMainEditCtrl($scope,usuariData,$translate,$state,$window,llistarols, $rootScope,$stateParams,UsuariFactory,Notification,llistaentitats,llistaproductes,HelperFactory) {
    var vm = this;
    var vm = this;
    vm.ctrlName = 'UsuarisMainEditCtrl';
    vm.usuari=usuariData.data;
    vm.showtransclude=true;
    vm.isNew =angular.isUndefined(vm.usuari);
    vm.selectedItemChip=null;
    vm.deletedItemChip=null;

    //llista de tots els productesbotiga de totes les entitats
    vm.productesbotiga=llistaproductes.data.list;
    //llista de totes les entitats
    vm.listallentitat=llistaentitats.data.list;
    vm.formularispan=5;
    vm.formularibotiga=6;
    vm.formularirols=7;
    vm.entitatselected=null;
    vm.identitatselected=null;
    vm.textchipproducte=$translate.instant('ENTITATPRODUCTE_CERCA');
    vm.nomentitatselected='';

    if (!angular.isUndefined(vm.usuari)) {
     if (vm.usuari.confirmat && !vm.usuari.deleted){
          vm.estatusuari= $translate.instant('USUARI_CONFIRMAT_TITOL'); 
      }else if (vm.usuari.deleted || vm.usuari.fictici){
        vm.estatusuari= $translate.instant('USUARI_NO_REGISTRAT_TITOL');
        vm.colorestat='color-vermell';
      }else if((!vm.usuari.deleted && !vm.usuari.fictici && !vm.usuari.confirmat)){
        vm.estatusuari= $translate.instant('USUARI_NO_CONFIRMAT_TITOL');
        vm.colorestat='color-groc';
      }
    }

    if (angular.isUndefined(vm.usuari)) {
        vm.showtransclude=false;
        vm.usuari = {entitats:[],rolsbyent:[],rols:[],productes:[],productesbyent:[]};
        if (!$rootScope.issuperadmin){
          if (llistaentitats.data.list.length>0){
            vm.usuari.entitats.push(llistaentitats.data.list[0]);
          }
        }
    }

    if (!angular.isUndefined(vm.usuari)) {
      if (vm.usuari.entitats.length>0){
          selectEntitatChip(0);
          vm.usuari.rolsbyent=vm.usuari.rols.filter(createFilterByEntitat(vm.identitatselected));
          productesBotigaByEntitatAssignats();
      }
    }
//Actualitza la llista de productes botiga assignats segons els rols
    function productesBotigaByEntitatAssignats() {
      if (vm.productesbotiga!=null){
          var listprodbotbyent=vm.productesbotiga.filter(createFilterByEntitat(vm.identitatselected));
          vm.usuari.productesbyent=[];
          //productebotiga de l'entitat
          for(var j = 0; j<listprodbotbyent.length;j++){
            var numprod=0;
            for(var i = 0; i<listprodbotbyent[j].idsproductesprincipals.length;i++){
                var idprod=listprodbotbyent[j].idsproductesprincipals[i];
                for(var k = 0; k<vm.usuari.rolsbyent.length;k++){
                  if(vm.usuari.rolsbyent[k].idproducte=== idprod){
                    numprod++;
                    break;
                  }
                }
              }
              if (numprod>0 && numprod===listprodbotbyent[j].idsproductesprincipals.length){
                  vm.usuari.productesbyent.push(listprodbotbyent[j]);
              }
          }
      }
    }


    vm.listallrolsentitat= llistarols.data.list.filter(createFilterByEntitat(vm.identitatselected));
    vm.productesbotigabyent=[];
    if (vm.productesbotiga!=null){
      vm.productesbotigabyent= vm.productesbotiga.filter(createFilterByEntitat(vm.identitatselected));
    }



    vm.onChangeFunction = onChangeFunction;
    function onChangeFunction(){
      vm.formulari.camps[vm.formularirols].list=llistarols.data.list.filter(createFilterByEntitat(vm.identitatselected));
      vm.formulari.camps[vm.formularibotiga].list=vm.productesbotiga.filter(createFilterByEntitat(vm.identitatselected));
        //si hi ha menys entitats de les originals haurem d'eliminar de la llista de rols ja
        //seleccionats el rols que de les entitats eliminades
           var trobat=false;
           for (var i = 0; i < vm.usuari.rols.length; i++){
              for (var j = 0; j < vm.usuari.entitats.length; j++){
                if (vm.usuari.rols[i].identitat === vm.usuari.entitats[j].id){
                  trobat =true;
                  break;
                }
              }
              if (!trobat)
              {
                  vm.usuari.rols.splice(i,1);
                  i--;
              }
              trobat=false;
            }
            var listrolbyent=vm.usuari.rols.filter(createFilterByEntitat(vm.identitatselected));
            vm.usuari.rolsbyent=listrolbyent;
            vm.formulari.camps[vm.formularirols].list=llistarols.data.list.filter(createFilterByEntitat(vm.identitatselected));
            productesBotigaByEntitatAssignats();
          //  selectEntitatChip(vm.identitatselected)
      }


      vm.onChangeRolFunction = onChangeRolFunction;
      function onChangeRolFunction(){
        for (var i = 0; i < vm.usuari.rols.length; i++){
          if (vm.usuari.rols[i].identitat===vm.identitatselected) {
                if (vm.usuari.rolsbyent.indexOf(vm.usuari.rols[i])===-1 ){
                  vm.usuari.rols.splice(i,1);
                }
           }
         }
         for (var i = 0; i <vm.usuari.rolsbyent.length; i++){
              if (vm.usuari.rols.indexOf(vm.usuari.rolsbyent[i])===-1 ){
                vm.usuari.rols.push(vm.usuari.rolsbyent[i]);
              }
          }
          productesBotigaByEntitatAssignats();
          onSelectFunction(vm.entitatselected);
      }

      vm.onSelectFunction = onSelectFunction;
      function onSelectFunction(chip){

        if (!angular.isUndefined(chip)){
            vm.identitatselected=chip.id;
            vm.entitatselected=chip;
            vm.formulari.camps[vm.formularispan].text=chip.nom;
            var listrolbyent=llistarols.data.list.filter(createFilterByEntitat(vm.identitatselected));
            vm.formulari.camps[vm.formularirols].list=listrolbyent;
            vm.usuari.rolsbyent=[];
            for(var j = 0; j<vm.usuari.rols.length;j++){
              if (vm.usuari.rols[j].identitat===vm.identitatselected){
                  vm.usuari.rolsbyent.push(vm.usuari.rols[j]);
              }
            }
            vm.formulari.camps[vm.formularibotiga].list=vm.productesbotiga.filter(createFilterByEntitat(vm.identitatselected));
            productesBotigaByEntitatAssignats();
        }

      }

      vm.onDeleteProducteFunction = onDeleteProducteFunction;
      function onDeleteProducteFunction(chip){
          var prodbotigaeliminat=chip;
          var productesusuari=[];
          var idsprodeliminar=[];
          var listrolsfinal=[];

          for (var j=0;j<vm.usuari.productesbyent.length;j++){
            for (var i=0;i<vm.usuari.productesbyent[j].idsproducte.length;i++){
              productesusuari.push(vm.usuari.productesbyent[j].idsproducte[i]);
            }
          }
          for(var i=0;i<prodbotigaeliminat.idsproducte.length;i++)
          {
            if (productesusuari.indexOf(prodbotigaeliminat.idsproducte[i])===-1){
              idsprodeliminar.push(prodbotigaeliminat.idsproducte[i]);
            }
          }
          for (var j=0;j<vm.usuari.rols.length;j++){
            if ((vm.usuari.rols[j].identitat===vm.identitatselected &&
              idsprodeliminar.indexOf(vm.usuari.rols[j].idproducte)===-1)
            || vm.usuari.rols[j].identitat!==vm.identitatselected ){
                listrolsfinal.push(vm.usuari.rols[j]);
            }
          }

          vm.usuari.rols=listrolsfinal;
          vm.usuari.rolsbyent=listrolsfinal.filter(createFilterByEntitat(vm.identitatselected));
      }

      vm.onAddProducteFunction = onAddProducteFunction;
      function onAddProducteFunction(chip){
        var prodbotigaafegit=chip;
        var prodassignats=[];
        var llistarolsbyent=llistarols.data.list.filter(createFilterByEntitat(vm.identitatselected));

        for(var j=0;j<vm.usuari.rolsbyent.length;j++){
            prodassignats.push(vm.usuari.rolsbyent[j].idproducte);
        }

        for(var i =0;i<prodbotigaafegit.idsproducte.length;i++){
          if (prodassignats.indexOf(prodbotigaafegit.idsproducte[i])===-1){
            for (var k =0;k<llistarolsbyent.length;k++){
                  if(llistarolsbyent[k].idproducte===prodbotigaafegit.idsproducte[i] && llistarolsbyent[k].inicial){
                    vm.usuari.rols.push(llistarolsbyent[k]);
                    vm.usuari.rolsbyent.push(llistarolsbyent[k]);
                    break;
                  }
              }
          }
        }
      }

      function createFilterByEntitat(identitatselected) {
           return function filterFn(item) {
                 if (item.identitat === identitatselected){
                    if (!$rootScope.issuperadmin && item.liccaducada){
                        return false;
                    }
                    else{ 
                       return true;
                    }
                 }
                 return false;
             };
       }

       function selectEntitatChip(index)
       {
          if(vm.usuari.entitats.length>0){
            vm.selectedItemChip=vm.usuari.entitats[index];
            vm.identitatselected=vm.usuari.entitats[index].id;
            vm.nomentitatselected=vm.usuari.entitats[index].nom;
          }
       }


    //idioma que ha seleccionat l'usuari al registre
     vm.idiomaList = [{id:0, name: $translate.instant('DEFAULT_CATALA')},
                    {id:1, name: $translate.instant('DEFAULT_ESPANYOL')},
                    {id:2, name: $translate.instant('DEFAULT_ANGLES')}];

    if (!vm.isNew){
        if(vm.usuari.idioma!=null){
          vm.usuari.idiomaObj = vm.idiomaList[vm.usuari.idioma];
        }
        else
        {
          vm.usuari.idiomaObj=vm.idiomaList[0];
        }
    }



    vm.idUsuari = $stateParams.idUsuari;
    vm.errors = [];

    //functions
    vm.back = back;
    vm.notificarregistre=notificarregistre;
    vm.notificarconfirmar=notificarconfirmar;
    vm.readonlylistentitat=!$rootScope.issuperadmin;

    vm.formulari = {
      nom: 'formulariUsuari',
      func: func,
      camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              required: false,
              columns: 6,
              maxLength: 200,
              disabled:!vm.isNew && !$rootScope.issuperadmin
            },
            {
              type: 'text',
              name: 'cognom',
              label: 'DEFAULT_COGNOM',
              required: false,
              columns: 6,
              maxLength: 200,
              disabled:!vm.isNew && !$rootScope.issuperadmin
            },
            {
              type: 'text',
              name: 'username',
              label: 'DEFAULT_USERNAME',
              required: true,
              columns: 6,
              maxLength: 255,
              disabled:!vm.isNew && !$rootScope.issuperadmin
            },
            {
              type: 'select',
              name: 'idiomaObj',
              propertyLabel: 'name',
              propertyId: 'id',
              label: 'DEFAULT_IDIOMA',
              list: vm.idiomaList ,
              columns: 6,
              required: true,
              disabled:!vm.isNew && !$rootScope.issuperadmin
            },
             {
              type: 'chips',
              name: 'entitats',
              list:vm.listallentitat,
              onChange: onChangeFunction,
              onSelect: onSelectFunction,
              fieldProperty: 'nom',
              textPlaceholder: $translate.instant('USUARIENTITAT_CERCA'),
              createNew: false,
              columns: 12,
              readonly:vm.readonlylistentitat,
              label:"Cerca entitats",
              mdMinLenght:0,
              mdSeletedItem:vm.selectedItemChip
            },
            {
             type: 'span',
             show:true,
             text:vm.nomentitatselected,
             classText:'span-color-title'
            },
            {
              type: 'chips',
              name: 'productesbyent',
              list:vm.productesbotigabyent ,
              onDelete: onDeleteProducteFunction,
              onAdd: onAddProducteFunction,
              fieldProperty: 'nom',
              textPlaceholder: $translate.instant('ENTITATPRODUCTE_CERCA'),
              createNew: false,
              columns: 12,
              readonly:false,
              label:"Cerca productes",
              mdMinLenght:0,
              mdSeletedItem:vm.selectedItemProdBotigaChip,
              mdDeletedItem:vm.deletedItemChip
            },
            {
              type: 'chips',
              name: 'rolsbyent',
              list:vm.listallrolsentitat,
              onChange: onChangeRolFunction,
              fieldProperty: 'nom',
              textPlaceholder: $translate.instant('USUARIROL_CERCA'),
              createNew: false,
              columns: 12,
              readonly:false,
              label:"Cerca entitats",
              mdMinLenght:0
            },
            {
              type: 'text',
              name: 'accesdata',
              label: 'DEFAULT_DATA_ACCES',
              required: false,
              columns: 6,
              maxLength: 255,
              disabled:true
            },
            {
              type: 'text',
              name: 'accesip',
              label: 'DEFAULT_IP_ACCES',
              required: false,
              columns: 6,
              maxLength: 255,
              disabled:true
            },
            {
              type: 'checkbox',
              name: 'infoitec',
              label: 'USUARI_INFOITEC',
              required: false,
              columns: 12,
              disabled:!vm.isNew && !$rootScope.issuperadmin
            }, 
            {
              type: 'checkbox',
              name: 'confirmat',
              label: 'USUARI_CONFIRMAT_EDIT',
              required: false,
              columns: 12,
              disabled: vm.isNew || !$rootScope.issuperadmin || vm.usuari.fictici==true
            },
              {
              type: 'multiTransclude',
              block: 'notificar-registre-button',
              columns: 6,
              show:vm.showtransclude
            },
            {
              type: 'multiTransclude',
              block: 'notificar-deleted-button',
              columns: 12,
              show:vm.showtransclude
            },
            {
              type: 'multiTransclude',
              block: 'notificar-confirmar-button',
              columns: 12,
              show:vm.showtransclude
            }
      ]
    };

    function func() {
      vm.usuari.idioma =vm.usuari.idiomaObj.id;
      if (vm.isNew) {
        return createNew();
      }
      else {
        return edit();
      }
    }

    function createNew() {
      var promise=UsuariFactory.add(vm.usuari).then(function (response) {
        vm.usuari.id = response.data;
        vm.usuari.fictici=true;
        $rootScope.$broadcast('usuaris.main.llista.add', vm.usuari);
        HelperFactory.setParams($stateParams, {'idUsuari': response.data});
        $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
         if(vm.usuari.idioma!=null){
            vm.usuari.idiomaObj = vm.idiomaList[vm.usuari.idioma];
          }
          else
          {
            vm.usuari.idiomaObj=vm.idiomaList[0];
          }
      });
      return promise;
    }

    function edit() {
      var promise=UsuariFactory.update(vm.idUsuari, vm.usuari).then(function (response){
      $rootScope.$broadcast('usuaris.main.llista.update', vm.usuari);
      $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
         if(vm.usuari.idioma!=null){
            vm.usuari.idiomaObj = vm.idiomaList[vm.usuari.idioma];
          }
          else
          {
            vm.usuari.idiomaObj=vm.idiomaList[0];
          }
      });
      return promise;
    }

    function back() {
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
      if (vm.isNew) {
        $state.go('usuaris.main', $stateParams, {'reload': 'usuaris.main.submain'});
      }
      else {
        $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
      }
    }

    function notificarregistre() {
      UsuariFactory.avisregistre(vm.idUsuari).then(function (response){
      Notification.success('SUCCESS_AVIS_REGISTRE');
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }

    function notificarconfirmar() {
      UsuariFactory.avisconfirmar(vm.idUsuari).then(function (response){
      Notification.success('SUCCESS_AVIS_CONFIRMAR');
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }


    if (vm.isNew) {
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': true});
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.dades
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main.submain.dades', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.usuaris.main.submain.dades')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('usuaris.main.submain.dades', {
        url: '/dades',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosUsuarisHeaderSubmenuLinksValue", function(permisosUsuarisHeaderSubmenuLinksValue){
                return permisosUsuarisHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@usuaris.main.submain': {
            templateUrl: 'usuaris/main/dades/dades.tpl.html',
            controller: 'UsuarisMainDadesCtrl',
            controllerAs: 'ctrl',
            resolve: {
              usuariData: ["UsuariFactory", "$stateParams", function(UsuariFactory, $stateParams) {
                if ($stateParams.isNew){
                  return {};
                }
                else if (!angular.isUndefined($stateParams.idUsuari)
                          && $stateParams.idUsuari !== null
                          && $stateParams.idUsuari) {
                  return UsuariFactory.getview($stateParams.idUsuari).catch(function(){});
                }
                else {
                  return {};
                }
              }]
            }
          }
        },
        breadcrumb: 'DEFAULT_DADES_GENERALS'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.dades.controller:DadesCtrl
   *
   * @description
   *
   */
  UsuarisMainDadesCtrl.$inject = ["usuariData", "$window", "$rootScope", "$stateParams", "$state", "HelperFactory", "UsuariFactory", "$scope", "Notification"];
  angular
    .module('itecAdministracio.usuaris.main.submain.dades')
    .controller('UsuarisMainDadesCtrl', UsuarisMainDadesCtrl);

  function UsuarisMainDadesCtrl(usuariData,$window, $rootScope,$stateParams,$state,HelperFactory,UsuariFactory,$scope,Notification) {
    var vm = this;
    vm.ctrlName = 'UsuarisMainDadesCtrl';
    vm.usuari=usuariData.data;

    //functions
    vm.changeToForm = changeToForm;
    vm.deleteElem = deleteElem;
    vm.viewProductesEntitat=viewProductesEntitat;
    vm.renew=renew;
    vm.unlock=unlock;

    function renew(idproducte,tipusclient,versio) {
      UsuariFactory.renew(vm.usuari.id,idproducte,tipusclient,versio).then(function(response){
        $scope.$evalAsync(function(){
          $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
        });
      }).catch(function(error){
        console.log(error);
        Notification.processError(error);
      });
    }
    
    function unlock() {
      UsuariFactory.unlock(vm.usuari.id).then(function(response){
        $scope.$evalAsync(function(){
          $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
        });
      }).catch(function(error){
        console.log(error);
        Notification.processError(error);
      });
    }
    

    function deleteElem() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('usuaris.main.delete', vm.usuari);
    }

    function changeToForm() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('usuaris.main.edit', vm.usuari);
    }
   

   if (angular.isUndefined($stateParams.idUsuari) || $stateParams.idUsuari === null || !$stateParams.idUsuari) {
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
      $state.go('usuaris.main', $stateParams, {'reload': 'usuaris.main.submain'});
    }
    else {
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': true});
    }

    function viewProductesEntitat(identitat) {
      HelperFactory.setParams($stateParams, {'idEntitat': identitat});

      if(!angular.isUndefined($rootScope.permisos.PRODUCTEENTMENU) && $rootScope.permisos.PRODUCTEENTMENU.read){
              var url = $state.href('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if (!angular.isUndefined($rootScope.permisos.ENTITATMENU) && $rootScope.permisos.ENTITATMENU.read){
              var url = $state.href('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
      }
      
      $window.open(url,'_blank');
    }

  } 
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name subsistemes.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.submain.permisos', [
      'ui.router'
    ]);
}());
(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.rols.main.submain.permisos')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('rols.main.submain.permisos', {
        url: '/permisos',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosRolsHeaderSubmenuLinksValue", function(permisosRolsHeaderSubmenuLinksValue){
                return permisosRolsHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@rols.main.submain': {
            templateUrl: 'rols/main/permisos/permisos.tpl.html',
            controller: 'RolsMainPermisosCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_ROLS_PERMISOS'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name rols.permisos.controller:RolsMainPermisosCtrl
   *
   * @description
   *
   */
 RolsMainPermisosCtrl.$inject = ["$window", "$rootScope", "HelperFactory", "ItecTreeTracking", "TemaFactory", "Notification", "$scope", "$q", "$state", "$stateParams", "rolData", "RolFactory"];
  angular
    .module('itecAdministracio.rols.main.submain.permisos')
    .controller('RolsMainPermisosCtrl', RolsMainPermisosCtrl);

  function RolsMainPermisosCtrl($window, $rootScope, HelperFactory, ItecTreeTracking, TemaFactory, Notification, $scope, $q, $state, $stateParams,rolData,RolFactory) {
      var vm = this;
      vm.ctrlName = 'RolsMainPermisosCtrl';
      vm.rol=rolData.data;

      vm.children                 = [];
      vm.expandedCollection       = [];
      vm.loadChildren             = loadChildren;
      vm.treeTracking             = ItecTreeTracking.newInstance();
      vm.loadBasicTree            = loadBasicTree;
      vm.rootTreeNodeCollection   = [];
      vm.loadBasicTree();
      vm.back = back;
      vm.func= func;
      vm.errors = [];

      vm.onChangeReadTheme=onChangeReadTheme;
      vm.onChangeDeleteTheme=onChangeDeleteTheme;
      vm.onChangeEditTheme=onChangeEditTheme;
      vm.onChangeAddTheme=onChangeAddTheme;


      function loadBasicTree(){
        TemaFactory.gettemesvistesarrel(vm.rol.id).then(function(response) {
          $scope.$evalAsync(function(){
            if (response.data.temes.length > 0) {
              response.data.temes.forEach(function(elem){
                vm.rootTreeNodeCollection.push(elem);
                loadChildren(elem);
              });
            }
          });
        });
      }

      function filterNode(){
        return true;
      }

      function loadChildren(object) {
        if (object === undefined) {
          return [];
        }
        var deferred = $q.defer();
        if(object.children===null)
        {
          if (object.type === 'tema'){
            TemaFactory.getfills(object.id,vm.rol.id).then(function(response){
              $scope.$evalAsync(function(){
                object.children = response.data.temes.concat(response.data.objectes);
                angular.forEach(object.children, function(obj, index){
                  if (object.read) obj.read=object.read;
                  if (object.add) obj.add = object.add;
                  if (object.delete) obj.delete = object.delete;
                  if (object.edit) obj.edit = object.edit;
                  if (obj.type === 'vista') {
                    vm.rol.vistes.push(obj);
                  }
                });
                deferred.resolve(object.children);
              });
            });
          }
        }
        else{
            deferred.resolve(object.children);
        }
        return deferred.promise;
      }

      function onChangeReadTheme(object)
      {
        if (object.read){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.read = object.read;
            if (child.type === 'tema'){
              onChangeReadTheme(child);
            }
          });
        }
      }

 function onChangeAddTheme(object)
      {
        if (object.add){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.add = object.add;
            if (child.type === 'tema'){
              onChangeAddTheme(child);
            }
          });
        }
      }

 function onChangeDeleteTheme(object)
      {
        if (object.delete){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.delete = object.delete;
            if (child.type === 'tema'){
              onChangeDeleteTheme(child);
            }
          });
        }
      }

 function onChangeEditTheme(object)
      {
        if (object.edit){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.edit = object.edit;
            if (child.type === 'tema'){
              onChangeEditTheme(child);
            }
          });
        }
      }

      function back() {
        $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
        if ($stateParams.isNew) {
          $state.go('rols.main', $stateParams, {'reload': 'rols.main.submain'});
        }
        else {
          $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
        }
      }

      function func() {
        edit();
      }


      function edit() {
        $rootScope.$broadcast('$activateLoader');
        RolFactory.updateacls(vm.rol.id, vm.rol).then(function (response){
        $rootScope.$broadcast('$deactivateLoader');
        $rootScope.$broadcast('rols.main.submain.permisos', vm.rol);
        $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain.permisos'});
        }).catch(function(error){
          $rootScope.$broadcast('$deactivateLoader');
          vm.errors = Notification.processError(error);
        });
      }


 }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name rols.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.llista', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name rols.llista.controller:LlistaCtrl
   *
   * @description
   *
   */
  RolsMainLlistaCtrl.$inject = ["$translate", "$rootScope", "$scope", "HelperFactory", "Notification", "RolFactory", "$window", "$state", "$stateParams", "llistaentitats"];
  angular
    .module('itecAdministracio.rols.main.llista')
    .controller('RolsMainLlistaCtrl', RolsMainLlistaCtrl);

  function RolsMainLlistaCtrl($translate,$rootScope,$scope, HelperFactory, Notification, RolFactory, $window, $state, $stateParams,llistaentitats) {
    var vm = this;
    vm.ctrlName = 'RolsMainLlistaCtrl';

    vm.calculateListFields = calculateListFields;
    vm.load = load;
    vm.view = view;
    vm.edit=edit;
    vm.deleteRols=deleteElem;
    vm.duplicate = duplicate;

    vm.llista = [];
    vm.page = 1;
    vm.perPage = 25;
    vm.pages = 0;
    vm.canLoad = true;
    vm.errors=[];
    vm.auxentitatsel=[];

    vm.issuperadmin= $rootScope.issuperadmin;

    vm.cercaObj = {
      page : vm.page,
      perPage: vm.perPage,
      pages: vm.pages,
      nom: '',
      entitatsel:[],
      identitat:''
    };


    if (!angular.isUndefined(llistaentitats)){
      vm.listallentitat=llistaentitats.data.list;
    }

    function onChangeFunction(){
      vm.cercaObj.identitat=null;
      if (vm.cercaObj.entitatsel!=null){
        if (vm.cercaObj.entitatsel.length>0){
          vm.cercaObj.identitat=vm.cercaObj.entitatsel[0].id;
        }
      }
    }

    if ($rootScope.issuperadmin){
      vm.formulari = {
        nom: 'cercador',
        func: function(){
          cercar();
        },
        camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              columns: 6,
              required: false
            }
            ,
            {
                type: 'chips',
                name: 'entitatsel',
                list:vm.listallentitat,
                master: true,
                fieldProperty: 'nom',
                textPlaceholder: $translate.instant('USUARIENTITAT_CERCA'),
                columns: 6,
                label:"CERCA_ENTITATS",
                onChange :  onChangeFunction,
                mdMaxChips:2
            }
          ]
        }
      }
      else
      {
      vm.formulari = {
        nom: 'cercador',
        func: function(){
          cercar();
        },
        camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              columns: 6,
              required: false
            }]
        }
      }

 vm.formatter = formatter;
    function formatter(object, field) {
      var css = '';
      if (field === 'nom' && (object.liccaducada) ) {
        css = 'color:#dd2c00;';
      }
      return css;
    };




    function loadRols() {
      if (!angular.isUndefined($rootScope.permisos) && $rootScope.permisos.ROL.read){
       vm.auxentitatsel=vm.cercaObj.entitatsel;
        vm.cercaObj.entitatsel=[];
        var promise = RolFactory.getAll(vm.cercaObj).then(function(response){
          $scope.$evalAsync(function(){
            vm.cercaObj.pages = response.data.pages;
            vm.cercaObj.page = response.data.page + 1;
            angular.forEach(response.data.list, function(entrada) {
              if(vm.issuperadmin || !entrada.liccaducada){
                vm.llista.push(entrada);
              }
            });
          });
        }).catch(function(error){
          Notification.processError(error);
        });
        vm.cercaObj.entitatsel=vm.auxentitatsel;
        return promise;
      }
      else
      {
        return undefined;
      }
    }

    function cercar(){
      vm.cercaObj.page = 1;
      vm.cercaObj.pages = undefined;
      vm.llista = [];
      loadRols();
    }

    function load(){
      if (!angular.isUndefined(vm.cercaObj.pages) && (vm.cercaObj.page < (vm.cercaObj.pages + 1)) ) {
        vm.canLoad = false;
        loadRols().then(function(){
          $scope.$evalAsync(function(){
            vm.canLoad = true;
          });
        });
      }
    }

    function calculateListFields(reductedList){
      if (reductedList){
        vm.fields = [
          {
            header: 'DEFAULT_NOM',
            type: 'text',
            name: 'nom'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];
      } else{
        vm.fields = [
          {
            header: 'DEFAULT_NOM',
            type: 'text',
            name: 'nom'
          },
          {
            header: 'DEFAULT_ENTITAT',
            type: 'text',
            name: 'nomentitat'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];

      }
    }



    function deleteElem(id) {
      $rootScope.$broadcast('$activateLoader');
      RolFactory.delete(id).then(function(response){
        $scope.$evalAsync(function(){
          /*if (id === $stateParams.idRol) {
            HelperFactory.setParams($stateParams, {'idRol': null});
            $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
          }*/

          vm.llista.forEach(function(elem, index) {
            if (elem.id === id){
                vm.llista.splice(index,1);
                vm.indexeliminat=index;
            }
          });
          if (vm.llista.length==0 )
          {
            HelperFactory.setParams($stateParams, {'idRol': null});
            $state.go('rols.main', $stateParams, {'reload': 'rols.main.submain'});
          }
          else
          {
            if (vm.llista.length==1)
            {
              view(vm.llista[0]);
            }
            else{
              if (vm.indexeliminat<vm.llista.length)
              {
                view(vm.llista[vm.indexeliminat]);
              }
              else
              {
                view(vm.llista[vm.indexeliminat-1]);
              }
            }
          }

        });
      $rootScope.$broadcast('$deactivateLoader');
      }).catch(function(error){
        $rootScope.$broadcast('$deactivateLoader');
        Notification.processError(error);
      });
    }




    function duplicate(id){
      $rootScope.$broadcast('$activateLoader');
      RolFactory.duplicate(id).then(function(response){
        cercar();
        $rootScope.$broadcast('$deactivateLoader');
      }).catch(function(error){
        $rootScope.$broadcast('$deactivateLoader');
        Notification.processError(error);
      });
    }

    function edit(id) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'isNew': false, 'idRol': id});
      $state.go('rols.main.submain.edit', $stateParams, {'reload': 'rols.main.submain'});
    }

    function view(obj) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'idRol': obj.id});
      $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
    }

     $scope.$on('addItemToTree', function(event, data) {
      HelperFactory.setParams($stateParams, {'isNew': true, 'idRol': undefined});
      $state.go('rols.main.submain.edit', $stateParams);
    });

    cercar();

    /*--------------------------------EVENTS ------------------------------*/

    $scope.$on('changeSides', function(event, data) {
      vm.calculateListFields(!data.left.collapsed && !data.links.collapsed);
    });

    $scope.$on('rols.main.delete', function(event, data) {
      deleteElem(data.id);
    });

     $scope.$on('rols.main.edit', function(event, data) {
      edit(data.id);
    });


    $scope.$on('rols.main.llista.update', function(event, data) {
      vm.llista.forEach(function(obj, index){
        if (obj.id === data.id) {
          obj.nom = data.nom;

          if (obj.nom.indexOf(vm.cercaObj.nom) == -1) {
            vm.llista.splice(index, 1);
          }
          Notification.success('GENERIC_SUCCESS');

          return;
        }
      });
    });

    $scope.$on('rols.main.llista.add', function(event, data) {
      $stateParams.idRol = data.id;
        if (vm.cercaObj.identitat== data.entitat[0].id ||vm.cercaObj.identitat==null ||vm.cercaObj.identitat=="" ){
          if (data.nom.indexOf(vm.cercaObj.nom) != -1 )  {
          vm.llista.push(data);
          }
        }

      view(data);
      Notification.success('GENERIC_SUCCESS');
    });

    if (angular.isUndefined($stateParams.idRol)){
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.edit
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.submain.edit', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.rols.main.submain.edit')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('rols.main.submain.edit', {
        url: '/edit',
         params: {
          isNew : false
        },
      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosRolsHeaderSubmenuLinksValue", function(permisosRolsHeaderSubmenuLinksValue){
                return permisosRolsHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@rols.main.submain': {
            templateUrl: 'rols/main/edit/edit.tpl.html',
            controller: 'RolsMainEditCtrl',
            controllerAs: 'ctrl'  ,
            resolve: {
              llistaproductes: ["ProducteFactory", function(ProducteFactory) {
                return ProducteFactory.getProductesEntitats().catch(function(){});
              }],
              llistaentitats:["EntitatFactory", function(EntitatFactory) {
                return EntitatFactory.getAll().catch(function(){});
              }]
            }
          }
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name agents.edit.controller:EditCtrl
   *
   * @description
   *
   */
  RolsMainEditCtrl.$inject = ["$scope", "rolData", "$translate", "$state", "$window", "$rootScope", "$stateParams", "RolFactory", "Notification", "llistaentitats", "llistaproductes"];
  angular
    .module('itecAdministracio.rols.main.submain.edit')
    .controller('RolsMainEditCtrl', RolsMainEditCtrl);

  function RolsMainEditCtrl($scope,rolData,$translate,$state,$window, $rootScope,$stateParams,RolFactory,Notification,llistaentitats,llistaproductes) {
    var vm = this;
     var vm = this;
    vm.ctrlName = 'RolsMainEditCtrl';
    vm.rol=rolData.data;
    vm.isNew =angular.isUndefined(vm.rol);

    if (angular.isUndefined(vm.rol)) {
        vm.rol = {entitat:[],producte:[]};
        if (!$rootScope.issuperadmin){
          if (llistaentitats.data.list.length>0){
            vm.rol.entitat.push(llistaentitats.data.list[0]);
          }
        }
    }

    vm.listallentitat=llistaentitats.data.list;
    //filtre dels productes segons les entitats seleccionades
    if (llistaproductes.data.list!=null )
    {
      vm.listallproductesentitat= llistaproductes.data.list.filter(createFilterFor());
    }
    else
    {
      vm.listallproductesentitat=[]; 
    }
    

     function createFilterFor() {
          return function filterFn(item) {
            if (item.identitat === null){
              //seguretat per exemple te entitat null
              return true;
            }
            else if(vm.rol.entitat!=null){
              if (vm.rol.entitat.length>0){
                if (item.identitat === vm.rol.entitat[0].id){
                  return true;
                }
              }
            }
            return false;
            };
        }

    vm.onChangeFunction = onChangeFunction;
    function onChangeFunction(){
      vm.formulari.camps[2].list=llistaproductes.data.list.filter(createFilterFor());
     //si hi ha menys entitats de les originals haurem d'eliminar de la llista de rols ja 
      //seleccionats el rols que de les entitats eliminades
      if (vm.rol.entitat.length===0)
      {
        if(vm.rol.producte.length>0){
          vm.rol.producte.splice(0,1);
        }
      }
    }  

    vm.idRol = $stateParams.idRol;
    vm.errors = [];
    
    //functions
    vm.back = back;
    if (angular.isUndefined(vm.rol.acls)) {
      vm.readonlylistentitat=!$rootScope.issuperadmin;
      vm.readonlylistproductes=false;
    }
    else
    {
      vm.readonlylistentitat=!$rootScope.issuperadmin || vm.rol.acls.length>0;
      vm.readonlylistproductes=vm.rol.acls.length>0;
    }


    //long vars
    vm.formulari = {
      nom: 'formulariRol',
      func: func,
      camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              required: true,
              columns: 9,
              maxLength: 50
            },
             {
              type: 'chips',
              name: 'entitat',
              list:vm.listallentitat,
              onChange :  onChangeFunction,
              fieldProperty: 'nom',
              textPlaceholder: $translate.instant('USUARIENTITAT_CERCA'),
              createNew: true,
              columns: 12,
              readonly:vm.readonlylistentitat ||  !vm.isNew,
              label:"CERCA_ENTITATS",
              mdMinLenght:0,
              mdMaxChips:2,
              required:true
            },
            {
              type: 'chips',
              name: 'producte',
              list:vm.listallproductesentitat,
              fieldProperty: 'nom',
              textPlaceholder: $translate.instant('USUARIROL_CERCA'),
              createNew: false,
              columns: 12,
              readonly:vm.readonlylistproductes || !vm.isNew,
              label:"CERCA_PRODUCTES",
              mdMinLenght:0,
              mdMaxChips:2,
              required:true
            },
            {
              type: 'checkbox',
              name: 'eliminar',
              label: 'ROL_ES_POT_ELIMINAR',
              required: false,
              columns: 6,
              show:$rootScope.issuperadmin
            },
            {
              type: 'checkbox',
              name: 'inicial',
              label: 'ROL_INICIAL',
              required: false,
              columns: 6,
              show:$rootScope.issuperadmin
            },
            {
              type: 'checkbox',
              name: 'visibleall',
              label: 'ROL_VISIBLEALL',
              required: false,
              columns: 6,
              show:$rootScope.issuperadmin
            }          
      ]
    };


    function func() {
      if (vm.isNew) {
        createNew();
      }
      else {
        edit();
      }
    }

    function createNew() {
      RolFactory.add(vm.rol).then(function (response) {
        vm.rol.id = response.data;
        $rootScope.$broadcast('rols.main.llista.add', vm.rol);
        HelperFactory.setParams($stateParams, {'idRol': response.data});
        $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }
    function edit() {
      RolFactory.update(vm.idRol, vm.rol).then(function (response){
      $rootScope.$broadcast('rols.main.llista.update', vm.rol);
      $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }



    function back() {
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
      if (vm.isNew) {
        $state.go('rols.main', $stateParams, {'reload': 'rols.main.submain'});
      }
      else {
        $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
      }
    }

    function notificarregistre() {
      RolFactory.avisregistre(vm.idRol).then(function (response){


      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }
    
    function notificarconfirmar() {
      RolFactory.avisconfirmar(vm.idRol).then(function (response){


      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }


    if (vm.isNew) {
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': true});
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.dades
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.submain.dades', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.rols.main.submain.dades')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('rols.main.submain.dades', {
        url: '/dades',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosRolsHeaderSubmenuLinksValue", function(permisosRolsHeaderSubmenuLinksValue){
                return permisosRolsHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@rols.main.submain': {
            templateUrl: 'rols/main/dades/dades.tpl.html',
            controller: 'RolsMainDadesCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_DADES_GENERALS'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.dades.controller:DadesCtrl
   *
   * @description
   *
   */
  RolsMainDadesCtrl.$inject = ["rolData", "$window", "$rootScope", "$stateParams", "$state"];
  angular
    .module('itecAdministracio.rols.main.submain.dades')
    .controller('RolsMainDadesCtrl', RolsMainDadesCtrl);

  function RolsMainDadesCtrl(rolData,$window, $rootScope,$stateParams,$state) {
    var vm = this;
    vm.ctrlName = 'RolsMainDadesCtrl';
    vm.rol=rolData.data;

    //functions
    vm.changeToForm = changeToForm;
    vm.deleteElem = deleteElem;
    vm.issuperadmin=  $rootScope.issuperadmin;


    function deleteElem() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('rols.main.delete', vm.rol);
    }

    function changeToForm() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('rols.main.edit', vm.rol);
    }
   

   if (angular.isUndefined($stateParams.idRol) || $stateParams.idRol === null || !$stateParams.idRol) {
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
      $state.go('rols.main', $stateParams, {'reload': 'rols.main.submain'});
    }
    else {
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': true});
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name subsistemes.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.permisos', [
      'ui.router'
    ]);
}());
(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.productes.main.submain.permisos')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('productes.main.submain.permisos', {
        url: '/permisos',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosProductesHeaderSubmenuLinksValue", function(permisosProductesHeaderSubmenuLinksValue){
                return permisosProductesHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@productes.main.submain': {
            templateUrl: 'productes/main/permisos/permisos.tpl.html',
            controller: 'ProductesMainPermisosCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_PRODUCTES_PERMISOS'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name productes.permisos.controller:ProductesMainPermisosCtrl
   *
   * @description
   *
   */
 ProductesMainPermisosCtrl.$inject = ["$window", "$rootScope", "HelperFactory", "ItecTreeTracking", "TemaFactory", "Notification", "$scope", "$q", "$state", "$stateParams", "producteData", "ProducteFactory"];
  angular
    .module('itecAdministracio.productes.main.submain.permisos')
    .controller('ProductesMainPermisosCtrl', ProductesMainPermisosCtrl);

  function ProductesMainPermisosCtrl($window, $rootScope, HelperFactory, ItecTreeTracking, TemaFactory, Notification, $scope, $q, $state, $stateParams,producteData,ProducteFactory) {
      var vm = this;
      vm.ctrlName = 'ProductesMainPermisosCtrl';
      vm.producte=producteData.data;

      vm.children                 = [];
      vm.expandedCollection       = [];
      vm.loadChildren             = loadChildren;
      vm.treeTracking             = ItecTreeTracking.newInstance();
      vm.loadBasicTree            = loadBasicTree;
      vm.rootTreeNodeCollection   = [];
      vm.loadBasicTree();
      vm.back = back;
      vm.func= func;
      vm.errors = [];


      vm.onChangeReadTheme=onChangeReadTheme;
      vm.onChangeDeleteTheme=onChangeDeleteTheme;
      vm.onChangeEditTheme=onChangeEditTheme;
      vm.onChangeAddTheme=onChangeAddTheme;
      vm.actualitzarrols=actualitzarrols;

      function loadBasicTree(){
        ProducteFactory.gettemesvistesarrel(vm.producte.id).then(function(response) {
          $scope.$evalAsync(function(){
            if (response.data.temes.length > 0) {
              response.data.temes.forEach(function(elem){
                vm.rootTreeNodeCollection.push(elem);
                loadChildren(elem);
              });
            }
          });
        });
      }

      function filterNode(){
        return true;
      }

      function loadChildren(object) {
        if (object === undefined) {
          return [];
        }


        var deferred = $q.defer();
          if(object.children===null)
          {
            if (object.type === 'tema'){
              ProducteFactory.getfills(object.id,vm.producte.id).then(function(response){
                $scope.$evalAsync(function(){
                  object.children = response.data.temes.concat(response.data.objectes);
                  angular.forEach(object.children, function(obj, index){
                  if (obj.type === 'vista') {
                    vm.producte.vistes.push(obj);
                    }
                  });
                  deferred.resolve(object.children);
                });
              });
            }
        }
        else{
            deferred.resolve(object.children);
        }
        return deferred.promise;
      }




      function onChangeReadTheme(object)
      {
        if (object.read){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.read = object.read;
            if (child.type === 'tema'){
              onChangeReadTheme(child);
            }
          });
        }
      }

 function onChangeAddTheme(object)
      {
        if (object.read){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.add = object.add;
            if (child.type === 'tema'){
              onChangeAddTheme(child);
            }
          });
        }
      }

 function onChangeDeleteTheme(object)
      {
        if (object.read){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.delete = object.delete;
            if (child.type === 'tema'){
              onChangeDeleteTheme(child);
            }
          });
        }
      }

 function onChangeEditTheme(object)
      {
        if (object.read){
            vm.expandedCollection.push(object);
        }
        if (!angular.isUndefined(object.children) && object.children !== null){
          object.children.forEach(function(child){
            child.edit = object.edit;
            if (child.type === 'tema'){
              onChangeEditTheme(child);
            }
          });
        }
      }


      function back() {
        $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
        if ($stateParams.isNew) {
          $state.go('productes.main', $stateParams, {'reload': 'productes.main.submain'});
        }
        else {
          $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain'});
        }
      }

      function func() {
        edit();
      }

      function edit() {
        ProducteFactory.updatevistes(vm.producte.id, vm.producte).then(function (response){
        $rootScope.$broadcast('productes.main.submain.permisos', vm.producte);
        $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain.permisos'});
        }).catch(function(error){
          vm.errors = Notification.processError(error);
        });
      }

      function actualitzarrols() {
        $rootScope.$broadcast('$activateLoader');
        ProducteFactory.updaterols(vm.producte.id, vm.producte.id).then(function (response){
        $rootScope.$broadcast('$deactivateLoader');
        $rootScope.$broadcast('productes.main.submain.permisos', vm.producte);
        $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain.permisos'});
        }).catch(function(error){
          $rootScope.$broadcast('$deactivateLoader');
          vm.errors = Notification.processError(error);
        });
      }

 }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name productes.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.llista', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name productes.llista.controller:LlistaCtrl
   *
   * @description
   *
   */
  ProductesMainLlistaCtrl.$inject = ["$translate", "$rootScope", "$scope", "HelperFactory", "Notification", "ProducteFactory", "$window", "$state", "$stateParams", "llistaaplicacions"];
  angular
    .module('itecAdministracio.productes.main.llista')
    .controller('ProductesMainLlistaCtrl', ProductesMainLlistaCtrl);

  function ProductesMainLlistaCtrl($translate,$rootScope,$scope, HelperFactory, Notification, ProducteFactory, $window, $state, $stateParams,llistaaplicacions) {
    var vm = this;
    vm.ctrlName = 'ProductesMainLlistaCtrl';

    vm.calculateListFields = calculateListFields;
    vm.load = load;
    vm.view = view;
    vm.edit=edit;
    vm.deleteProductes=deleteElem;
    vm.duplicate = duplicate;

    vm.llista = [];
    vm.page = 1;
    vm.perPage = 25;
    vm.pages = 0;
    vm.canLoad = true;
    vm.errors=[];
    vm.auxaplicaciosel=[];

    vm.issuperadmin= $rootScope.issuperadmin;

    vm.cercaObj = {
      page : vm.page,
      perPage: vm.perPage,
      pages: vm.pages,
      nom: '',
      aplicaciosel:[],
      idaplicacio:''
    };


    if (!angular.isUndefined(llistaaplicacions)){
      vm.listallaplicacio=llistaaplicacions.data.list;
    }

    function onChangeFunction(){
      vm.cercaObj.idaplicacio=null;
      if (vm.cercaObj.aplicaciosel!=null){
        if (vm.cercaObj.aplicaciosel.length>0){
          vm.cercaObj.idaplicacio=vm.cercaObj.aplicaciosel[0].id;
        }
      }
    }

    if ($rootScope.issuperadmin){
      vm.formulari = {
        nom: 'cercador',
        func: function(){
          cercar();
        },
        camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              columns: 6,
              required: false
            }
            ,
            {
                type: 'chips',
                name: 'aplicaciosel',
                list:vm.listallaplicacio,
                master: true,
                fieldProperty: 'nom',
                textPlaceholder: $translate.instant('APLICACIO_CERCA'),
                columns: 6,
                label:"CERCA_APLICACIONS",
                onChange :  onChangeFunction,
                mdMaxChips:2
            }
          ]
        }
      }
      else
      {
      vm.formulari = {
        nom: 'cercador',
        func: function(){
          cercar();
        },
        camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              columns: 6,
              required: false
            }]
        }
      }

    function loadProductes() {
      if (!angular.isUndefined($rootScope.permisos) && $rootScope.permisos.PRODUCTE.read){
       vm.auxaplicaciosel=vm.cercaObj.aplicaciosel;
        vm.cercaObj.aplicaciosel=[];
        var promise = ProducteFactory.getAll(vm.cercaObj).then(function(response){
          $scope.$evalAsync(function(){
            vm.cercaObj.pages = response.data.pages;
            vm.cercaObj.page = response.data.page + 1;
            angular.forEach(response.data.list, function(entrada) {
              vm.llista.push(entrada);
            });
          });
        }).catch(function(error){
          Notification.processError(error);
        });
        vm.cercaObj.aplicaciosel=vm.auxaplicaciosel;
        return promise;
      }
      else
      {
        return undefined;
      }
    }

    function cercar(){
      vm.cercaObj.page = 1;
      vm.cercaObj.pages = undefined;
      vm.llista = [];
      loadProductes();
    }

    function load(){
      if (!angular.isUndefined(vm.cercaObj.pages) && (vm.cercaObj.page < (vm.cercaObj.pages + 1)) ) {
        vm.canLoad = false;
        loadProductes().then(function(){
          $scope.$evalAsync(function(){
            vm.canLoad = true;
          });
        });
      }
    }

    function calculateListFields(reductedList){
      if (reductedList){
        vm.fields = [
          {
            header: 'DEFAULT_NOM',
            type: 'text',
            name: 'nom'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];
      } else{
        vm.fields = [
          {
            header: 'DEFAULT_NOM',
            type: 'text',
            name: 'nom'
          },
          {
            header: 'DEFAULT_APLICACIO',
            type: 'text',
            name: 'nomaplicacio'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];

      }
    }

    function deleteElem(id) {
      $rootScope.$broadcast('$activateLoader');
      ProducteFactory.delete(id).then(function(response){
        $scope.$evalAsync(function(){
          vm.llista.forEach(function(elem, index) {
            if (elem.id === id){
                vm.llista.splice(index,1);
                vm.indexeliminat=index;
            }
          });
          if (vm.llista.length==0 )
          {
            HelperFactory.setParams($stateParams, {'idProducte': null});
            $state.go('productes.main', $stateParams, {'reload': 'productes.main.submain'});
          }
          else
          {
            if (vm.llista.length==1)
            {
              view(vm.llista[0]);
            }
            else{
              if (vm.indexeliminat<vm.llista.length)
              {
                view(vm.llista[vm.indexeliminat]);
              }
              else
              {
                view(vm.llista[vm.indexeliminat-1]);
              }
            }
          }

        });
      $rootScope.$broadcast('$deactivateLoader');
      }).catch(function(error){
        $rootScope.$broadcast('$deactivateLoader');
        Notification.processError(error);
      });
    }




    function duplicate(id){
      $rootScope.$broadcast('$activateLoader');
      ProducteFactory.duplicate(id).then(function(response){
        cercar();
        $rootScope.$broadcast('$deactivateLoader');
      }).catch(function(error){
        $rootScope.$broadcast('$deactivateLoader');
        Notification.processError(error);
      });
    }

    function edit(id) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'isNew': false, 'idProducte': id});
      $state.go('productes.main.submain.edit', $stateParams, {'reload': 'productes.main.submain'});
    }

    function view(obj) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'idProducte': obj.id});
      $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain'});
    }

    $scope.$on('addItemToTree', function(event, data) {
      HelperFactory.setParams($stateParams, {'isNew': true, 'idProducte': undefined});
      $state.go('productes.main.submain.edit', $stateParams);
    });

    cercar();

    /*--------------------------------EVENTS ------------------------------*/

    $scope.$on('changeSides', function(event, data) {
      vm.calculateListFields(!data.left.collapsed && !data.links.collapsed);
    });

    $scope.$on('productes.main.delete', function(event, data) {
      deleteElem(data.id);
    });

     $scope.$on('productes.main.edit', function(event, data) {
      edit(data.id);
    });


    $scope.$on('productes.main.llista.update', function(event, data) {
      vm.llista.forEach(function(obj, index){
        if (obj.id === data.id) {
          obj.nom = data.nom;

          if (obj.nom.indexOf(vm.cercaObj.nom) == -1) {
            vm.llista.splice(index, 1);
          }
          Notification.success('GENERIC_SUCCESS');

          return;
        }
      });
    });

    $scope.$on('productes.main.llista.add', function(event, data) {
      $stateParams.idProducte = data.id;
        if (vm.cercaObj.idaplicacio== data.aplicacio.id ||vm.cercaObj.idaplicacio==null ||vm.cercaObj.idaplicacio=="" ){
          if (data.nom.indexOf(vm.cercaObj.nom) != -1 )  {
          vm.llista.push(data);
          }
        }

      view(data);
      Notification.success('GENERIC_SUCCESS');
    });

    if (angular.isUndefined($stateParams.idProducte)){
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.entitats
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.entitats', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.productes.main.submain.entitats')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('productes.main.submain.entitats', {
        url: '/entitats',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosProductesHeaderSubmenuLinksValue", function(permisosProductesHeaderSubmenuLinksValue){
                return permisosProductesHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@productes.main.submain': {
            templateUrl: 'productes/main/entitats/dades.tpl.html',
            controller: 'ProductesMainEntitatsCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_DADES_GENERALS'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.entitats.controller:entitatsCtrl
   *
   * @description
   *
   */
 ProductesMainEntitatsCtrl.$inject = ["ProducteFactory", "$window", "$rootScope", "$stateParams", "$state", "$scope", "Notification", "HelperFactory"];
  angular
    .module('itecAdministracio.productes.main.submain.entitats')
    .controller('ProductesMainEntitatsCtrl', ProductesMainEntitatsCtrl);

  function ProductesMainEntitatsCtrl(ProducteFactory,$window, $rootScope,$stateParams,$state,$scope,Notification,HelperFactory) {
    var vm = this;
    vm.ctrlName = 'ProductesMainEntitatsCtrl';
    vm.llista=[];

      
    vm.cercaObj = {
      page : vm.page,
      perPage: vm.perPage,
      pages: vm.pages,
      nom: '',
      codiclient: '',
      nif:''
    };

    vm.load = load;
    vm.page = 1;
    vm.perPage = 25;
    vm.pages = 0;
    vm.canLoad = true;
    vm.view=view;
    
     vm.formulari = {
      nom: 'cercador',
      func: function(){
        cercar();
      },
      camps: [
          {
            type: 'text',
            name: 'nom',
            label: 'DEFAULT_NOM',
            columns: 4,
            required: false
          },
          {
            type: 'text',
            name: 'codiclient',
            label: 'DEFAULT_CODI_client',
            columns: 4,
            required: false,
            show:$rootScope.issuperadmin
           },
           {
             type: 'text',
             name: 'nif',
             label: 'DEFAULT_NIF',
             columns: 4,
             required: false,
             show:$rootScope.issuperadmin
            }
      ]
    }
    
    function loadEntitats() {
        var promise = ProducteFactory.getProducteEntitats($stateParams.idProducte, vm.cercaObj).then(function(response){
          $scope.$evalAsync(function(){
            vm.cercaObj.pages = response.data.pages;
            vm.cercaObj.page = response.data.page + 1;
            angular.forEach(response.data.list, function(entrada) {
              vm.llista.push(entrada);
            });
          });
        }).catch(function(error){
          Notification.processError(error);
        });

        return promise;
      }

    
    function load(){
      if (!angular.isUndefined(vm.cercaObj.pages) && (vm.cercaObj.page < (vm.cercaObj.pages + 1)) ) {
        vm.canLoad = false;
        loadEntitats().then(function(){
          $scope.$evalAsync(function(){
            vm.canLoad = true;
          });
        });
      }
    }
    
    vm.fields = [
    {
      header: 'DEFAULT_NOM',
      type: 'text',
      name: 'nom'
    },
    {
      header: 'DEFAULT_CODI_client',
      type: 'text',
      name: 'codiclient'
    },
    {
      header: 'DEFAULT_NIF',
      type: 'text',
      name: 'nif'
    },
    {
      header: 'DEFAULT_CODI',
      type: 'text',
      name: 'codi'
    }
  ];

 
  function view(obj) {
      HelperFactory.setParams($stateParams, {'idEntitat': obj.id});

      if(!angular.isUndefined($rootScope.permisos.PRODUCTEENTMENU) && $rootScope.permisos.PRODUCTEENTMENU.read){
              var url = $state.href('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if (!angular.isUndefined($rootScope.permisos.ENTITATMENU) && $rootScope.permisos.ENTITATMENU.read){
              var url = $state.href('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
      }
      
      $window.open(url,'_blank');
  }

    function cercar(){
      vm.cercaObj.page = 1;
      vm.cercaObj.pages = undefined;
      vm.llista = [];
      loadEntitats();
    }

    cercar();  
    if (angular.isUndefined($stateParams.idEntitat)){
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
 }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.edit
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.edit', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.productes.main.submain.edit')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('productes.main.submain.edit', {
        url: '/edit',
         params: {
          isNew : false
        },
      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosProductesHeaderSubmenuLinksValue", function(permisosProductesHeaderSubmenuLinksValue){
                return permisosProductesHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@productes.main.submain': {
            templateUrl: 'productes/main/edit/edit.tpl.html',
            controller: 'ProductesMainEditCtrl',
            controllerAs: 'ctrl'  ,
            resolve: {
              llistaaplicacions: ["AplicacioFactory", function(AplicacioFactory) {
                return AplicacioFactory.getAll().catch(function(){});
              }]
            }
          }
        }
      });
  }
}());

(function () {
  'use strict';
  /**
   * @ngdoc object
   * @name agents.edit.controller:EditCtrl
   *
   * @description
   *
   */
  ProductesMainEditCtrl.$inject = ["$scope", "producteData", "$translate", "$state", "$window", "$rootScope", "$stateParams", "ProducteFactory", "Notification", "llistaaplicacions"];
  angular
    .module('itecAdministracio.productes.main.submain.edit')
    .controller('ProductesMainEditCtrl', ProductesMainEditCtrl);
  function ProductesMainEditCtrl($scope,producteData,$translate,$state,$window, $rootScope,$stateParams,ProducteFactory,Notification,llistaaplicacions) {
    var vm = this;
     var vm = this;
    vm.ctrlName = 'ProductesMainEditCtrl';
    vm.producte=producteData.data;

    vm.listallaplicacions=llistaaplicacions.data.list;

    vm.idProducte = $stateParams.idProducte;
    vm.errors = [];
    vm.isNew = $stateParams.isNew;
    //functions
    vm.back = back;
    if (angular.isUndefined(vm.producte)) {
      vm.producte = {aplicacio:{}};
      vm.disabledlistapp=false;
    }
    else
    {
      vm.disabledlistapp=vm.producte.tevistesdefinides;
    }
    //long vars
    vm.formulari = {
      nom: 'formulariProducte',
      func: func,
      camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              required: true,
              columns: 6,
              maxLength: 50
            },
            {
              type: 'select',
              name: 'aplicacio',
              label: 'DEFAULT_APLICACIO',
              list:vm.listallaplicacions,
              propertyLabel: 'nom',
              propertyId: 'id' ,
              required: true,
              columns: 6,
              disabled:vm.disabledlistapp
           },
            {
              type: 'text',
              name: 'codiclient',
              label: 'DEFAULT_CODI_client',
              required: false,
              columns: 6,
              maxLength: 50
            },
            {
              type: 'numeric',
              name: 'tedemo',
              label: 'DEFAULT_TEDEMO',
              required: false,
              columns: 6,
              decimalPlaces:0,
              minValue:-1
            }
      ]
    };
    function func() {
      if (vm.isNew) {
        createNew();
      }
      else {
        edit();
      }
    }
    function createNew() {
      ProducteFactory.add(vm.producte).then(function (response) {
        vm.producte.id = response.data;
        $rootScope.$broadcast('productes.main.llista.add', vm.producte);
        HelperFactory.setParams($stateParams, {'idProducte': response.data});
        $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }
    function edit() {
      ProducteFactory.update(vm.idProducte, vm.producte).then(function (response){
      $rootScope.$broadcast('productes.main.llista.update', vm.producte);
      $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }
    function back() {
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
      if ($stateParams.isNew) {
        $state.go('productes.main', $stateParams, {'reload': 'productes.main.submain'});
      }
      else {
        $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain'});
      }
    }
    if (!angular.isUndefined($stateParams.isNew) && $stateParams.isNew !== null && $stateParams.isNew) {
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': true});
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.llicencies
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.sessions', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.entitats.main.sessions')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.sessions', {
        url: '/sessions',
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["entitatsHeaderSubmenuLinksValue", function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/sessions/sessions.tpl.html',
            controller: 'EntitatsMainSessionsCtrl',
            controllerAs: 'ctrl',
            resolve: {
              usuarissessioData: ["EntitatFactory", "$stateParams", function(EntitatFactory, $stateParams){
                return EntitatFactory.getsessions($stateParams.idEntitat);
              }]
            }
          }
        },
        breadcrumb: 'USUARIS_SESSIO'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.sessions.controller:sessionsCtrl
   *
   * @description
   *
   */
  EntitatsMainSessionsCtrl.$inject = ["Notification", "usuarissessioData", "$locale", "HelperFactory", "$state", "$rootScope", "$stateParams", "$scope", "$mdDialog", "$document", "$window"];
  angular
    .module('itecAdministracio.entitats.main.sessions')
    .controller('EntitatsMainSessionsCtrl', EntitatsMainSessionsCtrl);

  function EntitatsMainSessionsCtrl(Notification, usuarissessioData,  $locale, HelperFactory, $state, $rootScope, $stateParams, $scope,$mdDialog,$document,$window) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainSessions';
    vm.usuarisensessio=usuarisensessio;
    vm.productes = usuarissessioData.data;
    vm.viewuser=viewuser;

   



    if (angular.isUndefined($stateParams.idEntitat) || $stateParams.idEntitat === null || !$stateParams.idEntitat) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }

    function usuarisensessio(usuarisensessio) {

      $mdDialog.show({
        controller: ["$scope", "$mdDialog", "$translate", function DialogController($scope, $mdDialog,$translate) {
          var vm = this;
          vm.usuarisensessio=usuarisensessio;


          $scope.hide = function() {
            $mdDialog.cancel();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
        }],

        controllerAs: 'ctrl',
        templateUrl: 'entitats/main/sessions/usuarisensessio.tpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true
      });
    }
 
    function viewuser(id) {
      HelperFactory.setParams($stateParams, {'idUsuari': id});
        var url = $state.href('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
        $window.open(url,'_blank');
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.dades
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.dades', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.productes.main.submain.dades')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('productes.main.submain.dades', {
        url: '/dades',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosProductesHeaderSubmenuLinksValue", function(permisosProductesHeaderSubmenuLinksValue){
                return permisosProductesHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@productes.main.submain': {
            templateUrl: 'productes/main/dades/dades.tpl.html',
            controller: 'ProductesMainDadesCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_DADES_GENERALS'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.dades.controller:DadesCtrl
   *
   * @description
   *
   */
  ProductesMainDadesCtrl.$inject = ["producteData", "$window", "$rootScope", "$stateParams", "$state"];
  angular
    .module('itecAdministracio.productes.main.submain.dades')
    .controller('ProductesMainDadesCtrl', ProductesMainDadesCtrl);

  function ProductesMainDadesCtrl(producteData,$window, $rootScope,$stateParams,$state) {
    var vm = this;
    vm.ctrlName = 'ProductesMainDadesCtrl';
    vm.producte=producteData.data;

    //functions
    vm.changeToForm = changeToForm;
    vm.deleteElem = deleteElem;
    vm.issuperadmin=  $rootScope.issuperadmin;


    function deleteElem() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('productes.main.delete', vm.producte);
    }

    function changeToForm() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('productes.main.edit', vm.producte);
    }
   

   if (angular.isUndefined($stateParams.idProducte) || $stateParams.idProducte === null || !$stateParams.idProducte) {
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
      $state.go('productes.main', $stateParams, {'reload': 'productes.main.submain'});
    }
    else {
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': true});
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.logos
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.logos', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.entitats.main.logos')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.logos', {
        url: '/logos',
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["entitatsHeaderSubmenuLinksValue", function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/logos/logos.tpl.html',
            controller: 'EntitatsMainLogosCtrl',
            controllerAs: 'ctrl',
            resolve: {
              logosData: ["LogoFactory", "$stateParams", function(LogoFactory, $stateParams){
                return LogoFactory.getAll($stateParams.idEntitat);
              }]
            }
          }
        },
        breadcrumb: 'DEFAULT_LOGOS'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.logos.controller:LogosCtrl
   *
   * @description
   *
   */
  EntitatsMainLogosCtrl.$inject = ["logosData", "LogoFactory", "$scope", "$stateParams", "$rootScope", "HelperFactory", "$state", "AdmConstant", "Notification"];
  angular
    .module('itecAdministracio.entitats.main.logos')
    .controller('EntitatsMainLogosCtrl', EntitatsMainLogosCtrl);

  function EntitatsMainLogosCtrl(logosData, LogoFactory, $scope, $stateParams, $rootScope, HelperFactory, $state, AdmConstant,Notification) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainLogosCtrl';

    vm.add = add;

    vm.logos = logosData.data.list;

    vm.baseUrlUpload = '/api/' + AdmConstant.SERVER_PATH_ADMINISTRACIO;
    vm.controllerUrlUpload = 'entitats/' + $stateParams.idEntitat + '/logos';
    vm.idEntitat = $stateParams.idEntitat;
    vm.makeLogoPred = function(id){
      LogoFactory.makeLogoPredeterminat(vm.idEntitat, id).then(function (response){
        Notification.success('GENERIC_SUCCESS');
        $scope.$evalAsync(function(){
          for (var i = 0; i < vm.logos.length; i++){
            vm.logos[i].predeterminat = vm.logos[i].id === id;
          }
        });
      }).catch(function (response){
        Notification.error('GENERIC_ERROR_UNEXPECTED_EXCEPTION');
      });
    }

    vm.uploadEndFunction = function(){
      LogoFactory.getAll(vm.idEntitat).then(function(response){
        $scope.$evalAsync(function(){
          vm.logos = response.data.list;
        });
      }).catch(function(error){
        Notification.processError(error);
      });
    }

    function add(){
      HelperFactory.setParams($stateParams, {'isNew': true});
      $state.go('entitats.main.submain.logos.formulari', $stateParams, {'reload': 'entitats.main.submain.logos'});
    }

    if (angular.isUndefined(vm.idEntitat) || vm.idEntitat === null || !vm.idEntitat) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.llista
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.llista', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.llista.controller:EntitatsMainLlistaCtrl
   *
   * @description
   *
   */
 EntitatsMainLlistaCtrl.$inject = ["$scope", "HelperFactory", "Notification", "EntitatFactory", "$window", "$state", "$stateParams", "$rootScope"];
  angular
    .module('itecAdministracio.entitats.main.llista')
    .controller('EntitatsMainLlistaCtrl', EntitatsMainLlistaCtrl);

  function EntitatsMainLlistaCtrl($scope, HelperFactory, Notification, EntitatFactory, $window, $state, $stateParams, $rootScope) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainLlistaCtrl';

    vm.calculateListFields = calculateListFields;
    vm.load = load;
    vm.view = view;
    vm.deleteEntitat = deleteEntitat;
    vm.edit = edit;

    vm.llista = [];
    vm.page = 1;
    vm.perPage = 25;
    vm.pages = 0;
    vm.canLoad = true;
    vm.indexeliminat=-1;

    vm.codivisible=false;
    vm.codiclient=false;

    vm.cercaObj = {
      page : vm.page,
      perPage: vm.perPage,
      pages: vm.pages,
      nom: '',
      codiclient: '',
      nif:''
    };

    vm.formulari = {
      nom: 'cercador',
      func: function(){
        cercar();
      },
      camps: [
          {
            type: 'text',
            name: 'nom',
            label: 'DEFAULT_NOM',
            columns: 4,
            required: false
          },
          {
            type: 'text',
            name: 'codiclient',
            label: 'DEFAULT_CODI_client',
            columns: 4,
            required: false,
            show:$rootScope.issuperadmin
           },
           {
             type: 'text',
             name: 'nif',
             label: 'DEFAULT_NIF',
             columns: 4,
             required: false,
             show:$rootScope.issuperadmin
            }
      ]
    }

    function loadEntitats() {
      if (!angular.isUndefined($rootScope.permisos.ENTITAT)){
        var promise = EntitatFactory.getAll(vm.cercaObj).then(function(response){
          $scope.$evalAsync(function(){
            vm.cercaObj.pages = response.data.pages;
            vm.cercaObj.page = response.data.page + 1;
            angular.forEach(response.data.list, function(entrada) {
              vm.llista.push(entrada);
            });
          });
        }).catch(function(error){
          Notification.processError(error);
        });

        return promise;
      }
      else
      {
        return undefined;
      }
    }

    function cercar(){
      vm.cercaObj.page = 1;
      vm.cercaObj.pages = undefined;
      vm.llista = [];
      loadEntitats();
    }

    function load(){
      if (!angular.isUndefined(vm.cercaObj.pages) && (vm.cercaObj.page < (vm.cercaObj.pages + 1)) ) {
        vm.canLoad = false;
        loadEntitats().then(function(){
          $scope.$evalAsync(function(){
            vm.canLoad = true;
          });
        });
      }
    }
    function calculateListFields(reductedList){
        if (!angular.isUndefined($rootScope.permisos.CODI)){
          vm.codivisible=$rootScope.permisos.CODI.read;
        }
        if (!angular.isUndefined($rootScope.permisos.CODIclient)){
          vm.codiclient=$rootScope.permisos.CODIclient.read;
        }
        if (reductedList ||  (!vm.codivisible && !vm.codiclient)){
          vm.fields = [
            {
              header: 'DEFAULT_NOM',
              type: 'text',
              name: 'nom'
            },
            {
              header: 'DEFAULT_ACCIONS',
              type: 'actions',
              name: 'id'
            }
          ];
        }
        else
        {
          vm.fields = [
            {
              header: 'DEFAULT_NOM',
              type: 'text',
              name: 'nom'
            },
            {
              header: 'DEFAULT_CODI_client',
              type: 'text',
              name: 'codiclient'


            },
            {
              header: 'DEFAULT_NIF',
              type: 'text',
              name: 'nif'
            },
            {
              header: 'DEFAULT_CODI',
              type: 'text',
              name: 'codi'
            },
            {
              header: 'DEFAULT_ACCIONS',
              type: 'actions',
              name: 'id'
            }
          ];

        }
    }


    function view(obj) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'idEntitat': obj.id});

      if (!angular.isUndefined($rootScope.permisos.ENTITATMENU) && $rootScope.permisos.ENTITATMENU.read){
              $state.go('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if(!angular.isUndefined($rootScope.permisos.ADMINISTRADORSENTMENU) && $rootScope.permisos.ADMINISTRADORSENTMENU.read){
              $state.go('entitats.main.submain.administradors', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if(!angular.isUndefined($rootScope.permisos.PRODUCTEENTMENU) && $rootScope.permisos.PRODUCTEENTMENU.read){
              $state.go('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if(!angular.isUndefined($rootScope.permisos.LOGOSMENU) && $rootScope.permisos.LOGOSMENU.read){
              $state.go('entitats.main.submain.logos', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if(!angular.isUndefined($rootScope.permisos.PRODUCTEENTMENU) && $rootScope.permisos.PRODUCTEENTMENU.read){
              $state.go('entitats.main.submain.sessions', $stateParams, {'reload': 'entitats.main.submain'});
      }
    }

    function deleteEntitat(id){
      EntitatFactory.delete(id).then(function(response){
      /*  if (id === $stateParams.idEntitat) {
          HelperFactory.setParams($stateParams, {'idEntitat': null});
          $state.go('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
        }*/
        vm.indexeliminat=-1;
        vm.llista.forEach( function(obj, index) {
          if (obj.id === id) {
            vm.llista.splice(index, 1);
            vm.indexeliminat=index;
          }
        });
        if (vm.llista.length==0 )
        {
          HelperFactory.setParams($stateParams, {'idEntitat': null});
          $state.go('entitats.main', $stateParams, {'reload': 'entitats.main.submain'});
        }
        else
        {
          if (vm.llista.length==1)
          {
            view(vm.llista[0]);
          }
          else{
            if (vm.indexeliminat<vm.llista.length)
            {
              view(vm.llista[vm.indexeliminat]);
            }
            else
            {
              view(vm.llista[vm.indexeliminat-1]);
            }
          }
        }


      });
    }

    function edit(id){
      HelperFactory.setParams($stateParams, {'isNew': false, 'idEntitat': id});
      $state.go('entitats.main.submain.formulari', $stateParams, {'reload': 'entitats.main.submain'});
    }

    cercar();

    /*--------------------------------EVENTS ------------------------------*/

    $scope.$on('changeSides', function(event, data) {
      vm.calculateListFields(!data.left.collapsed && !data.links.collapsed);
    });

    $scope.$on('addItemToTree', function(event, data) {
      HelperFactory.setParams($stateParams, {'isNew':true, 'idEntitat': undefined});
      $state.go('entitats.main.submain.formulari', $stateParams, {'reload': 'entitats.main.submain'});
    });

    $scope.$on('entitats.main.llista.update', function(event, data) {
      vm.llista.forEach(function(obj, index){
        if (obj.id === data.id) {
          obj.nom = data.nom;

          if (obj.nom.toLowerCase().indexOf(vm.cercaObj.nom.toLowerCase()) == -1) {
            vm.llista.splice(index, 1);
          }
          Notification.success('GENERIC_SUCCESS');

          return;
        }
      });
    });

    $scope.$on('entitats.main.llista.add', function(event, data) {
      $stateParams.idEntitat = data.id;
      if (data.nom.indexOf(vm.cercaObj.nom) != -1) {
        vm.llista.push(data);
      }
      Notification.success('GENERIC_SUCCESS');
    });

    $scope.$on('entitats.main.llista.delete', function(event, id) {
      deleteEntitat(id);
    });

    if (angular.isUndefined($stateParams.idEntitat)){
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
 }
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.entitats.main.llicencies')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.llicencies', {
        url: '/llicencies',
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["entitatsHeaderSubmenuLinksValue", function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/llicencies/llicencies.tpl.html',
            controller: 'EntitatsMainLlicenciesCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_PRODUCTES'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.llicencies.controller:LlicenciesCtrl
   *
   * @description
   *
   */
  EntitatsMainLlicenciesCtrl.$inject = ["Notification", "entitatData", "LlicenciaFactory", "$locale", "HelperFactory", "$state", "$rootScope", "$stateParams", "$scope", "$mdDialog", "$document", "EntitatFactory"];
  angular
    .module('itecAdministracio.entitats.main.llicencies')
    .controller('EntitatsMainLlicenciesCtrl', EntitatsMainLlicenciesCtrl);

  function EntitatsMainLlicenciesCtrl(Notification, entitatData, LlicenciaFactory, $locale, HelperFactory, $state, $rootScope, $stateParams, $scope,$mdDialog,$document,EntitatFactory) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainLlicenciesCtrl';

    vm.editLLicencies = editLLicencies;
    vm.add = add;
    vm.saveNewDate = saveNewDate;
    vm.deleteFunction = deleteFunction;
    vm.errors = [];
    //vm.usuarisensessio=usuarisensessio;
    vm.llistar  = llistar;
    vm.isAgrupat=true;
    vm.llicenciesdata = [];

    if(!angular.isUndefined($stateParams.errorproces) && $stateParams.errorproces!='')
    {
      vm.errors.push($stateParams.errorproces);
    }


    function omplirllistalic(){
      vm.llicencies.items = [];
        for (var i=0;i<vm.entitat.llicencies.length;i++){
          if ($locale.localeID === vm.entitat.llicencies[i].idioma){
            vm.llicencies.items.push(vm.entitat.llicencies[i]);
          }
        }
    }

    vm.entitat=entitatData.data;

    var llicencies = [];
    for (var i=0;i<vm.entitat.llicencies.length;i++){
      if ($locale.localeID === vm.entitat.llicencies[i].idioma){
        llicencies.push(vm.entitat.llicencies[i]);
      }
    }
    function llistar(){
     // if (!vm.isAgrupat){
          EntitatFactory.getGroup($stateParams.idEntitat).then(function (response){
            vm.entitat=response.data;
            omplirllistalic();
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });

     // }
     /* else{
          EntitatFactory.get($stateParams.idEntitat).then(function (response){
            vm.entitat=response.data;
            omplirllistalic();
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
      }*/

      
    }

    vm.llicencies = {
      items : llicencies,
      fields : [
        {
          header: 'DEFAULT_NOM',
          type: 'text',
          name: 'productenom'
        },
        {
          header: 'DEFAULT_NUMERO',
          type: 'numeric',
          name: 'numero',
          decimalPlaces:0
         },
        {
          header: 'DEFAULT_DATA_CADUCITAT',
          type: 'multiTransclude',
          block: 'caducitat'
        },
        {
          header: 'DEFAULT_ACCIONS',
          type: 'actions'
        },
        {
          header: 'DEFAULT_USERS',
          type: 'text',
          name: 'usersensessio'
        }
      ]
    };

    function deleteFunction(obj){
      LlicenciaFactory.delete($stateParams.idEntitat,obj.id).then(function(response){
        $scope.$evalAsync(function(){
          vm.llicencies.items.forEach(function(elem, index) {
            if (elem.id === obj.id){
              vm.llicencies.items.splice(index,1);
            }
          });
        });
        Notification.success('GENERIC_SUCCESS');
      }).catch(function(error){
        Notification.processError(error);
      });
    }

    function add(){
      HelperFactory.setParams($stateParams, {'isNew': true});
      $state.go('entitats.main.submain.llicencies.formulari', $stateParams, {'reload': 'entitats.main.submain.llicencies'});
    }

    function editLLicencies(obj){
      HelperFactory.setParams($stateParams, {'isNew': false, 'idLlicencia': obj.id});
      $state.go('entitats.main.submain.llicencies.formulari', $stateParams, {'reload': 'entitats.main.submain.llicencies'});
    }

    function saveNewDate(llicencia){
      LlicenciaFactory.update($stateParams.idEntitat, llicencia.id, llicencia).then(function(response){
        $scope.$evalAsync(function(){
          llicencia.editant = false;
        });
       }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }

    if (angular.isUndefined($stateParams.idEntitat) || $stateParams.idEntitat === null || !$stateParams.idEntitat) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }

  /*  function usuarisensessio(usuarisensessio) {

      $mdDialog.show({
        controller: function DialogController($scope, $mdDialog,$translate) {
          var vm = this;
          vm.usuarisensessio=usuarisensessio;


          $scope.hide = function() {
            $mdDialog.cancel();
          };
          $scope.cancel = function() {
            $mdDialog.cancel();
          };
        },

        controllerAs: 'ctrl',
        templateUrl: 'entitats/main/llicencies/usuarisensessio.tpl.html',
        parent: angular.element($document.body),
        clickOutsideToClose:true
      });
    }*/

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.formulari
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.formulari', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.entitats.main.formulari')
    .config(config);

function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.formulari', {
        url: '/formulari',
        params: {
          isNew : false
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["entitatsHeaderSubmenuLinksValue", function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/formulari/formulari.tpl.html',
            controller: 'EntitatsMainSubmainFormulariCtrl',
            controllerAs: 'ctrl'
          }
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.formulari.controller:FormulariCtrl
   *
   * @description
   *
   */
  EntitatsMainSubmainFormulariCtrl.$inject = ["EntitatFactory", "entitatData", "$rootScope", "$stateParams", "$state", "HelperFactory", "Notification", "$translate"];
  angular
    .module('itecAdministracio.entitats.main.formulari')
    .controller('EntitatsMainSubmainFormulariCtrl', EntitatsMainSubmainFormulariCtrl);

  function EntitatsMainSubmainFormulariCtrl(EntitatFactory, entitatData, $rootScope, $stateParams, $state, HelperFactory, Notification,$translate) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainSubmainFormulariCtrl';
    vm.isNew =angular.isUndefined(entitatData.data);

    vm.entitat = [];
    vm.maxlength = 100;

    if (angular.isUndefined(entitatData.data)){
      vm.entitat = {};
    }
    else {
      vm.entitat = entitatData.data;
    }

     vm.tipus_empresaList = [{id:'interno', name: $translate.instant('interno')},
                    {id:'externo', name: $translate.instant('externo')}]

     for (var i=0;i < vm.tipus_empresaList.length;i++){
      if (vm.entitat.tipus_client==vm.tipus_empresaList[i].id ) {
        vm.entitat.tipus_empresaObj=vm.tipus_empresaList[i];
        break;
      }
     }


    vm.formulari = {
        nom: 'formulari',
        func: func,
        camps: [
          {
            type: 'text',
            name: 'nom',
            label: 'DEFAULT_NOM',
            required: true,
            columns: 6,
            maxLength: 100
          },
          {
            type: 'text',
            name: 'nif',
            label: 'DEFAULT_NIF',
            required: true,
            columns: 6,
            maxLength: 20
          },
          {
            type: 'text',
            name: 'codi',
            label: 'DEFAULT_CODI',
            columns: 6,
            maxLength: vm.maxlength,
            disabled:true
          },
          {
            type: 'text',
            name: 'codiclient',
            label: 'DEFAULT_CODI_client',
            columns: 6,
            maxLength: 50,
            required: true
          },
          {
              type: 'select',
              name: 'tipus_empresaObj',
              propertyLabel: 'name',
              propertyId: 'id',
              label: 'DEFAULT_TIPUS',
              list: vm.tipus_empresaList ,
              columns: 6,
              required: true,
          },
          {
             type: 'checkbox',
             name: 'bloquejada',
             columns: 6,
             label: 'DEFAULT_BLOQUEJADA'
          }
        ]
      };

    vm.errors = [];
    vm.back = back;

    function func(){
      vm.entitat.tipus_client= vm.entitat.tipus_empresaObj.id;
      if (vm.isNew){
          EntitatFactory.add(vm.entitat).then(function (response){
            vm.entitat.id = response.data;
            $rootScope.$broadcast('entitats.main.llista.add', vm.entitat);
            HelperFactory.setParams($stateParams, {'idEntitat': response.data});
            $state.go('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
      }
      else {
          EntitatFactory.update($stateParams.idEntitat, vm.entitat).then(function (response){
            $rootScope.$broadcast('entitats.main.llista.update', vm.entitat);
            $state.go('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
      }
    }

    function back() {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
      if (vm.isNew) {
        $state.go('entitats.main', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else {
        $state.go('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
      }
    }

    if (vm.isNew) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.dades
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.dades', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.entitats.main.dades')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.dades', {
        url: '/dades',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["entitatsHeaderSubmenuLinksValue", function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/dades/dades.tpl.html',
            controller: 'EntitatsMainSubmainDadesCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_DADES_GENERALS'
      });
  }
}());

 (function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.dades.controller:DadesCtrl
   *
   * @description
   *
   */
  EntitatsMainSubmainDadesCtrl.$inject = ["entitatData", "$window", "$rootScope", "$stateParams", "$locale", "$state", "HelperFactory", "UploadFileConstants", "$cookies", "$scope", "AdmConstant", "UploadFactory", "Notification"];
  angular
    .module('itecAdministracio.entitats.main.dades')
    .controller('EntitatsMainSubmainDadesCtrl', EntitatsMainSubmainDadesCtrl);

  function EntitatsMainSubmainDadesCtrl(entitatData,$window, $rootScope, $stateParams, $locale, $state, HelperFactory,UploadFileConstants,$cookies,$scope,AdmConstant,UploadFactory,Notification) {
    var vm = this;
    vm.ctrlName = 'EntitatsMainSubmainDadesCtrl';

    vm.entitat=entitatData.data;
    vm.edit = edit;
    vm.deleteElem = deleteElem;


    function edit(){
      HelperFactory.setParams($stateParams, {'isNew': false, 'idEntitat': vm.entitat.id});
      $state.go('entitats.main.submain.formulari', $stateParams, {'reload': 'entitats.main.submain'});
    }



    function deleteElem() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('entitats.main.llista.delete', vm.entitat.id);
    }


    if (angular.isUndefined($stateParams.idEntitat) || $stateParams.idEntitat === null || !$stateParams.idEntitat) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
      $state.go('entitats.main', $stateParams, {'reload': 'entitats.main.submain'});

    }
    else {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }


    vm.size = UploadFileConstants.SIZE_MINIMAL;
    vm.files = [];
    vm.errFiles = [];

    vm.chunkSize = angular.isUndefined($rootScope.chunkSize) ? UploadFileConstants.CHUNKSIZE : $scope.chunkSize;
    vm.maxSize = angular.isUndefined($rootScope.maxSize) ? UploadFileConstants.MAX_SIZE_UPLOAD_IMAGE : $scope.maxSize;
    vm.showOnlyIcon = angular.isUndefined($rootScope.showOnlyIcon) ? false : $scope.showOnlyIcon;
    vm.iconLeft = angular.isUndefined($rootScope.iconLeft) ? undefined : $scope.iconLeft;
    vm.iconRight = angular.isUndefined($rootScope.iconRight) ? undefined : $scope.iconRight;
    vm.ngDisabled = angular.isUndefined($rootScope.ngDisabled) ? false : $rootScope.ngDisabled;

    vm.onFinishFunction = onFinishUpload;
    vm.uploadFile       = uploadFile;
    vm.fitxercarrega = undefined;



    function cleanForm() {
      vm.files = [];
      vm.errFiles = [];
    }


    function onFinishUpload(objFile, response) {
          $rootScope.$broadcast('$deactivateLoader');
          cleanForm();
          vm.fitxercarrega = undefined;
          Notification.success('GENERIC_SUCCESS');
    }


    function onErrorUpload(objFile, error) {
          $rootScope.$broadcast('$deactivateLoader');
          Notification.processMessage(error.data);
          vm.files = [];
          cleanForm();
          vm.fitxercarrega = undefined;
    }

    function uploadFile() {
      $rootScope.$broadcast('$activateLoader');

      if (angular.isUndefined(vm.files) || vm.files.length === 0) {
        return;
      }

      var oldNewFileId;
      if (!angular.isUndefined(vm.fitxercarrega)) {
          oldNewFileId = vm.fitxercarrega.fields.newFileId;
      }

      var objFile = vm.files[0];
      vm.fitxercarrega = objFile;
      objFile.fields = {
        newFileId: HelperFactory.uniqueMoment(),
      };
      objFile.chunkSize = vm.chunkSize;
      objFile.sizeUrl = 'ok.html'+'?newFileId='+objFile.fields.newFileId+'&name='+objFile.file.name;
      objFile.baseUrl = '/api/' ;
      objFile.controllerUrl = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'entitats' + '/' + vm.entitat.id + '/llicenciesusuaris/upload';
      objFile.headers = { 'authsecurity' : $cookies.get('authsecurity'), 'x-api-version' :  AdmConstant.SERVER_ADMINISTRACIO_VERSION};

      UploadFactory.uploadFile(objFile, onFinishUpload,onErrorUpload);
    }

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name main.administradors
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.administradors', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.entitats.main.administradors')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.administradors', {
        url: '/administradors',
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["entitatsHeaderSubmenuLinksValue", function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }]
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/administradors/administradors.tpl.html',
            controller: 'EntitatsAdministradorsCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_ADMINISTRADORS'
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.administradors.controller:AdministradorsCtrl
   *
   * @description
   *
   */
  EntitatsAdministradorsCtrl.$inject = ["$translate", "EntitatFactory", "entitatData", "Notification", "$stateParams", "$rootScope", "UsuariFactory", "$state", "HelperFactory", "$window"];
  angular
    .module('itecAdministracio.entitats.main.administradors')
    .controller('EntitatsAdministradorsCtrl', EntitatsAdministradorsCtrl);

  function EntitatsAdministradorsCtrl($translate, EntitatFactory, entitatData ,  Notification, $stateParams, $rootScope, UsuariFactory,$state,HelperFactory, $window) {
    var vm = this;
    vm.ctrlName = 'EntitatsAdministradorsCtrl';
    vm.personesAdministradors = [];
    vm.persones = [];
    vm.entitat= entitatData.data;
    vm.readonlychips=true;
    vm.viewuser=viewuser;
    vm.onEnviarAdminsChange=onEnviarAdminsChange;
    vm.listnotificar=[];


    vm.listnotificar = [{id:0, name: $translate.instant('enviar_all_users')},
                    {id:1, name: $translate.instant('enviar_admins')}];

    vm.entitat.tipusnotificacions=vm.listnotificar[vm.entitat.tipusnotificacions];


   if (angular.isUndefined($stateParams.idEntitat) || $stateParams.idEntitat === null || !$stateParams.idEntitat) {
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
    else { 
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': true});
    }   

    function viewuser(id) {
      HelperFactory.setParams($stateParams, {'idUsuari': id});
        var url = $state.href('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
        $window.open(url,'_blank');
    }

     function onEnviarAdminsChange()
    {
      EntitatFactory.update_all_users($stateParams.idEntitat, vm.entitat.tipusnotificacions.id).then(function (response){

          }).catch(function(error){
            vm.errors = Notification.processError(error);
          });
            
      }


  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name usuaris.main
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main', [
      'ui.router',
      'itecAdministracio.usuaris.main.llista',
      'itecAdministracio.usuaris.main.submain.dades',
      'itecAdministracio.usuaris.main.submain.edit'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider", "$urlRouterProvider"];
  angular
    .module('itecAdministracio.usuaris.main')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $stateProvider
      .state('usuaris.main', {
        url: '/',
        params: {
          tipus: 0,
          nom: '',
          submenuInfo: {
            visible: true,
            left: {
              visible: true,
              visibleMenu: true,
              collapsable: true,
              collapsed: false,
              name: 'DEFAULT_USUARIS',
              nameCollapsed: 'DEFAULT_USUARIS',
              icon: 'view_list',
              columns: 4,
              columnsCollapsed: 0
            },
            content: {
              visible: true,
              collapsable: true,
              collapsed: true,
              columnsCollapsed: 0,
              menu: {
                minColumns: 3,
                minOptions: 2
              },
              dynamicMenu: {
                minColumns: 3,
                minOptions: 2
              }
            },
            right: {
              visible: false,
              visibleMenu: false,
            }
          }
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosUsuarisHeaderSubmenuLinksValue", function(permisosUsuarisHeaderSubmenuLinksValue) {
                return permisosUsuarisHeaderSubmenuLinksValue;
              }]
            }
          },
          'leftSide': {
            templateUrl: 'usuaris/main/llista/llista.tpl.html',
            controller: 'UsuarisMainLlistaCtrl',
            controllerAs: 'ctrl',
            resolve: {
                  llistaentitats:["EntitatFactory", "$rootScope", function(EntitatFactory,$rootScope) {
                    if (!angular.isUndefined($rootScope.permisos) && $rootScope.permisos.ROL.read)
                    {
                      return EntitatFactory.getAll().catch(function(){});
                    }
                    else{
                      return undefined;
                    }
                  }]
            }
          },
          breadcrumb: 'DEFAULT_USUARIS'

        }
      })
      .state('usuaris.main.submain', {
        url: '{idUsuari:[0-9]{0,32}}',
        abstract: true,
        views: {
          'content@usuaris': {
            templateUrl: 'shared/submain/submain.tpl.html'
          }
        },
        breadcrumb: {
          dynamicText: '{{breadcrumbText}}',
          stateName: 'usuaris.main.submain.dades',
          textParam: {paramName: 'label', paramValue: '{{usuariData.data.username}}'}
        },
        resolve: {
   /*       usuariData: function(UsuariFactory, $stateParams) {
            if ($stateParams.isNew){
              return {};
            }
            else if (!angular.isUndefined($stateParams.idUsuari)
                      && $stateParams.idUsuari !== null
                      && $stateParams.idUsuari) {
              return UsuariFactory.get($stateParams.idUsuari).catch(function(){});
            }
            else {
              return {};
            }
          },*/
          breadcrumbText: ["$stateParams", function($stateParams){
            if (angular.isUndefined($stateParams.idUsuari) || $stateParams.idUsuari === '') {
              return 'BREADCRUMB_FORMULARI_CREACIO';
            }
            else {
              return 'BREADCRUMB_LABEL';
            }
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name usuaris.main.controller:MainCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main')
    .controller('UsuarisMainCtrl', UsuarisMainCtrl);

  function UsuarisMainCtrl() {
    var vm = this;
    vm.ctrlName = 'UsuarisMainCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name shared.tables
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.tables', []);
}());

(function () {
  'use strict';

  /**
          Útil per posar tds en un ng-repeat d'un tr



   * @ngdoc directive
   * @name shared.directive:replaceMe
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="shared">
       <file name="index.html">
        <replace-me></replace-me>
       </file>
     </example>
   *
   */
      replaceMe.$inject = ["$compile", "$http", "$templateCache"];
  angular
    .module('itecAdministracio.shared.tables')
    .directive('replaceMe', replaceMe);

  function replaceMe($compile, $http, $templateCache) {
    return {
            restrict: 'A',
            scope: {
               row: "=",
               controlador: "="
            },
            link: function (scope, element, attrs) {
                function getTemplate(template) {
                    $http.get(template, {cache: $templateCache}).success(function (templateContent) {
                        element.replaceWith($compile(templateContent)(scope));
                    });
                }

                scope.$watch(attrs.template, function () {
                    if (attrs.template) {
                        getTemplate(attrs.template);
                    }
                });
            }
        }
      }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.shared.submain
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.submain', [
    ]);
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.shared.locale
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.locale', [
      'ui.router'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.shared.locale.factory:LocaleInterceptorFactory
   *
   * @description
   *
   */
  LocaleInterceptorFactory.$inject = ["$cookies", "LocalStorage", "LocaleService"];
  angular
    .module('itecAdministracio.shared.locale')
    .factory('LocaleInterceptorFactory', LocaleInterceptorFactory);

  function LocaleInterceptorFactory($cookies, LocalStorage, LocaleService) {
    var requestInterceptor = {
      response: function(response) {
        var localeCookie = $cookies.get('org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE');
        if (!angular.isUndefined(localeCookie)) {
          var locale = LocalStorage.get('locale');
          if (locale !== localeCookie) {
            LocalStorage.save('locale', localeCookie);
            LocaleService.setLocale(localeCookie);
          }  
        }
        
        return response;
      }
    };
    return requestInterceptor;
  }

}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.shared.estat
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.headerSubmenu', []);
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name administracio.penalitzacions.criticitat.controller:AdministracioPenalitzacionsCriticitatSubmainCtrl
   *
   * @description
   *
   */
  HeaderSubmenuCtrl.$inject = ["optionsHeaderSubmenuData", "AppHeaderSubmenuFactory", "PermisosFactory", "$rootScope", "$scope", "$state", "$stateParams", "$log"];
  angular
    .module('itecAdministracio.shared.headerSubmenu')
    .controller('HeaderSubmenuCtrl', HeaderSubmenuCtrl);

  function HeaderSubmenuCtrl(
                optionsHeaderSubmenuData,
                AppHeaderSubmenuFactory,
                PermisosFactory,
                $rootScope, $scope, $state, $stateParams, $log) {
    var vm = this;

    if (!angular.isUndefined(optionsHeaderSubmenuData.addPermit) && optionsHeaderSubmenuData.addPermit !== null
      && (angular.isUndefined($stateParams.submenuInfo.left.addButton) || $stateParams.submenuInfo.left.addButton)) {
      $stateParams.submenuInfo.left.addButton = PermisosFactory.isVisible(optionsHeaderSubmenuData.addPermit, 'add');
    }

    $scope.$on(optionsHeaderSubmenuData.name + '.showOptionSubmenu',function(event, data){
      if (data.show){
        angular.forEach(optionsHeaderSubmenuData.options, function(key){
          if (key.permit) {
            key.show = PermisosFactory.isVisible(key.permit, 'read');
          } else {
            key.show = true;
          }
        });
      }else{
        angular.forEach(optionsHeaderSubmenuData.options, function(key){
          key.show = false;
        });
      }
    });

    AppHeaderSubmenuFactory.resize($state, $stateParams, optionsHeaderSubmenuData.name);

    AppHeaderSubmenuFactory.createAttributes(vm, optionsHeaderSubmenuData.options, $stateParams, false);


  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.shared.filters
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.filters', [
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.shared.filters.filter:percentatge
   *
   * @description
   *
   */
  percentatgeFilter.$inject = ["$filter"];
  angular
    .module('itecAdministracio.shared.filters')
    .filter('percentatge', percentatgeFilter);

  function percentatgeFilter($filter) {
    return function (input, decimals) {
      if (input === null) {
        input = 0;
      }
      return $filter('number')(input, decimals) + '%';
    }
  }
}());
(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.shared.document
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.document', [
      'itecGuicomponents.commonControls',
      'ngFileUpload'
    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name itecAdministracio.shared.document.directive:admFormFileUploadManteniment
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module='itecAdministracio.shared.document'>
       <file name='index.html'>
        <itec-file-upload-manteniment-directive></itec-file-upload-manteniment-directive>
       </file>
     </example>
   *
   */
  admFormFileUploadManteniment.$inject = ["Upload", "$timeout", "$cookies", "$stateParams"];
  angular
    .module('itecAdministracio.shared.document')
    .directive('admFormFileUploadManteniment', admFormFileUploadManteniment);

  function admFormFileUploadManteniment(Upload, $timeout, $cookies, $stateParams) {
    return {
      restrict: 'EA',
      scope: {
        chunkSize           : '@?',
        selectFilesText     : '@',
        saveFilesText       : '@',
        maxSize             : '@?',
        maxSizeExceededText : '@',
        idEntitat           : '=',
        listCategories      : '=',
        onFinishFunction    : '&?',
        urlBase             : '=',
        urlController       : '='
      },
      templateUrl: 'shared/document/adm-form-file-upload-manteniment-directive.tpl.html',
      replace: false,
      controllerAs: 'vm',
      controller: ["$scope", "AdmConstant", "UploadFactory", "UploadFileConstants", "HelperFactory", function ($scope, AdmConstant, UploadFactory, UploadFileConstants, HelperFactory) {
        var vm = this;
        vm.name = 'admFormFileUploadManteniment';
        
        vm.files      = [];
        vm.errFiles   = [];

        vm.chunkSize  = angular.isUndefined($scope.chunkSize) ? UploadFileConstants.CHUNKSIZE : $scope.chunkSize;
        vm.maxSize    = angular.isUndefined($scope.maxSize) ? UploadFileConstants.MAX_SIZE_UPLOAD_DEFAULT : $scope.maxSize;
        vm.onFinishFunction = $scope.onFinishFunction;

        vm.cleanForm      = cleanForm;
        vm.selectFiles    = selectFiles;
        vm.invalidForm    = UploadFactory.invalidForm;
        vm.uploadFiles    = uploadFiles;
        vm.pending        = UploadFactory.pending;

        /////////////////////////////////////////////////////
        //----------------- functions ---------------------//
        /////////////////////////////////////////////////////

        //quan selecciem fitxers creem els formularis
        function selectFiles() {
          angular.forEach(vm.files, function(objFile) {
            if (angular.isUndefined(objFile.fields)) {
              objFile.fields =  {
                  title : objFile.file.name.substring(0, 255),                  
                  description:'',
                  dataDocument: new Date(),
                  dataDocumentString: '',
                  newFileId: '',
                  idEntitat: $scope.idEntitat,
                  selected: true,
                  extendedForm: false
              };
            }
          });
        }

        function cleanForm() {
          vm.files = [];
          vm.errFiles = [];
        }

        function onFinishUpload(objFile, response) {
          objFile.file.result = response.data;
          objFile.fields.selected = false;
          if (UploadFactory.checkFinalUpload()) {
            vm.cleanForm();
            if (!angular.isUndefined(vm.onFinishFunction)) {
              vm.onFinishFunction();
            }
          }
        }

        function uploadFiles() {
          angular.forEach(vm.files, function(objFile, index) {   

            if (objFile.fields.selected){
              objFile.fields.newFileId = HelperFactory.uniqueMoment(index);

              var date = new Date(objFile.fields.dataDocument);
              objFile.fields.dataDocumentString = date.getTime();
              objFile.fields.idEntitat = $scope.idEntitat;

              init_app({name: 'security', version: AdmConstant.SERVER_ADMINISTRACIO_VERSION} , $cookies.get('authsecurity')).then( function(response){

                objFile.chunkSize = vm.chunkSize;
                objFile.sizeUrl = 'ok.html'+'?newFileId='+objFile.fields.newFileId+'&name='+objFile.file.name;
                objFile.baseUrl = $scope.urlBase;
                objFile.controllerUrl = $scope.urlController;
                objFile.headers = { 'authmanteniment' : response.app.auth,
                                        'x-api-version' : AdmConstant.SERVER_ADMINISTRACIO_VERSION};
                UploadFactory.uploadFile(objFile, onFinishUpload);

              });
            }

          });
        }

      }],
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint 'no-unused-vars': [2, {'args': 'none'}] */
      }
    };
  }
}());
(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name itecAdministracio.shared.document.directive:mntDocumentView
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="shared.document">
       <file name="index.html">
        <itec-document-view></itec-document-view>
       </file>
     </example>
   *
   */
  admDocumentView.$inject = ["$cookies", "$http", "FileSaver", "Blob", "ConvertFactory"];
  angular
    .module('itecAdministracio.shared.document')
    .directive('admDocumentView', admDocumentView);

  function admDocumentView($cookies, $http, FileSaver, Blob, ConvertFactory) {
    return {
      restrict: 'E',
      scope: {
        idEntitat: '=',
        listDocuments: '=',
        showCut: '=?',
        showCopy: '=?',
        showPaste: '=?',
        showEdit: '=?',
        editFunction: '=?',
        showDelete: '=?',
        showUpload: '=?',
        labelConfirmDelete: '@?',
        labelListTitle: '@?',
        labelUploadTitle: '@?',
        labelEditTitle: '@?',
        labelVersionTitle: '@?',
        labelLogTitle: '@?',
        uploadEndFunction: '=?',
        baseUrlUpload: '=',
        controllerUrlUpload: '='
      },
      templateUrl: 'shared/document/adm-document-view-directive.tpl.html',
      replace: false,
      controllerAs: 'ctrl',
      controller: ["DataFactory", "LogoFactory", "$scope", "$log", "$filter", "Notification", "LocalStorage", "$mdDialog", "$document", "AdmConstant", function (DataFactory, LogoFactory, $scope, $log, $filter, Notification, LocalStorage, $mdDialog, $document, AdmConstant) {
        var vm = this;
        vm.name = 'admDocumentView';

        vm.showCut = angular.isUndefined($scope.showCut) ? true : $scope.showCut;
        vm.showCopy = angular.isUndefined($scope.showCopy) ? true : $scope.showCopy;
        vm.showPaste = angular.isUndefined($scope.showPaste) ? true : $scope.showPaste;
        vm.showEdit = angular.isUndefined($scope.showEdit) ? true : $scope.showEdit;
        vm.editFunction = angular.isUndefined($scope.editFunction) ? function(){} : $scope.editFunction;
        vm.showDelete = angular.isUndefined($scope.showDelete) ? true : $scope.showDelete;
        vm.showUpload = angular.isUndefined($scope.showUpload) ? true : $scope.showUpload;
        vm.uploadEndFunction = angular.isUndefined($scope.uploadEndFunction) ? function(){} : $scope.uploadEndFunction;


        vm.date = new Date().getTime();
        //vm.listDocuments = $scope.listDocuments;
        vm.selectedDocuments = [];
        vm.errors = {};
        vm.mode = 0;
        vm.listMode = true;

        vm.labelConfirmDelete = angular.isUndefined($scope.labelConfirmDelete) ? 'SHARED_DOCUMENT_CONFIRM_DELETE_CONTENT' : $scope.labelConfirmDelete;
        vm.labelListTitle = angular.isUndefined($scope.labelListTitle) ? 'SHARED_DOCUMENT_LIST_TITLE' : $scope.labelListTitle;
        vm.labelUploadTitle = angular.isUndefined($scope.labelUploadTitle) ? 'SHARED_DOCUMENT_UPLOAD_TITLE' : $scope.labelUploadTitle;
        vm.labelEditTitle = angular.isUndefined($scope.labelEditTitle) ? 'SHARED_DOCUMENT_EDIT_TITLE' : $scope.labelEditTitle;
        vm.labelVersionTitle = angular.isUndefined($scope.labelVersionTitle) ? 'SHARED_DOCUMENT_VERSION_TITLE' : $scope.labelVersionTitle;
        vm.labelLogTitle = angular.isUndefined($scope.labelLogTitle) ? 'SHARED_DOCUMENT_LOG_TITLE' : $scope.labelLogTitle;


        vm.setSelected = setSelected;
        vm.downloadDocument = downloadDocument;
        vm.downloadDocuments = downloadDocuments;
        vm.deleteDocument = deleteDocument;
        vm.editDocument = editDocument;
        //vm.editDocuments = editDocuments;
        vm.changeListMode = changeListMode;
        vm.submitEditForm = submitEditForm;
        vm.tornar = tornar;
        //vm.refreshDocuments = refreshDocuments;

        vm.editForm = 'editFormDocuments';


        /*Moure a itec-gallery*/
        function setSelected(selected, id) {
          var index = vm.selectedDocuments.indexOf(id);        
          if (index < 0 && selected) {
            vm.selectedDocuments.push(id);
          } else if (index >= 0 && !selected) {
            vm.selectedDocuments.splice(index, 1);
          }
        }

        function changeListMode() {
          vm.listMode = !vm.listMode;
          vm.refreshDocuments();
        }

        function editDocument(id) {
          vm.editFunction(id);
        }

        function deleteDocument(id) {
          LogoFactory.delete($scope.idEntitat, id).then(function(){
            vm.uploadEndFunction();        
          }).catch(function(error){
            Notification.processError(error);
          });
        }

        function downloadDocuments() {
          if (vm.selectedDocuments.length > 0) {

            vm.listVersionDocuments = [];
            angular.forEach(vm.selectedDocuments, function(id) {
              var docAux = {};
              var aux = $filter('filter')($scope.listDocuments, {id : id}, true);
              if (!angular.isUndefined(aux) && aux.length > 0) {
                docAux = aux[0];  
              }
             
              vm.downloadDocument(docAux.id);
              
            });
          } else {
            $log.debug('No s\'ha seleccionat cap document');
          }
        }    

        function downloadDocument(id) {
          var url = AdmConstant.SERVER_PATH_ADMINISTRACIO_COMPLETE_API + 'entitats/' + $scope.idEntitat + '/logos/' + id + '/download';
          
          var headers = {};
          headers['x-api-version'] = AdmConstant.SERVER_ADMINISTRACIO_VERSION;
          headers['authsecurity'] = $cookies.get('authsecurity');

          $http.get(url, {headers: headers}).then(function(response){
            var blob = ConvertFactory.b64toBlob(response.data, response.headers('Content-Type'));
            FileSaver.saveAs(blob, response.headers('filename'));
          });
        }

        function SaveToDisk(fileURL, fileName) {
          // for non-IE
          if (!window.ActiveXObject) {
            var save = document.createElement('a');
            save.href = fileURL;
            save.target = '_blank';
            save.download = fileName || 'unknown';

            var event = document.createEvent('Event');
            event.initEvent('click', true, true);
            save.dispatchEvent(event);
            (window.URL || window.webkitURL).revokeObjectURL(save.href);
          }

          // for IE
          else if ( !! window.ActiveXObject && document.execCommand)     {
            var _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName || fileURL);
            _window.close();
          }
        }

        function tornar(newMode){
          vm.mode = newMode;
          vm.refreshDocuments();
        }

        function submitEditForm() {
          if (vm.editForm.$valid) {
            LogoFactory.update(vm.idEntitat, vm.listEditDocuments[0].id, vm.listEditDocuments[0]).then(function(){
              $log.debug('Document modificats, id: ' + vm.selectedDocuments);
              vm.tornar(0);
            }).catch(function(error){
              vm.errors = Notification.processError(error);
            });
          } else {
            $log.log('invalid');
          }
        }
      }],
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.shared.breadcrumb
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.breadcrumb', [
      'itecGuicomponents.layout.wrapper.breadcrumb'
    ])
    // .config(function(ItecBreadcrumbProvider) {
    //   ItecBreadcrumbProvider.compileWith(function(currentState, $interpolate) {
    //     var state = currentState.self;
    //     if(!state.breadcrumb) { return null; }
    //     if(typeof state.breadcrumb === 'string') {
    //       return {
    //         text: state.breadcrumb,
    //         stateName: state.name
    //       };
    //     } else {
    //       var breadcrumb = angular.copy(state.breadcrumb);

    //       if (breadcrumb.dynamicText) {
    //         breadcrumb.text=$interpolate(breadcrumb.dynamicText)(currentState.locals.globals);
    //       }

    //       if (breadcrumb.list){
    //         var list = JSON.parse($interpolate(breadcrumb.list)(currentState.locals.globals));
    //         var breadcrumbs = [];
    //         angular.forEach(list, function(obj){
    //           var aux = {};
    //           aux.stateName = breadcrumb.stateName;
    //           if (breadcrumb.stateParams){ //tractament per N paràmetres d'estat
    //             var result = '';
    //             angular.forEach(breadcrumb.stateParams, function(stateParam, index){
    //               if (index > 0){
    //                 result += ', ';
    //               }
    //               result = result + '\"' + stateParam.paramName + '\" : \"' + obj[stateParam.paramProperty] + '\"';
    //             });
    //             aux.stateName = aux.stateName + '({' + result + '})';
    //           } else if (breadcrumb.stateParam) {
    //             aux.stateName = aux.stateName + '({' + breadcrumb.stateParam.paramName + ' : ' + obj[breadcrumb.stateParam.paramProperty] + '})';
    //           }
    //           aux.class = breadcrumb.class;
    //           aux.text = breadcrumb.text;
    //           if (breadcrumb.textParams){
    //             var result = '';
    //             angular.forEach(breadcrumb.textParams, function(textParam, index){
    //               if (index > 0){
    //                 result += ', ';
    //               }
    //               result = result + '\"' + textParam.paramName + '\" : \"' + obj[textParam.paramProperty] + '\"';
    //             });
    //             aux.textParams = JSON.parse('{' + result + '}');
    //           } else if (breadcrumb.textParam) {
    //             aux.textParams = JSON.parse('{\"' + breadcrumb.textParam.paramName + '\" : \"' + obj[breadcrumb.textParam.paramProperty] + '\"}');  
    //           } else {
    //             aux.textParams = {};
    //           }
              
    //           breadcrumbs.push(aux);
    //         });
    //         return breadcrumbs;
    //       } else {
            
    //         if (breadcrumb.textParams){ //tractament per N paràmetres de text
    //           var result = '';
    //           angular.forEach(breadcrumb.textParams, function(textParam, index){
    //             if (index > 0){
    //               result += ', ';
    //             }
    //             result = result + '\"' + textParam.paramName + '\" : \"' + $interpolate(textParam.paramValue)(currentState.locals.globals) + '\"';
    //           });
    //           breadcrumb.textParams = JSON.parse('{' + result + '}');
    //         } else if (breadcrumb.textParam) { //tractament per un paràmetre de text
    //           breadcrumb.textParams = JSON.parse('{\"' + breadcrumb.textParam.paramName + '\" : \"' + $interpolate(breadcrumb.textParam.paramValue)(currentState.locals.globals) + '\"}');
    //         } else {
    //           breadcrumb.textParams = {};
    //         }

    //         if (breadcrumb.stateParams){ //tractament per N paràmetres d'estat
    //           var result = '';
    //           angular.forEach(breadcrumb.stateParams, function(stateParam, index){
    //             if (index > 0){
    //               result += ', ';
    //             }
    //             result = result + '\"' + stateParam.paramName + '\" : \"' + $interpolate(stateParam.paramValue)(currentState.locals.globals) + '\"';
    //           });
    //           breadcrumb.stateName = breadcrumb.stateName + '({' + result + '})';
    //         } else if (breadcrumb.stateParam) { //tractament per un paràmetre d'estat
    //           breadcrumb.stateName = breadcrumb.stateName + '({\"' + breadcrumb.stateParam.paramName + '\" : \"' + $interpolate(breadcrumb.stateParam.paramValue)(currentState.locals.globals) + '\"})';
    //         }
    //       }
    //       return breadcrumb;
    //     }
    //   });
    // });
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name rols.main
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main', [
      'ui.router',
      'itecAdministracio.rols.main.llista',
      'itecAdministracio.rols.main.submain.dades',
      'itecAdministracio.rols.main.submain.edit',
      'itecAdministracio.rols.main.submain.permisos'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider", "$urlRouterProvider"];
  angular
    .module('itecAdministracio.rols.main')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $stateProvider
      .state('rols.main', {
        url: '/',
        params: {
          tipus: 0,
          nom: '',
          submenuInfo: {
            visible: true,
            left: {
              visible: true,
              visibleMenu: true,
              collapsable: true,
              collapsed: false,
              name: 'DEFAULT_ROLS',
              nameCollapsed: 'DEFAULT_ROLS',
              icon: 'view_list',
              columns: 4,
              columnsCollapsed: 0
            },
            content: {
              visible: true,
              collapsable: true,
              collapsed: true,
              columnsCollapsed: 0,
              menu: {
                minColumns: 3,
                minOptions: 2
              },
              dynamicMenu: {
                minColumns: 3,
                minOptions: 2
              }
            },
            right: {
              visible: false,
              visibleMenu: false,
            }
          }
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosRolsHeaderSubmenuLinksValue", function(permisosRolsHeaderSubmenuLinksValue) {
                return permisosRolsHeaderSubmenuLinksValue;
              }]
            }
          },
          'leftSide': {
            templateUrl: 'rols/main/llista/llista.tpl.html',
            controller: 'RolsMainLlistaCtrl',
            controllerAs: 'ctrl',
            resolve: {
                  llistaentitats:["EntitatFactory", "$rootScope", function(EntitatFactory,$rootScope) {
                    if (!angular.isUndefined($rootScope.permisos) && $rootScope.permisos.ROL.read)
                    {
                      return EntitatFactory.getAll().catch(function(){});
                    }
                    else{
                      return undefined;
                    }
                  }]
            }
          }
        }
      })
      .state('rols.main.submain', {
        url: '{idRol:[0-9]{0,32}}',
        abstract: true,
        views: {
          'content@rols': {
            templateUrl: 'shared/submain/submain.tpl.html'
          }
        },
        breadcrumb: {
          dynamicText: '{{breadcrumbText}}',
          stateName: 'rols.main.submain.dades',
          textParam: {paramName: 'label', paramValue: '{{rolData.data.nom}}'}
        },
        resolve: {
          rolData: ["RolFactory", "$stateParams", function(RolFactory, $stateParams) {
            if ($stateParams.isNew){
              return {};
            }
            else if (!angular.isUndefined($stateParams.idRol)
                      && $stateParams.idRol !== null
                      && $stateParams.idRol) {
              return RolFactory.get($stateParams.idRol).catch(function(){});
            }
            else {
              return {};
            }
          }],
          breadcrumbText: ["$stateParams", function($stateParams){
            if (angular.isUndefined($stateParams.idRol) || $stateParams.idRol === '') {
              return 'BREADCRUMB_FORMULARI_CREACIO';
            }
            else {
              return 'BREADCRUMB_LABEL';
            }
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name rols.main.controller:MainCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main')
    .controller('RolsMainCtrl', RolsMainCtrl);

  function RolsMainCtrl() {
    var vm = this;
    vm.ctrlName = 'RolsMainCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name productes.main
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main', [
      'ui.router',
      'itecAdministracio.productes.main.llista',
      'itecAdministracio.productes.main.submain.dades',
      'itecAdministracio.productes.main.submain.edit',
      'itecAdministracio.productes.main.submain.permisos',
      'itecAdministracio.productes.main.submain.entitats'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider", "$urlRouterProvider"];
  angular
    .module('itecAdministracio.productes.main')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $stateProvider
      .state('productes.main', {
        url: '/',
        params: {
          tipus: 0,
          nom: '',
          submenuInfo: {
            visible: true,
            left: {
              visible: true,
              visibleMenu: true,
              collapsable: true,
              collapsed: false,
              name: 'DEFAULT_PRODUCTES',
              nameCollapsed: 'DEFAULT_PRODUCTES',
              icon: 'view_list',
              columns: 4,
              columnsCollapsed: 0
            },
            content: {
              visible: true,
              collapsable: true,
              collapsed: true,
              columnsCollapsed: 0,
              menu: {
                minColumns: 3,
                minOptions: 2
              },
              dynamicMenu: {
                minColumns: 3,
                minOptions: 2
              }
            },
            right: {
              visible: false,
              visibleMenu: false,
            }
          }
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["permisosProductesHeaderSubmenuLinksValue", function(permisosProductesHeaderSubmenuLinksValue) {
                return permisosProductesHeaderSubmenuLinksValue;
              }]
            }
          },
          'leftSide': {
            templateUrl: 'productes/main/llista/llista.tpl.html',
            controller: 'ProductesMainLlistaCtrl',
            controllerAs: 'ctrl',
            resolve: {
                  llistaaplicacions:["AplicacioFactory", "$rootScope", function(AplicacioFactory,$rootScope) {
                    if (!angular.isUndefined($rootScope.permisos) && $rootScope.permisos.PRODUCTE.read)
                    {
                      return AplicacioFactory.getAll().catch(function(){});
                    }
                    else{
                      return undefined;
                    }
                  }]
            }
          }
        }
      }
      )
      .state('productes.main.submain', {
        url: '{idProducte:[0-9]{0,32}}',
        abstract: true,
        views: {
          'content@productes': {
            templateUrl: 'shared/submain/submain.tpl.html'
          }
        },
        breadcrumb: {
          dynamicText: '{{breadcrumbText}}',
          stateName: 'productes.main.submain.dades',
          textParam: {paramName: 'label', paramValue: '{{producteData.data.nom}}'}
        },
        resolve: {
          producteData: ["ProducteFactory", "$stateParams", function(ProducteFactory, $stateParams) {
            if ($stateParams.isNew){
              return {};
            }
            else if (!angular.isUndefined($stateParams.idProducte)
                      && $stateParams.idProducte !== null
                      && $stateParams.idProducte) {
              return ProducteFactory.get($stateParams.idProducte).catch(function(){});
            }
            else {
              return {};
            }
          }],
          breadcrumbText: ["$stateParams", function($stateParams){
            if (angular.isUndefined($stateParams.idProducte) || $stateParams.idProducte === '') {
              return 'BREADCRUMB_FORMULARI_CREACIO';
            }
            else {
              return 'BREADCRUMB_LABEL';
            }
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name productes.main.controller:MainCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main')
    .controller('ProductesMainCtrl', ProductesMainCtrl);

  function ProductesMainCtrl() {
    var vm = this;
    vm.ctrlName = 'ProductesMainCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name entitats.main
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main', [
      'ui.router',
      'itecAdministracio.entitats.main.llista',
      'itecAdministracio.entitats.main.dades',
      'itecAdministracio.entitats.main.formulari',
      'itecAdministracio.entitats.main.administradors',
      'itecAdministracio.entitats.main.llicencies',
      'itecAdministracio.entitats.main.sessions',
      'itecAdministracio.entitats.main.logos'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.entitats.main')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main', {
        url: '/',
        params: {              
          tipus: 0,
          nom: '',
          errorproces: undefined,
          submenuInfo: {
            visible: true,
            left: {
              visible: true,
              visibleMenu: true,
              collapsable: true,
              collapsed: false,
              name: 'DEFAULT_ENTITATS',
              nameCollapsed: 'DEFAULT_ENTITATS',
              icon: 'view_list',
              columns: 4,
              columnsCollapsed: 0
            },
            content: {
              visible: true,
              collapsable: true,
              collapsed: true,
              columnsCollapsed: 0,
              menu: {
                minColumns: 3,
                minOptions: 2
              },
              dynamicMenu: {
                minColumns: 3,
                minOptions: 2
              }
            },
            right: {
              visible: false,
              visibleMenu: false,
            }
          }
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: ["entitatsHeaderSubmenuLinksValue", function(entitatsHeaderSubmenuLinksValue) {
                return entitatsHeaderSubmenuLinksValue;
              }]
            }
          },
          'leftSide': {
            templateUrl: 'entitats/main/llista/llista.tpl.html',
            controller: 'EntitatsMainLlistaCtrl',
            controllerAs: 'ctrl'
          }
        }
      })
      .state('entitats.main.submain', {
        url: '{idEntitat:[0-9]{0,32}}',
        abstract: true,
        views: {
          'content@entitats': {
            templateUrl: 'shared/submain/submain.tpl.html'
          }
        },
        breadcrumb: {
          dynamicText: '{{breadcrumbText}}',
          stateName: 'entitats.main.submain.dades',
          textParam: {paramName: 'label', paramValue: '{{entitatData.data.nom}}'}
        },
        resolve: {
          entitatData: ["EntitatFactory", "$stateParams", function(EntitatFactory, $stateParams) {
            if ($stateParams.isNew){
              return {};
            }
            else if (!angular.isUndefined($stateParams.idEntitat)
                      && $stateParams.idEntitat !== null
                      && $stateParams.idEntitat) {
              return EntitatFactory.get($stateParams.idEntitat).catch(function(){});
            }
            else {
              return {};
            }
          }],
          breadcrumbText: ["$stateParams", function($stateParams){
            if (angular.isUndefined($stateParams.idEntitat) || $stateParams.idEntitat === '') {
              return 'BREADCRUMB_FORMULARI_CREACIO';
            }
            else {
              return 'BREADCRUMB_LABEL';
            }
          }]
        }
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name entitats.main.controller:MainCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main')
    .controller('MainCtrl', MainCtrl);

  function MainCtrl() {
    var vm = this;
    vm.ctrlName = 'MainCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.usuari', [

    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  UsuariFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.usuari')
    .factory('UsuariFactory', UsuariFactory);

  function UsuariFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'usuaris';
    
    var UsuariBase = {
        
      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },

      get: function(id){
        var url = api + '/' + id + '/edit';
        return DataFactory.get(url);
      },

      add: function(obj){
        return DataFactory.add(api,obj);
      },

      update: function(id, obj){
        var url = api + '/' + id;
        return DataFactory.update(url,obj);
      },

      delete: function(id){
        var url = api;
        return DataFactory.delete(url, id);
      },
      avisconfirmar:function(id){
        var url = api + '/' + id + '/avisconfirmar';
        return DataFactory.add(url, {});
      },
      avisregistre:function(id){
        var url = api + '/' + id + '/avisregistre';
        return DataFactory.add(url,{});
      },
       getview: function(id){
        var url = api + '/' + id + '/view';
        return DataFactory.get(url);
      },
       renew: function(id, idproducte,tipusclient,versio){
        var url = api + '/' + id + '/renewdemo' + '/' + idproducte + '/' + tipusclient + '/' + versio ;
        return DataFactory.add(url,{});
      },
       unlock: function(id){
        var url = api + '/' + id + '/unlock';
        return DataFactory.add(url,{});
      }
    };
    return UsuariBase;
  }
}());

(function () {
  'use strict';
  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.tyk', [
    ]);
}());

(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name itecAdministracio.api.entitat.factory:EntitatFactory
   *
   * @description
   *
   */
  TykFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.tyk')
    .factory('TykFactory', TykFactory);
  function TykFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'tyks';

    var TykBase = {

      getTyksEntitat: function(identitat){
        var url = api;
        return DataFactory.getWithParams(url, {"identitat":identitat});
      }
    };
    return TykBase;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.tema', [

    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  TemaFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.tema')
    .factory('TemaFactory', TemaFactory);

  function TemaFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'temes';
    
    var TemaBase = {
      gettemesvistesarrel: function(idrol){
        var url = api +'/temesvistesarrel' ;
        return DataFactory.getWithParams(url, {"idrol":idrol});
      },        
      getfills: function(id,idrol){
        var url = api + '/' + id + '/fills';
        return DataFactory.getWithParams(url, {"idrol":idrol});
      },
      getobjectes: function(id,idrol){
        var url = api + '/' + id + '/objectes';
        return DataFactory.getWithParams(url, {"idrol":idrol});
      }/*,
      getacls: function(id,idrol,idvistaobjecte){
        var url = api + '/' + id + '/acls';
        return DataFactory.getWithParams(url, {"idrol":idrol,"idvistaobjecte":idvistaobjecte});
      }  */       
    };
    return TemaBase;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.rol', [

    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  RolFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.rol')
    .factory('RolFactory', RolFactory);

  function RolFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'rols';
    
    var RolBase = {
        
      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },
      get: function(id){
        var url = api + '/' + id;
        return DataFactory.get(url);
      },
      add: function(obj){
        return DataFactory.add(api,obj);
      },

      duplicate: function(obj){
        return DataFactory.add(api+'/duplicate',obj);
      },

      update: function(id, obj){
        var url = api + '/' + id;
        return DataFactory.update(url,obj);
      },
      delete: function(id){
        var url = api;
        return DataFactory.delete(url, id);
      },
      updateacls: function(id, obj){
        var url = api + '/' + id + '/acls';
        return DataFactory.update(url,obj);
      }

    };
    return RolBase;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.productebotiga', [

    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  ProducteBotigaFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.productebotiga')
    .factory('ProducteBotigaFactory', ProducteBotigaFactory);

  function ProducteBotigaFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'productesbotiga';

    var ProducteBase = {
      getAll: function(){
        return DataFactory.get(api);
      },
      getProductesBotigaEntitats: function(){
        var url = api + '/productebotigaentitats';
        return DataFactory.get(url);
      }
    };
    return ProducteBase;
  }
}());

(function () {
  'use strict';
  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.producte', [
    ]);
}());
(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  ProducteFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.producte')
    .factory('ProducteFactory', ProducteFactory);
  function ProducteFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'productes';

    var ProducteBase = {
      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },
      getProductesEntitats:function(){
        var url = api + '/productesentitats';
        return DataFactory.get(url);
      },
      get: function(id){
        var url = api + '/' + id;
        return DataFactory.get(url);
      },
      add: function(obj){
        return DataFactory.add(api,obj);
      },
      duplicate: function(obj){
        return DataFactory.add(api+'/duplicate',obj);
      },
      update: function(id, obj){
        var url = api + '/' + id;
        return DataFactory.update(url,obj);
      },
      delete: function(id){
        var url = api;
        return DataFactory.delete(url, id);
      },
      gettemesvistesarrel: function(idproducte){
        var url = api +'/temesvistesarrel' ;
        return DataFactory.getWithParams(url, {"idproducte":idproducte});
      },
      getfills: function(id,idproducte){
        var url = api + '/' + id + '/fills';
        return DataFactory.getWithParams(url, {"idproducte":idproducte});
      },
      updatevistes: function(id, obj){
        var url = api + '/' + id + '/vistes';
        return DataFactory.update(url,obj);
      },
      updaterols: function(id, obj){
        var url = api + '/' + id + '/updaterols';
        return DataFactory.update(url);
      },
      getProducteEntitats: function(id,form){
        var url = api + '/' + id + '/entitats' ;
        return DataFactory.getWithParams(url, form);
      },
    };
    return ProducteBase;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.persona', [

    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  PersonaFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.persona')
    .factory('PersonaFactory', PersonaFactory);

  function PersonaFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'persones';
    var PersonaBase = {
      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },

      get: function(id){
        var url = api + '/' + id;
        return DataFactory.get(url);
      },

      getByUserName: function(id){
        var url = api + '/getByUserName?idUserName=' + id;
        return DataFactory.get(url);
      },

      add: function(obj){
        return DataFactory.add(api,obj);
      },

      update: function(id, obj){
        var url = api + '/' + id;
        return DataFactory.update(url,obj);
      },

      delete: function(id){
        var url = api;
        return DataFactory.delete(url, id);
      },

      getOperacions: function(id, form){
        var url = api + '/' + id + '/operacions';
        return DataFactory.getWithParams(url, form);
      },

      getPersonaEspais: function(id, form){
        var url = api + '/' + id + '/persona_espais';
        return DataFactory.getWithParams(url, form);
      },

      getPersonesNoAssociades: function(id){
        var url = api + '/' + id + '/persona_espais/no_associades';
        return DataFactory.get(url);
      },

      addPersonaEspais: function(id, form){
        var url = api + '/' + id + '/persona_espais';
        return DataFactory.add(url, form);
      },

      updatePersonaEspais: function(id, form){
        var url = api + '/' + id + '/persona_espais';
        return DataFactory.update(url, form);
      },

      deletePersonaEspai: function(id, idPersonaEspai, recursiu){
        var url = api + '/' + id + '/persona_espais/' + idPersonaEspai;
        return DataFactory.deleteWithParams(url, {recursiu: recursiu});
      },
    };
    return PersonaBase;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.api.logout
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.logout', [

    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.logout.factory:LogoutFactory
   *
   * @description
   *
   */
  LogoutFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.logout')
    .factory('LogoutFactory', LogoutFactory);

  function LogoutFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'j_spring_security_logout';
    
    var LogoutBase = {

      get: function(){
        return DataFactory.get(api);
      }
      
    };
    return LogoutBase;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.logo', [

    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  LogoFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.logo')
    .factory('LogoFactory', LogoFactory);

  function LogoFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'entitats';
    
    var LogoBase = {

      getAll: function(idEntitat){
        var url = api + '/' + idEntitat + '/logos';
        return DataFactory.get(url);
      },

      get: function(idEntitat, id, form){
        var url = api + '/' + idEntitat + '/logos/' + id;
        return DataFactory.getWithParams(url, form);
      },
        
      add: function(idEntitat, obj){
        var url = api + '/' + idEntitat + '/logos';
        return DataFactory.add(url,obj);
      },
      makeLogoPredeterminat:function(idEntitat, id){
        var url = api + '/' + idEntitat + '/logos/' + id + '/makeLogoPredeterminat';
        return DataFactory.update(url,{});
      },
      update: function(idEntitat, id, obj){
        var url = api + '/' + idEntitat + '/logos/' + id;
        return DataFactory.update(url,obj);
      },

      delete: function(idEntitat, id){
        var url = api + '/' + idEntitat + '/logos';
        return DataFactory.delete(url, id);
      }
      
    };
    return LogoBase;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.llicencia', [

    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.persona.factory:PersonaFactory
   *
   * @description
   *
   */
  LlicenciaFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.llicencia')
    .factory('LlicenciaFactory', LlicenciaFactory);

  function LlicenciaFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'entitats';
    
    var LlicenciaBase = {

      get: function(idEntitat, id, form){
        var url = api + '/' + idEntitat + '/llicencies/' + id;
        return DataFactory.getWithParams(url, form);
      },
        
      add: function(idEntitat, obj){
        var url = api + '/' + idEntitat + '/llicencies';
        return DataFactory.add(url,obj);
      },

      update: function(idEntitat, id, obj){
        var url = api + '/' + idEntitat + '/llicencies/' + id;
        return DataFactory.update(url,obj);
      },

      delete: function(idEntitat, id){
        var url = api + '/' + idEntitat + '/llicencies';
        return DataFactory.delete(url, id);
      }
      
    };
    return LlicenciaBase;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.entitat', [

    ]);
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.entitat.factory:EntitatFactory
   *
   * @description
   *
   */
  EntitatFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.entitat')
    .factory('EntitatFactory', EntitatFactory);

  function EntitatFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'entitats';

    var EntitatBase = {

      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },

      get: function(id){
        var url = api + '/' + id;
        return DataFactory.get(url);
      },

      add: function(obj){
        return DataFactory.add(api,obj);
      },

      update: function(id, obj){
        var url = api + '/' + id;
        return DataFactory.update(url,obj);
      },
      delete: function(id){
        var url = api;
        return DataFactory.delete(url, id);
      },
      getsessions: function(id){
        var url = api + '/' + id + '/sessions';
        return DataFactory.get(url);
      },
      update_all_users: function(id, obj){
        var url = api + '/notificacio' + '/' + id;
        return DataFactory.update(url,obj);
      },
      getGroup: function(id){
        var url = api + '/' + id + '/group';
        return DataFactory.get(url);
      }
    };
    return EntitatBase;
  }
}());

(function () {
  'use strict';
  /* @ngdoc object
   * @name itecAdministracio.api.persona
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.aplicacio', [
    ]);
}());
(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name itecAdministracio.api.entitat.factory:EntitatFactory
   *
   * @description
   *
   */
  AplicacioFactory.$inject = ["AdmConstant", "DataFactory"];
  angular
    .module('itecAdministracio.api.aplicacio')
    .factory('AplicacioFactory', AplicacioFactory);
  function AplicacioFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'aplicacions';

    var AplicacioBase = {

      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },
      get: function(id){
        var url = api + '/' + id;
        return DataFactory.get(url);
      },
      getAplicacionsProducte: function(idproducte,identitat){
        var url = api;
        return DataFactory.getWithParams(url, {"idproducte":idproducte,"identitat":identitat});
      }
    };
    return AplicacioBase;
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name usuaris
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris', [
      'ui.router',
      'itecAdministracio.usuaris.main'
    ]);
}());

(function () {
  'use strict';

  /* @ngdoc service
   * @name itecAdministracio.permisos.categories:usuarisHeaderSubmenuLinks
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris')
    .value('permisosUsuarisHeaderSubmenuLinksValue',  {
      'name'     : 'usuaris.main',
      'addPermit'    : 'AFEGIRUSUARI',
      'options'  : {
          '0': {
            'name'         : 'DEFAULT_DADES_GENERALS',
            'state'        : 'usuaris.main.submain.dades',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'LOGIN',
            'stateOptions' : {'reload': 'usuaris.main.submain'}
          }
      }
    });
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider", "$urlRouterProvider"];
  angular
    .module('itecAdministracio.usuaris')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.when('/usuaris', '/usuaris/');

    $stateProvider
      .state('usuaris', {
        url: '/usuaris',
        views: {
          'wrapper': {
            templateUrl: 'usuaris/usuaris.tpl.html',
            controller: ["AppHeaderSubmenuFactory", "$stateParams", "$scope", "$rootScope", function(AppHeaderSubmenuFactory, $stateParams, $scope, $rootScope) {
              var vm = this;

              $scope.$on('changeSides', function (event, data) {
                AppHeaderSubmenuFactory.setStateParams($stateParams, data, false);
                AppHeaderSubmenuFactory.setWrapperAttributesFromChild(vm, data);
              });
            }],
            controllerAs: 'ctrl'
          }
        },
        resolve: {
          permisosLoad: ["PermisosFactory", "LocaleService", "$rootScope", "DataFactory", "ApiLayoutConstant", function(PermisosFactory, LocaleService, $rootScope, DataFactory, ApiLayoutConstant) {
            if (angular.isUndefined($rootScope.permisos) && $rootScope.permisos == null ) {
              /* Hay casos en que se ejecuta antes este "resolve" que el controlador de la "app"
                 ("/app-controller.js") y, por tanto, los permisos no llegan definidos aquí. */

              DataFactory.setApiParameters('security', ApiLayoutConstant.SERVER_VERSION_ADMINISTRACIO,
                  'authsecurity','');
              PermisosFactory.setApiParameters(ApiLayoutConstant.SERVER_PATH_ADMINISTRACIO + 'permisos',
                  'notfound');

              var promise= PermisosFactory.load().then(function (response) {
                $rootScope.permisos = response.data.permisos;
                $rootScope.usuari = response.data.usuari;
                LocaleService.setLocaleByIdioma($rootScope.usuari.idioma);
              });
              return promise;
            }
          }]
        },
        breadcrumb: "DEFAULT_USUARIS"
     });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name usuaris.controller:UsuarisCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris')
    .controller('UsuarisCtrl', UsuarisCtrl);

  function UsuarisCtrl() {
    var vm = this;
    vm.ctrlName = 'UsuarisCtrl';
      

  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name shared
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared', [
      'itecAdministracio.shared.breadcrumb',
      'itecAdministracio.shared.headerSubmenu',
      'itecAdministracio.shared.filters',
      'itecAdministracio.shared.submain',
      'itecAdministracio.shared.locale',
      'itecAdministracio.shared.tables',
      'itecAdministracio.shared.document'
    ]);
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name rols
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols', [
      'ui.router',
      'itecAdministracio.rols.main'
    ]);
}());

(function () {
  'use strict';

  /* @ngdoc service
   * @name itecAdministracio.permisos.categories:rolsHeaderSubmenuLinks
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols')
    .value('permisosRolsHeaderSubmenuLinksValue',  {
      'name'     : 'rols.main',
      'addPermit'    : 'AFEGIRROL',
      'options'  : {
          '0': {
            'name'         : 'DEFAULT_DADES_GENERALS',
            'state'        : 'rols.main.submain.dades',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'ROL',
            'stateOptions' : {'reload': 'rols.main.submain'}
          },
          '1': {
            'name'         : 'DEFAULT_ROLS_PERMISOS',
            'state'        : 'rols.main.submain.permisos',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'ROL',
            'stateOptions' : {'reload': 'rols.main.submain'}
          }
      }
    });
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider", "$urlRouterProvider"];
  angular
    .module('itecAdministracio.rols')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.when('/rols', '/rols/');

    $stateProvider
      .state('rols', {
        url: '/rols',
        views: {
          'wrapper': {
            templateUrl: 'rols/rols.tpl.html',
            controller: ["AppHeaderSubmenuFactory", "$stateParams", "$scope", "$rootScope", function(AppHeaderSubmenuFactory, $stateParams, $scope, $rootScope) {
              var vm = this;

              $scope.$on('changeSides', function (event, data) {
                AppHeaderSubmenuFactory.setStateParams($stateParams, data, false);
                AppHeaderSubmenuFactory.setWrapperAttributesFromChild(vm, data);
              });
            }],
            controllerAs: 'ctrl'
          }
        },
        resolve: {
          permisosLoad: ["PermisosFactory", "LocaleService", "$rootScope", "DataFactory", "ApiLayoutConstant", function(PermisosFactory,LocaleService,$rootScope, DataFactory, ApiLayoutConstant) {
            if (angular.isUndefined($rootScope.permisos) && $rootScope.permisos == null ) {
              DataFactory.setApiParameters('security', ApiLayoutConstant.SERVER_VERSION_ADMINISTRACIO,
                'authsecurity','');
              PermisosFactory.setApiParameters(ApiLayoutConstant.SERVER_PATH_ADMINISTRACIO + 'permisos',
                'notfound');

              var promise= PermisosFactory.load().then(function (response) {
                $rootScope.permisos = response.data.permisos;
                $rootScope.usuari = response.data.usuari;
                LocaleService.setLocaleByIdioma($rootScope.usuari.idioma);
              });
              return promise;
            }
          }]
        },
        breadcrumb: "DEFAULT_ROLS"
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name rols.controller:UsuarisCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols')
    .controller('RolsCtrl', RolsCtrl);

  function RolsCtrl() {
    var vm = this;
    vm.ctrlName = 'RolsCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name productes
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes', [
      'ui.router',
      'itecAdministracio.productes.main'
    ]);
}());

(function () {
  'use strict';

  /* @ngdoc service
   * @name itecAdministracio.permisos.categories:productesHeaderSubmenuLinks
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes')
    .value('permisosProductesHeaderSubmenuLinksValue',  {
      'name'     : 'productes.main',
      'addPermit'    : 'AFEGIRPRODUCTE',
      'options'  : {
          '0': {
            'name'         : 'DEFAULT_DADES_GENERALS',
            'state'        : 'productes.main.submain.dades',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'PRODUCTE',
            'stateOptions' : {'reload': 'productes.main.submain'}
          },
          '1': {
            'name'         : 'DEFAULT_PRODUCTE_PERMISOS',
            'state'        : 'productes.main.submain.permisos',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'PRODUCTE',
            'stateOptions' : {'reload': 'productes.main.submain'}
          },
          '2': {
            'name'         : 'DEFAULT_ENTITATS',
            'state'        : 'productes.main.submain.entitats',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'PRODUCTE',
            'stateOptions' : {'reload': 'productes.main.submain'}
          }
      }
    });
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider", "$urlRouterProvider"];
  angular
    .module('itecAdministracio.productes')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.when('/productes', '/productes/');

    $stateProvider
      .state('productes', {
        url: '/productes',
        views: {
          'wrapper': {
            templateUrl: 'productes/productes.tpl.html',
            controller: ["AppHeaderSubmenuFactory", "$stateParams", "$scope", "$rootScope", function(AppHeaderSubmenuFactory, $stateParams, $scope, $rootScope) {
              var vm = this;

              $scope.$on('changeSides', function (event, data) {
                AppHeaderSubmenuFactory.setStateParams($stateParams, data, false);
                AppHeaderSubmenuFactory.setWrapperAttributesFromChild(vm, data);
              });
            }],
            controllerAs: 'ctrl'
          }
        },
        resolve: {
          permisosLoad: ["PermisosFactory", "LocaleService", "$rootScope", "DataFactory", "ApiLayoutConstant", function(PermisosFactory,LocaleService,$rootScope, DataFactory, ApiLayoutConstant) {
            if (angular.isUndefined($rootScope.permisos) && $rootScope.permisos == null ) {
              DataFactory.setApiParameters('security', ApiLayoutConstant.SERVER_VERSION_ADMINISTRACIO,
                'authsecurity','');
              PermisosFactory.setApiParameters(ApiLayoutConstant.SERVER_PATH_ADMINISTRACIO + 'permisos',
                'notfound');

              var promise= PermisosFactory.load().then(function (response) {
                $rootScope.permisos = response.data.permisos;
                $rootScope.usuari = response.data.usuari;
                LocaleService.setLocaleByIdioma($rootScope.usuari.idioma);
              });
              return promise;
            }
          }]
        },
        breadcrumb: "DEFAULT_PRODUCTES"
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name productes.controller:ProductesCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes')
    .controller('ProductesCtrl', ProductesCtrl);

  function ProductesCtrl() {
    var vm = this;
    vm.ctrlName = 'ProductesCtrl';
  }
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name entitats
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats', [
      'ui.router',
      'itecAdministracio.entitats.main'
    ]);
}());

(function () {
  'use strict';

  /* @ngdoc service
   * @name itecAdministracio.permisos.categories:usuarisHeaderSubmenuLinks
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats')
    .value('entitatsHeaderSubmenuLinksValue',  {
      'name'     : 'entitats.main',
      'addPermit': 'AFEGIRENT',
      'options'  : {
          '0': {
            'name'         : 'DEFAULT_DADES_GENERALS',
            'state'        : 'entitats.main.submain.dades',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'ENTITATMENU',
            'stateOptions' : {'reload': 'entitats.main.submain'}
          },
           '1': {
            'name'         : 'DEFAULT_ADMINISTRADORS',
            'state'        : 'entitats.main.submain.administradors',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'ADMINISTRADORSENTMENU',
            'stateOptions' : {'reload': 'entitats.main.submain'}
          },
           '2': {
            'name'         : 'SUBSCRIPCIONS',
            'state'        : 'entitats.main.submain.llicencies',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'PRODUCTEENTMENU',
            'stateOptions' : {'reload': 'entitats.main.submain'}
          },
          '3': {
           'name'         : 'USUARIS_SESSIO_TITOL',
           'state'        : 'entitats.main.submain.sessions',
           'icon'         : '',
           'show'         : false,
           'onclick'      : '',
           'permit'       : 'USUARISSESSIO',
           'stateOptions' : {'reload': 'entitats.main.submain'}
         },
          '4': {
            'name'         : 'DEFAULT_LOGOS',
            'state'        : 'entitats.main.submain.logos',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'LOGOSMENU',
            'stateOptions' : {'reload': 'entitats.main.submain'}
          }
      }
    });
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider", "$urlRouterProvider"];
  angular
    .module('itecAdministracio.entitats')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.when('/entitats', '/entitats/');

    $stateProvider
      .state('entitats', {
        url: '/entitats',
        views: {
        'wrapper': {
            templateUrl: 'entitats/entitats.tpl.html',
            controller: ["AppHeaderSubmenuFactory", "$stateParams", "$scope", "$rootScope", function(AppHeaderSubmenuFactory, $stateParams, $scope, $rootScope) {
              var vm = this;

              $scope.$on('changeSides', function (event, data) {
                AppHeaderSubmenuFactory.setStateParams($stateParams, data, false);
                AppHeaderSubmenuFactory.setWrapperAttributesFromChild(vm, data);
              });
            }],
            controllerAs: 'ctrl'
          }
        },
        resolve: {
          permisosLoad: ["PermisosFactory", "LocaleService", "$rootScope", "DataFactory", "ApiLayoutConstant", function(PermisosFactory,LocaleService,$rootScope, DataFactory, ApiLayoutConstant) {
            if (angular.isUndefined($rootScope.permisos) && $rootScope.permisos == null ) {
              DataFactory.setApiParameters('security', ApiLayoutConstant.SERVER_VERSION_ADMINISTRACIO,
                'authsecurity','');
              PermisosFactory.setApiParameters(ApiLayoutConstant.SERVER_PATH_ADMINISTRACIO + 'permisos',
                'notfound');

              var promise= PermisosFactory.load().then(function (response) {
                $rootScope.permisos = response.data.permisos;
                $rootScope.usuari = response.data.usuari;
                LocaleService.setLocaleByIdioma($rootScope.usuari.idioma);
              });
              return promise;
            }
          }]
        },
        breadcrumb: "DEFAULT_ENTITATS"
      });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name entitats.controller:EntitatsCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats')
    .controller('EntitatsCtrl', EntitatsCtrl);

  function EntitatsCtrl() {
    var vm = this;
    vm.ctrlName = 'EntitatsCtrl';
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.constant:theme
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio')
    .value('theme', {
      'name': 'security'
    });
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.constant:headerMenuLinks
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio')
    .value('headerMenuLinks', {
        '0': {
            'name': 'DEFAULT_USUARIS',
            'state': 'usuaris',
            'onclick': '',
            'permit': 'USUARISMENU'
        },
        '1':{
            'name': 'DEFAULT_ROLS',
            'state': 'rols',
            'onclick': '',
            'permit': 'ROLSMENU'
        },

        '2':{
            'name': 'DEFAULT_ENTITATS',
            'state': 'entitats',
            'onclick': '',
            'permit': 'ENTITATMENU'
        },

        '3':{
            'name': 'DEFAULT_PRODUCTES',
            'state': 'productes',
            'onclick': '',
            'permit': 'PRODUCTEMENU'
        }
    });
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.constant:headerMenuIconsPosition
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio')
    .value('headerMenuIconsPosition', "up"); // Opciones: 'up', 'down', 'left' o 'right'.
}());

(function () {
  'use strict';

  /* @ngdoc object
   * @name api
   * @description
   *
   */
  angular
    .module('itecAdministracio.api', [
      'ui.router',
      'itecAdministracio.api.persona',
      'itecAdministracio.api.usuari',
      'itecAdministracio.api.entitat',
      'itecAdministracio.api.llicencia',
      'itecAdministracio.api.producte',
	    'itecAdministracio.api.rol',
      'itecAdministracio.api.logo',
      'itecAdministracio.api.productebotiga',
      'itecAdministracio.api.tema',
      'itecAdministracio.api.logout',
      'itecAdministracio.api.aplicacio',
      'itecAdministracio.api.tyk'
    ]);
}());

(function () {
  'use strict';

  config.$inject = ["$stateProvider"];
  angular
    .module('itecAdministracio.api')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('api', {
        url: '/api',
        templateUrl: 'api/views/api.tpl.html',
        controller: 'ApiCtrl',
        controllerAs: 'api'
      });
  }
}());

(function () {
  'use strict';

  config.$inject = ["$urlRouterProvider", "$stateProvider"];
  angular
    .module('itecAdministracio')
    .config(config);

  function config($urlRouterProvider, $stateProvider) {
    $urlRouterProvider.when('', '/usuaris');
    $urlRouterProvider.otherwise('/');

    $stateProvider
    .state('pagenotfound', {
      url: '/',
      views: {
        'wrapper': {
          template: '<itec-notfound initial-state="usuaris"></itec-notfound>',
        }
      },
    });
  }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio')
    .factory('AppFactory', AppFactory);

  function AppFactory() {
    /* private */
    var existsSession  = false;
    var appInitialized = false;

    /* public */
    var AppFactoryBase = {
      existsSession: function() {
        return existsSession;
      },
      setExistsSession: function(bool) {
        existsSession = (bool === true)? true : false;
      },
      getAppInitialized: function() {
        return appInitialized;
      },
      setAppInitialized: function(bool) {
        appInitialized = (bool === true)? true : false;
      }
    };

    AppFactoryBase.loadParams = function () {
        var params = {};

        /*
          // Carga síncrona de un fichero.
	        var xhr = new XMLHttpRequest();
	        xhr.onreadystatechange = function() {
	            if (xhr.readyState == 4 && xhr.status == 200) {
	                loadApps(xhr);
	            }
	        };
	        xhr.open('GET', 'tcqi-filename.json', false);
	        xhr.send();

	        function loadApps(json) {
	            var items = angular.fromJson(json.response);

	            params.foo = items.foo;
	        }
        */

        return params;
    };
    
    return AppFactoryBase;
  }
}());

(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name itecAdministracio.controller:AppCtrl
     *
     * @description
     *
     */
    AppCtrl.$inject = ["theme", "headerMenuLinks", "headerMenuIconsPosition", "$timeout", "AdmConstant", "DataFactory", "$location", "$scope", "AppWrapperFactory", "$rootScope", "LogoutFactory", "deviceDetector", "ApiLayoutConstant", "PermisosFactory", "LocaleService", "$state", "AppFactory"];
    angular
      .module('itecAdministracio')
      .controller('AppCtrl', AppCtrl);

    function AppCtrl(theme, headerMenuLinks, headerMenuIconsPosition, $timeout, AdmConstant, DataFactory, $location, $scope, AppWrapperFactory, $rootScope,LogoutFactory, deviceDetector, ApiLayoutConstant, PermisosFactory,LocaleService, $state, AppFactory) {

      var vm = this;

      $rootScope.modul = theme;

      AdmConstant.SERVER_PATH_ADMINISTRACIO_COMPLETE_API  = 'https://'+$location.$$host+'/api/security/';

      vm.app = {};
      vm.app.theme = theme;
      vm.app.headerMenuLinks = headerMenuLinks;
      vm.app.headerMenuIconsPosition = headerMenuIconsPosition;
      vm.logout=logout;
 

      function logout() {
        var promise = LogoutFactory.get().then(
          function(response){
          }).catch(function(error){
          });
        return promise;
      }

      vm.accesosAppsTCQi = undefined;

      /*
        Hem de fer varies crides paraleles per carregar tota la informació necessaria el primer cop (permisos, configuracions, notificacions, etc). Aquesta estructura permet saber com portem la carrega d'avançada porcentualment.
      */
      vm.initialized    = false;
      vm.loaded         = false;
      var promisesArray = [];
      vm.loadCalls = {
        num: 1,
        done: 0,
        errors: 0,
        initial: 40, //quan arribem aqui, ja tenim una part cargada
        percentage: 0, 
        loaded: false,
        calculate: function() {
          var callsPerc   = (this.done/this.num);
          var ponderat    = callsPerc*(100-this.initial);
          var perc        = this.initial+ponderat;
          this.percentage = Math.min(perc,100);
          this.loaded     = (this.done >= this.num);
        }
      };
      vm.loadCalls.percentage = vm.loadCalls.initial;

      function cridaPosterior(promise) {
        promisesArray.push(promise);
        
        vm.loadCalls.num++;
        promise.then(function(){
          vm.loadCalls.done++;
          vm.loadCalls.calculate();
        }).catch(function(){
          vm.loadCalls.done++;
          vm.loadCalls.errors++;
          vm.loadCalls.calculate();
        }); 
      }

      function endInitialization(delay) {
        //ho encapsulo en un timeout per allargar la directiva de loading esperant al renderitzat, pero caldria una solucio mes optima
        vm.loadCalls.calculate();
        $timeout(function() {
          AppFactory.setAppInitialized(true);
          vm.initialized = AppFactory.getAppInitialized();
        }, delay || 0);
      }

      function loadEndingInsurance() {
        //en cas d'error "d'infinit" al promisesArray, posem aquest metode per assegurar-nos que informara al AppFactory igualment als 10 segons.
        endInitialization(10000);
      }


      //Per evitar multiples crides paral·leles que causen un 'session expired' error primer fem una que obté els permisos i de pas crea una sessió unica, i després fem totes les crides conseqüents.
      PermisosFactory.loadWithURL(ApiLayoutConstant.SERVER_PATH_ADMINISTRACIO + 'accesos').then(function(response) {
        vm.accesosAppsTCQi = response.data.acces;
        vm.loadCalls.done++;
        endInitialization(2000);          
      }).catch(function(error){
        endInitialization();
        console.log(error);
        $state.go('pagenotfound');
      }).finally(function(){
        loadEndingInsurance();
      });


      AppWrapperFactory.init($scope);

      var miliseconds = 0;
      if (angular.equals(deviceDetector.browser, 'firefox')) {
        // Se necesita retrasar 2 segundos la carga del contenido para que Angular en Firefox
        // detecte las capas con "scroll" mediante el evento 'tcqiAppLoaded'.
        miliseconds = 2000;
      }

      vm.loaded = false;
      $scope.$on('$viewContentLoaded', function(ev, data){
        $timeout(function() {
          vm.loaded = true;
          $rootScope.$broadcast('tcqiAppLoaded');
        }, miliseconds);
      });
    }
}());

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.constant:app
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio')
    .constant('AdmConstant', {
      'SERVER_PATH_ADMINISTRACIO': 'security/',
      'SERVER_PATH_ADMINISTRACIO_API': 'api/security/',
      'SERVER_ADMINISTRACIO_VERSION' : 'v1'
    });
}());
